export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type Action = {
  __typename?: 'Action';
  actionName: ActionName;
  classification: Scalars['String'];
  commandJsons: Array<Scalars['String']>;
  commandPreviews: Array<Scalars['String']>;
  commandTypes: Array<CommandType>;
  hasArchiveCommand: Scalars['Boolean'];
  hasSnoozeCommand: Scalars['Boolean'];
  llmAction?: Maybe<Scalars['Boolean']>;
  logSummary: Scalars['String'];
  preview: Scalars['String'];
  sendQueue: SendQueue;
  uuid?: Maybe<Scalars['String']>;
};

export type ActionInput = {
  actionName: ActionName;
  commandJsons: Array<Scalars['String']>;
  editedBody?: InputMaybe<Scalars['String']>;
  llmAction?: InputMaybe<Scalars['Boolean']>;
  logSummary?: InputMaybe<Scalars['String']>;
  replyToMessageId?: InputMaybe<Scalars['Int']>;
  sendNow?: InputMaybe<Scalars['Boolean']>;
  uuid?: InputMaybe<Scalars['String']>;
};

export enum ActionName {
  ACCEPT_CAL_INVITE = 'ACCEPT_CAL_INVITE',
  ACCEPT_SHOW = 'ACCEPT_SHOW',
  ACK_ACCEPT_SHOW = 'ACK_ACCEPT_SHOW',
  ACK_ADDITIONAL_OCCUPANTS = 'ACK_ADDITIONAL_OCCUPANTS',
  ACK_CONFIRM_SHOW = 'ACK_CONFIRM_SHOW',
  ACK_FEEDBACK = 'ACK_FEEDBACK',
  ACK_GRATITUDE = 'ACK_GRATITUDE',
  ACK_MAYBE_QUALIFY = 'ACK_MAYBE_QUALIFY',
  ACK_MOVE_IN_DATE = 'ACK_MOVE_IN_DATE',
  ACK_NEGATIVE_FEEDBACK = 'ACK_NEGATIVE_FEEDBACK',
  ACK_NOT_INTERESTED = 'ACK_NOT_INTERESTED',
  ACK_NOT_QUALIFY = 'ACK_NOT_QUALIFY',
  ACK_POSITIVE_FEEDBACK = 'ACK_POSITIVE_FEEDBACK',
  ACK_QUALIFY = 'ACK_QUALIFY',
  ADD_AGENT = 'ADD_AGENT',
  AGENT_REJECT_SHOWING = 'AGENT_REJECT_SHOWING',
  AGENT_RUNNING_LATE = 'AGENT_RUNNING_LATE',
  ANSWER_ADDRESS = 'ANSWER_ADDRESS',
  ANSWER_AMENITIES = 'ANSWER_AMENITIES',
  ANSWER_APPLICATION_DOCS = 'ANSWER_APPLICATION_DOCS',
  ANSWER_APPLICATION_LINK = 'ANSWER_APPLICATION_LINK',
  ANSWER_APPLICATION_STATUS = 'ANSWER_APPLICATION_STATUS',
  ANSWER_AVAILABLE_ON = 'ANSWER_AVAILABLE_ON',
  ANSWER_CANT_CALL = 'ANSWER_CANT_CALL',
  ANSWER_CAN_I_WALK_IN = 'ANSWER_CAN_I_WALK_IN',
  ANSWER_COSIGNER_POLICY = 'ANSWER_COSIGNER_POLICY',
  ANSWER_DEFINE_TOUR_TYPE_IN_PERSON = 'ANSWER_DEFINE_TOUR_TYPE_IN_PERSON',
  ANSWER_DEFINE_TOUR_TYPE_SELF_GUIDED = 'ANSWER_DEFINE_TOUR_TYPE_SELF_GUIDED',
  ANSWER_DEFINE_TOUR_TYPE_VIRTUAL = 'ANSWER_DEFINE_TOUR_TYPE_VIRTUAL',
  ANSWER_DISCOUNTS = 'ANSWER_DISCOUNTS',
  ANSWER_FAIR_HOUSING = 'ANSWER_FAIR_HOUSING',
  ANSWER_FEATURE_REQUEST = 'ANSWER_FEATURE_REQUEST',
  ANSWER_FLOOR_PLAN_LINK = 'ANSWER_FLOOR_PLAN_LINK',
  ANSWER_FURNISHED = 'ANSWER_FURNISHED',
  ANSWER_FUTURE_AVAILABILITY = 'ANSWER_FUTURE_AVAILABILITY',
  ANSWER_HANDICAPPED_UNITS = 'ANSWER_HANDICAPPED_UNITS',
  ANSWER_HOW_TO_ACCEPT_INVITE = 'ANSWER_HOW_TO_ACCEPT_INVITE',
  ANSWER_HOW_TO_ACCEPT_SHOWING_FROM_CALENDAR = 'ANSWER_HOW_TO_ACCEPT_SHOWING_FROM_CALENDAR',
  ANSWER_HOW_TO_BLOCK_YOUR_CALENDAR = 'ANSWER_HOW_TO_BLOCK_YOUR_CALENDAR',
  ANSWER_HOW_TO_START_VIRTUAL_TOUR = 'ANSWER_HOW_TO_START_VIRTUAL_TOUR',
  ANSWER_HOW_TO_UNBLOCK_YOUR_CALENDAR = 'ANSWER_HOW_TO_UNBLOCK_YOUR_CALENDAR',
  ANSWER_HOW_TO_VIEW_SHOWING_DETAILS = 'ANSWER_HOW_TO_VIEW_SHOWING_DETAILS',
  ANSWER_LAUNDRY = 'ANSWER_LAUNDRY',
  ANSWER_LEASE_TERMS = 'ANSWER_LEASE_TERMS',
  ANSWER_LEASING_SPECIALS = 'ANSWER_LEASING_SPECIALS',
  ANSWER_LISTINGS = 'ANSWER_LISTINGS',
  ANSWER_MOVE_IN_COST = 'ANSWER_MOVE_IN_COST',
  ANSWER_NOT_A_BOT = 'ANSWER_NOT_A_BOT',
  ANSWER_OFFICE_PHONE = 'ANSWER_OFFICE_PHONE',
  ANSWER_PARKING = 'ANSWER_PARKING',
  ANSWER_PET_POLICY = 'ANSWER_PET_POLICY',
  ANSWER_QUALIFICATIONS = 'ANSWER_QUALIFICATIONS',
  ANSWER_REALTOR = 'ANSWER_REALTOR',
  ANSWER_REDIRECT_TO_AGENT = 'ANSWER_REDIRECT_TO_AGENT',
  ANSWER_RENT = 'ANSWER_RENT',
  ANSWER_RESIDENT = 'ANSWER_RESIDENT',
  ANSWER_SCHOOLS_NEARBY = 'ANSWER_SCHOOLS_NEARBY',
  ANSWER_SECTION8 = 'ANSWER_SECTION8',
  ANSWER_SERVICE_ANIMAL = 'ANSWER_SERVICE_ANIMAL',
  ANSWER_SHOWING_DURATION = 'ANSWER_SHOWING_DURATION',
  ANSWER_SHOWING_HOURS = 'ANSWER_SHOWING_HOURS',
  ANSWER_SQFT = 'ANSWER_SQFT',
  ANSWER_TOUR_TYPES_OFFERED = 'ANSWER_TOUR_TYPES_OFFERED',
  ANSWER_UNIT_UNAVAILABLE = 'ANSWER_UNIT_UNAVAILABLE',
  ANSWER_UTILITIES = 'ANSWER_UTILITIES',
  ANSWER_WHATS_YOUR_EMAIL = 'ANSWER_WHATS_YOUR_EMAIL',
  ANSWER_WHATS_YOUR_LAST_NAME = 'ANSWER_WHATS_YOUR_LAST_NAME',
  ANSWER_WHATS_YOUR_NAME = 'ANSWER_WHATS_YOUR_NAME',
  ANSWER_WHATS_YOUR_NUMBER = 'ANSWER_WHATS_YOUR_NUMBER',
  ANSWER_WHY_PHOTO_ID = 'ANSWER_WHY_PHOTO_ID',
  ANY_OTHER_QUESTIONS = 'ANY_OTHER_QUESTIONS',
  APPLICATION_STATUS_UPDATE = 'APPLICATION_STATUS_UPDATE',
  ARCHIVE = 'ARCHIVE',
  ASK_ADDITIONAL_OCCUPANTS = 'ASK_ADDITIONAL_OCCUPANTS',
  ASK_NAME = 'ASK_NAME',
  ASK_QUALIFY = 'ASK_QUALIFY',
  ASK_QUALIFY_FOLLOWUP = 'ASK_QUALIFY_FOLLOWUP',
  ASK_TOUR_TYPE = 'ASK_TOUR_TYPE',
  ASK_UNIT_TYPE = 'ASK_UNIT_TYPE',
  ASK_WANT_HELP = 'ASK_WANT_HELP',
  ASK_WANT_TO_RESCHEDULE = 'ASK_WANT_TO_RESCHEDULE',
  ASK_WANT_TO_SCHEDULE = 'ASK_WANT_TO_SCHEDULE',
  ASK_WORK_FOR_YOU = 'ASK_WORK_FOR_YOU',
  BLOCK_CALENDAR = 'BLOCK_CALENDAR',
  CANCEL_PROSPECT_SHOWINGS = 'CANCEL_PROSPECT_SHOWINGS',
  CANCEL_SHOW = 'CANCEL_SHOW',
  CREATE_NOTE = 'CREATE_NOTE',
  CREATE_VIRTUAL_TOUR_LINK = 'CREATE_VIRTUAL_TOUR_LINK',
  CROSS_SELL = 'CROSS_SELL',
  CROSS_SELL_UNIT_TYPE = 'CROSS_SELL_UNIT_TYPE',
  DECLINE_CAL_INVITE = 'DECLINE_CAL_INVITE',
  DELAY_SHOW = 'DELAY_SHOW',
  DISABLE_FEATURE_FLAG = 'DISABLE_FEATURE_FLAG',
  DISQUALIFY_SHOW = 'DISQUALIFY_SHOW',
  EDIT_AGENT_HOURS_OR_PRECEDENCE = 'EDIT_AGENT_HOURS_OR_PRECEDENCE',
  EMERGENCY = 'EMERGENCY',
  ENABLE_FEATURE_FLAG = 'ENABLE_FEATURE_FLAG',
  FIRE_AGENT = 'FIRE_AGENT',
  FIX_PM = 'FIX_PM',
  FLAG_PROBLEM_AGENT = 'FLAG_PROBLEM_AGENT',
  FOLLOW_UP = 'FOLLOW_UP',
  GET_AGENT_VIRTUAL_TOUR_LINK = 'GET_AGENT_VIRTUAL_TOUR_LINK',
  GOODBYE = 'GOODBYE',
  HOLIDAY_OFFICE_HOURS = 'HOLIDAY_OFFICE_HOURS',
  LEGACY = 'LEGACY',
  LIST_AGENTS = 'LIST_AGENTS',
  LIST_ALL_CONTACTS = 'LIST_ALL_CONTACTS',
  LIST_CALENDAR_BLOCKS = 'LIST_CALENDAR_BLOCKS',
  LIST_FIRM_ERRORS = 'LIST_FIRM_ERRORS',
  LIST_HOLIDAYS = 'LIST_HOLIDAYS',
  LIST_POLICY = 'LIST_POLICY',
  LIST_SHOWINGS = 'LIST_SHOWINGS',
  LIST_UNITS = 'LIST_UNITS',
  MARK_CONVO_TYPE = 'MARK_CONVO_TYPE',
  MARK_DID_SHOW = 'MARK_DID_SHOW',
  MARK_HUMAN_FALLBACK = 'MARK_HUMAN_FALLBACK',
  MARK_NO_SHOW = 'MARK_NO_SHOW',
  MAX_FOLLOWUPS_REACHED = 'MAX_FOLLOWUPS_REACHED',
  NOT_A_BOT = 'NOT_A_BOT',
  OFFBOARD_PROPERTY = 'OFFBOARD_PROPERTY',
  OFFBOARD_SCHEDULED_PROSPECT = 'OFFBOARD_SCHEDULED_PROSPECT',
  OFFER_SHOW = 'OFFER_SHOW',
  OFFER_SOONEST_SHOW = 'OFFER_SOONEST_SHOW',
  ONBOARDING_INTRO_BUILDING = 'ONBOARDING_INTRO_BUILDING',
  ONBOARDING_IT_PROVISION_EMAIL = 'ONBOARDING_IT_PROVISION_EMAIL',
  ONBOARDING_IT_PROVISION_PM_ACCOUNT = 'ONBOARDING_IT_PROVISION_PM_ACCOUNT',
  ONBOARDING_IT_TURN_ON_AUDIT = 'ONBOARDING_IT_TURN_ON_AUDIT',
  ONBOARDING_MARKETING_CONFIRM_DATE = 'ONBOARDING_MARKETING_CONFIRM_DATE',
  ONBOARDING_MARKETING_CONFIRM_SOURCES = 'ONBOARDING_MARKETING_CONFIRM_SOURCES',
  ONBOARDING_MARKETING_SWITCH_NOW = 'ONBOARDING_MARKETING_SWITCH_NOW',
  ONBOARDING_OPS_BOOK_LISA_TRAINING = 'ONBOARDING_OPS_BOOK_LISA_TRAINING',
  ONBOARDING_OPS_PROPERTY_INFO = 'ONBOARDING_OPS_PROPERTY_INFO',
  OPERATOR_REMIND_TARDY = 'OPERATOR_REMIND_TARDY',
  OTHER_LINE = 'OTHER_LINE',
  OUTSIDE_SCHEDULING = 'OUTSIDE_SCHEDULING',
  OUTSIDE_SCHEDULING_UNDO = 'OUTSIDE_SCHEDULING_UNDO',
  PARSE_UNPARSED_LEAD = 'PARSE_UNPARSED_LEAD',
  PROSPECT_RUNNING_LATE = 'PROSPECT_RUNNING_LATE',
  PROVIDE_FLOOR_PLAN_RENT = 'PROVIDE_FLOOR_PLAN_RENT',
  QUALIFY_PROSPECT = 'QUALIFY_PROSPECT',
  REACH_OUT_TO_PROSPECT = 'REACH_OUT_TO_PROSPECT',
  REACTIVATE_PROSPECT = 'REACTIVATE_PROSPECT',
  REASSIGN_SHOWING = 'REASSIGN_SHOWING',
  RECLASSIFY_INTENT = 'RECLASSIFY_INTENT',
  REMIND_AGENT_STEP_IN = 'REMIND_AGENT_STEP_IN',
  REMIND_APPOINTMENT = 'REMIND_APPOINTMENT',
  REMIND_PROSPECT_APPLICATION = 'REMIND_PROSPECT_APPLICATION',
  REMIND_PROSPECT_VIRTUAL_TOUR = 'REMIND_PROSPECT_VIRTUAL_TOUR',
  REPLACE_TASK_AGENT = 'REPLACE_TASK_AGENT',
  REQUEST_NAME = 'REQUEST_NAME',
  REQUEST_PHOTO_ID = 'REQUEST_PHOTO_ID',
  REQUEST_TASK_UPDATE = 'REQUEST_TASK_UPDATE',
  REQUEST_VOICE_CALL = 'REQUEST_VOICE_CALL',
  RESCHEDULE_SHOW = 'RESCHEDULE_SHOW',
  RESEND_CAL_INVITE = 'RESEND_CAL_INVITE',
  RESPOND_APPLICATION = 'RESPOND_APPLICATION',
  RETRY_ASK_CONFIRM_SHOW = 'RETRY_ASK_CONFIRM_SHOW',
  RUNNING_LATE = 'RUNNING_LATE',
  SAY_NOT_SHOWABLE = 'SAY_NOT_SHOWABLE',
  SCHEDULING_AGENT_ASK = 'SCHEDULING_AGENT_ASK',
  SEARCH_NOTES = 'SEARCH_NOTES',
  SEND_AGENT_STEP_IN = 'SEND_AGENT_STEP_IN',
  SEND_API_DOCS = 'SEND_API_DOCS',
  SEND_CALENDAR_LINK = 'SEND_CALENDAR_LINK',
  SEND_EVENING_FEEDBACK = 'SEND_EVENING_FEEDBACK',
  SEND_FRIDAY_FUNNEL = 'SEND_FRIDAY_FUNNEL',
  SEND_HUMAN = 'SEND_HUMAN',
  SEND_MORNING_REPORT = 'SEND_MORNING_REPORT',
  SEND_NPS_SURVEY = 'SEND_NPS_SURVEY',
  SEND_ONBOARDING_CHECKLIST = 'SEND_ONBOARDING_CHECKLIST',
  SEND_SHOWING_CODE = 'SEND_SHOWING_CODE',
  SET_ADDITIONAL_OCCUPANTS = 'SET_ADDITIONAL_OCCUPANTS',
  SET_MOVE_IN_DATE = 'SET_MOVE_IN_DATE',
  SET_PREFERRED_MESSAGE_TYPE = 'SET_PREFERRED_MESSAGE_TYPE',
  SET_SETTING = 'SET_SETTING',
  SHOWING_HISTORY = 'SHOWING_HISTORY',
  SNOOZE_THREAD = 'SNOOZE_THREAD',
  START_BOT = 'START_BOT',
  STOP_BOT = 'STOP_BOT',
  STOP_SHOWINGS_FOR_UNIT_TYPE = 'STOP_SHOWINGS_FOR_UNIT_TYPE',
  SUPPORT_REQUEST = 'SUPPORT_REQUEST',
  TAG_EVENING_FEEDBACK = 'TAG_EVENING_FEEDBACK',
  THANKS_FOR_TIME = 'THANKS_FOR_TIME',
  TOUR_INSTRUCTIONS = 'TOUR_INSTRUCTIONS',
  UNARCHIVE = 'UNARCHIVE',
  UNDO_AGENT_STEP_IN = 'UNDO_AGENT_STEP_IN',
  UNSUBSCRIBE_THREAD = 'UNSUBSCRIBE_THREAD',
  UPDATE_CONTACT_INFO = 'UPDATE_CONTACT_INFO',
  UPDATE_CONTACT_LANGUAGE = 'UPDATE_CONTACT_LANGUAGE',
  UPDATE_FIRM = 'UPDATE_FIRM',
  UPDATE_SHOWING_STATUS = 'UPDATE_SHOWING_STATUS',
  UPDATE_TASK_AGENT = 'UPDATE_TASK_AGENT',
  UPDATE_TASK_INFO = 'UPDATE_TASK_INFO',
  UPDATE_THREAD = 'UPDATE_THREAD',
  VIRTUAL_TOURS = 'VIRTUAL_TOURS'
}

export type Address = {
  __typename?: 'Address';
  addressParts: AddressParts;
  geolocation: Geolocation;
  id: Scalars['Int'];
  today: Scalars['String'];
};

export type AddressParts = {
  __typename?: 'AddressParts';
  city: Scalars['String'];
  state: Scalars['String'];
  street: Scalars['String'];
  zipcode: Scalars['String'];
};

export type AgentCalendar = {
  __typename?: 'AgentCalendar';
  calEvents: Array<CalEvent>;
  contact: Contact;
  date: Scalars['String'];
  endOfDay: Scalars['String'];
  isToday: Scalars['Boolean'];
  offHours: Array<Range>;
  showings: Array<Showing>;
  startOfDay: Scalars['String'];
  timeZone: Scalars['String'];
  workHours: Array<Range>;
};

export type AgentVirtualTour = {
  __typename?: 'AgentVirtualTour';
  calendarLink: Scalars['String'];
  contact: Contact;
  dailyCallOptions?: Maybe<DailyCallOptions>;
  showing?: Maybe<Showing>;
};

export type ApmInfo = {
  __typename?: 'ApmInfo';
  additionalVhosts: Array<Scalars['String']>;
  pmFirm: Scalars['String'];
  pmType: Scalars['String'];
  showingsNotifyTenant: Scalars['Boolean'];
};

export type ApmInfoInput = {
  additionalVhosts?: InputMaybe<Array<Scalars['String']>>;
  pmFirm?: InputMaybe<Scalars['String']>;
  pmType?: InputMaybe<Scalars['String']>;
  showingsNotifyTenant?: InputMaybe<Scalars['Boolean']>;
};

export type Attendee = {
  __typename?: 'Attendee';
  calId: Scalars['String'];
  responseStatus: CalResponseStatus;
};

export type BasicPmInfo = {
  __typename?: 'BasicPmInfo';
  pmFirm: Scalars['String'];
  pmType: Scalars['String'];
};

export type BasicPmInfoInput = {
  pmFirm?: InputMaybe<Scalars['String']>;
  pmType?: InputMaybe<Scalars['String']>;
};

export type BotActionValidationError = {
  __typename?: 'BotActionValidationError';
  canBeRerunInCC: Scalars['Boolean'];
  errorDescription: Scalars['String'];
  validationType: BotActionValidationType;
};

export enum BotActionValidationType {
  ALLOWED_ACTION_VALIDATION = 'ALLOWED_ACTION_VALIDATION',
  MASS_CANCELLATION_VALIDATION = 'MASS_CANCELLATION_VALIDATION',
  MESSAGE_BODY_VALIDATION = 'MESSAGE_BODY_VALIDATION',
  TEST_VALIDATION = 'TEST_VALIDATION',
  THREAD_ACTIVITY_VALIDATION = 'THREAD_ACTIVITY_VALIDATION',
  UNSUBSCRIBED_THREAD_VALIDATION = 'UNSUBSCRIBED_THREAD_VALIDATION'
}

export type BotThread = {
  __typename?: 'BotThread';
  action?: Maybe<Action>;
  actionMessageType?: Maybe<MessageType>;
  contact: Contact;
  contactId: Scalars['Int'];
  sendTime?: Maybe<Scalars['String']>;
  showCountdown: Scalars['Boolean'];
  task: LeasingTask;
  taskId: Scalars['Int'];
};

export enum BulkUpdateOp {
  AGENT = 'AGENT',
  LAUNCH_DATE = 'LAUNCH_DATE',
  LEASING_ATTRIBUTION_SOURCE = 'LEASING_ATTRIBUTION_SOURCE',
  LEASING_SPECIAL = 'LEASING_SPECIAL',
  OFFBOARD_DATE = 'OFFBOARD_DATE',
  POLICIES = 'POLICIES',
  VIRTUAL_TOURS_ONLY = 'VIRTUAL_TOURS_ONLY'
}

export type Cal = {
  __typename?: 'Cal';
  id: Scalars['String'];
  timeLastAccess?: Maybe<Scalars['String']>;
  upcomingCalEvents: Array<CalEvent>;
};


export type CalUpcomingCalEventsArgs = {
  limit: Scalars['Int'];
};

export type CalEvent = {
  __typename?: 'CalEvent';
  attendees: Array<Attendee>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  location?: Maybe<Scalars['String']>;
  showingId?: Maybe<Scalars['Int']>;
  source?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  timeCreated: Scalars['String'];
  timeEnd: Scalars['String'];
  timeStart: Scalars['String'];
};

export enum CalResponseStatus {
  ACCEPTED = 'ACCEPTED',
  DECLINED = 'DECLINED',
  NEEDS_ACTION = 'NEEDS_ACTION',
  TENTATIVE = 'TENTATIVE',
  UNKNOWN = 'UNKNOWN'
}

export enum CalSource {
  APM = 'APM',
  EXCHANGE = 'EXCHANGE',
  GOOGLE = 'GOOGLE'
}

export type CalView = {
  __typename?: 'CalView';
  blocks: Array<CalViewBlock>;
  tzName: Scalars['String'];
};

export type CalViewBlock = {
  __typename?: 'CalViewBlock';
  calEvent?: Maybe<CalEvent>;
  calRespStatus?: Maybe<CalResponseStatus>;
  dispDate: Scalars['String'];
  dispTime: Scalars['String'];
  id: Scalars['String'];
  showing?: Maybe<Showing>;
  showingConfStatus?: Maybe<ConfirmationStatus>;
  snippet: Scalars['String'];
  type: CalViewBlockType;
};

export enum CalViewBlockType {
  EXTERNAL_CAL_EVENT = 'EXTERNAL_CAL_EVENT',
  NOW = 'NOW',
  SHOWING = 'SHOWING',
  SHOWING_SLOT = 'SHOWING_SLOT'
}

export enum CommandType {
  CALENDAR = 'CALENDAR',
  CREATE_ENDPOINT = 'CREATE_ENDPOINT',
  CREATE_NOTE = 'CREATE_NOTE',
  CREATE_OR_UPDATE_TASK_AGENT = 'CREATE_OR_UPDATE_TASK_AGENT',
  CREATE_SUPPORT_CASE = 'CREATE_SUPPORT_CASE',
  CREATE_THREAD = 'CREATE_THREAD',
  DELETE_TASK_AGENT = 'DELETE_TASK_AGENT',
  DISABLE_FEATURE_FLAG = 'DISABLE_FEATURE_FLAG',
  ENABLE_FEATURE_FLAG = 'ENABLE_FEATURE_FLAG',
  GENERATE_VIRTUAL_TOUR_LINK = 'GENERATE_VIRTUAL_TOUR_LINK',
  HUMAN_FALLBACK = 'HUMAN_FALLBACK',
  NOTIFY_TASK_AGENTS = 'NOTIFY_TASK_AGENTS',
  PARSE_UNPARSED_LEAD = 'PARSE_UNPARSED_LEAD',
  REASSIGN_SHOWING = 'REASSIGN_SHOWING',
  SCHEDULE_SHOWING = 'SCHEDULE_SHOWING',
  SEND_MESSAGE = 'SEND_MESSAGE',
  SEND_MESSAGE_TO_OTHER_THREAD = 'SEND_MESSAGE_TO_OTHER_THREAD',
  SEND_SLACK_MESSAGE = 'SEND_SLACK_MESSAGE',
  SEND_TEMPLATED_EMAIL = 'SEND_TEMPLATED_EMAIL',
  SET_SETTING = 'SET_SETTING',
  TAG_FEEDBACK = 'TAG_FEEDBACK',
  UPDATE_CONFIRMATION_STATUS = 'UPDATE_CONFIRMATION_STATUS',
  UPDATE_CONTACT = 'UPDATE_CONTACT',
  UPDATE_FIRM = 'UPDATE_FIRM',
  UPDATE_PM_SYSTEM = 'UPDATE_PM_SYSTEM',
  UPDATE_SHOWING = 'UPDATE_SHOWING',
  UPDATE_SMARTRENT_CODE = 'UPDATE_SMARTRENT_CODE',
  UPDATE_TASK = 'UPDATE_TASK',
  UPDATE_TASK_AGENT = 'UPDATE_TASK_AGENT',
  UPDATE_THREAD = 'UPDATE_THREAD'
}

export enum ConfirmationStatus {
  ACCEPTED = 'ACCEPTED',
  AVAIL = 'AVAIL',
  CANCEL_BY_THEM = 'CANCEL_BY_THEM',
  CANCEL_BY_THEM_NOSYNC = 'CANCEL_BY_THEM_NOSYNC',
  CANCEL_BY_US = 'CANCEL_BY_US',
  CONFIRMED = 'CONFIRMED',
  CONFIRMED_NOSYNC = 'CONFIRMED_NOSYNC',
  CONFIRM_SENT = 'CONFIRM_SENT',
  DISQUALIFIED = 'DISQUALIFIED',
  NOT_AVAIL = 'NOT_AVAIL',
  NO_SHOW = 'NO_SHOW',
  OFFERED = 'OFFERED',
  REJECTED = 'REJECTED'
}

export type Contact = {
  __typename?: 'Contact';
  addressEmail?: Maybe<Scalars['String']>;
  addressPhone?: Maybe<Scalars['String']>;
  customAgentNamePhone?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  language?: Maybe<Language>;
  lastName?: Maybe<Scalars['String']>;
  preferMessageType: MessageType;
  recentActions: Array<SavedAction>;
  showings: Array<Showing>;
  tasks: Array<LeasingTask>;
  threads: Array<Thread>;
  timeCreated: Scalars['String'];
  workHours: Scalars['String'];
};


export type ContactRecentActionsArgs = {
  limit: Scalars['Int'];
};


export type ContactShowingsArgs = {
  taskId?: InputMaybe<Scalars['Int']>;
};


export type ContactThreadsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

export type ContactInput = {
  addressEmail?: InputMaybe<Scalars['String']>;
  addressPhone?: InputMaybe<Scalars['String']>;
  customAgentNamePhone?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  language?: InputMaybe<Language>;
  lastName?: InputMaybe<Scalars['String']>;
  preferMessageType?: InputMaybe<MessageType>;
  workHours?: InputMaybe<Scalars['String']>;
};

export enum ConversationType {
  AGENT = 'AGENT',
  BOSS = 'BOSS',
  INVESTOR = 'INVESTOR',
  OPERATOR = 'OPERATOR',
  OTHER = 'OTHER',
  PROSPECT = 'PROSPECT',
  RESIDENT = 'RESIDENT',
  UNPARSED = 'UNPARSED'
}

export type DailyCallOptions = {
  __typename?: 'DailyCallOptions';
  token: Scalars['String'];
  url: Scalars['String'];
};

export type Endpoint = {
  __typename?: 'Endpoint';
  addr?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  lastInboundMessageId?: Maybe<Scalars['Int']>;
  lastInboundTimestamp?: Maybe<Scalars['String']>;
  lastOutboundMessageId?: Maybe<Scalars['Int']>;
  lastOutboundTimestamp?: Maybe<Scalars['String']>;
  leasingAttributionSource: LeasingAttributionSource;
  listingStatus?: Maybe<ListingStatus>;
  listingStatusLastUpdatedTimestamp?: Maybe<Scalars['String']>;
  listingUrl?: Maybe<Scalars['String']>;
  releasedAddr?: Maybe<Scalars['String']>;
};

export type EntrataInfo = {
  __typename?: 'EntrataInfo';
  password: Scalars['String'];
  pmFirm: Scalars['String'];
  pmType: Scalars['String'];
  username: Scalars['String'];
};

export type EntrataInfoInput = {
  password?: InputMaybe<Scalars['String']>;
  pmFirm?: InputMaybe<Scalars['String']>;
  pmType?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export type ErrorState = {
  __typename?: 'ErrorState';
  body: Scalars['String'];
  errorKey: Scalars['String'];
  firm: Firm;
  id: Scalars['Int'];
  modelId: Scalars['Int'];
  modelType: Scalars['String'];
  task: LeasingTask;
  timeCreated: Scalars['String'];
};

export type ExchangeCreds = {
  __typename?: 'ExchangeCreds';
  email: Scalars['String'];
  ewsUrl: Scalars['String'];
  password?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

export type ExchangeCredsInput = {
  email?: InputMaybe<Scalars['String']>;
  ewsUrl?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  userName?: InputMaybe<Scalars['String']>;
};

export type ExternalUserInput = {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  description: Scalars['String'];
  enabled: Scalars['Boolean'];
  featureName: FeatureName;
  firmId: Scalars['Int'];
};

export enum FeatureName {
  APM_IS_SOURCE_OF_TRUTH_FOR_POLICIES = 'APM_IS_SOURCE_OF_TRUTH_FOR_POLICIES',
  APPROVED_APPS_RELIEF_VALVE = 'APPROVED_APPS_RELIEF_VALVE',
  BYPASS_SMALL_PROPERTY_SHOWING_RESTRICTION = 'BYPASS_SMALL_PROPERTY_SHOWING_RESTRICTION',
  CLOSE_COLD_LEADS = 'CLOSE_COLD_LEADS',
  DAILY_CO_VIRTUAL_TOURS = 'DAILY_CO_VIRTUAL_TOURS',
  QUALIFY_MESSAGE_FOLLOWUP = 'QUALIFY_MESSAGE_FOLLOWUP',
  REQUEST_MOVE_IN_DATE = 'REQUEST_MOVE_IN_DATE',
  REQUEST_OCCUPANTS_COUNT = 'REQUEST_OCCUPANTS_COUNT',
  RETRY_REACTIVATION = 'RETRY_REACTIVATION',
  SELF_GUIDED_REMINDER_FOR_AGENTS = 'SELF_GUIDED_REMINDER_FOR_AGENTS',
  SMARTRENT_SELF_GUIDED_TOURS = 'SMARTRENT_SELF_GUIDED_TOURS',
  TRANSCRIPT_CHARACTER_ENCODING = 'TRANSCRIPT_CHARACTER_ENCODING',
  TRANSCRIPT_HIDE_PHOTO_ID = 'TRANSCRIPT_HIDE_PHOTO_ID',
  TRANSLATE_SPANISH_INBOUND = 'TRANSLATE_SPANISH_INBOUND',
  TRANSLATE_SPANISH_OUTBOUND = 'TRANSLATE_SPANISH_OUTBOUND',
  USE_PHONE_MANAGER_FOR_VOICE = 'USE_PHONE_MANAGER_FOR_VOICE',
  VIRTUAL_TOUR_REMINDER_FOR_AGENTS = 'VIRTUAL_TOUR_REMINDER_FOR_AGENTS'
}

export type Firm = {
  __typename?: 'Firm';
  acceptSection8?: Maybe<Scalars['Boolean']>;
  agentContacts: Array<Contact>;
  apmInfoWithObfuscatedSecrets?: Maybe<ApmInfo>;
  applicationDocsText?: Maybe<Scalars['String']>;
  bossContacts: Array<Contact>;
  config?: Maybe<Scalars['String']>;
  cosignerPolicyText?: Maybe<Scalars['String']>;
  discountsText?: Maybe<Scalars['String']>;
  emailThreadContacts: Array<Contact>;
  englishConversationOnly?: Maybe<Scalars['Boolean']>;
  entrataInfoWithObfuscatedSecrets?: Maybe<EntrataInfo>;
  exchangeCredsWithObfuscatedSecrets?: Maybe<ExchangeCreds>;
  firmName: Scalars['String'];
  firmTask?: Maybe<LeasingTask>;
  firmType: FirmType;
  gSuiteCredsWithObfuscatedSecrets?: Maybe<GSuiteCreds>;
  headsUpText?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  leaseTermsText?: Maybe<Scalars['String']>;
  maxAcceptedPerShowing?: Maybe<Scalars['Int']>;
  moveInCostText?: Maybe<Scalars['String']>;
  msGraphCredsWithObfuscatedSecrets?: Maybe<MsGraphCreds>;
  numUnits: Scalars['Int'];
  officePhone?: Maybe<Scalars['String']>;
  petPolicyText?: Maybe<Scalars['String']>;
  pmKeyJsons: Array<Scalars['String']>;
  pmPropertiesWithoutTasks: Array<PmProperty>;
  pmTypes: Array<Scalars['String']>;
  propertyListingsUrl?: Maybe<Scalars['String']>;
  qualificationText?: Maybe<Scalars['String']>;
  realpageInfoWithObfuscatedSecrets?: Maybe<RealpageInfo>;
  realtorText?: Maybe<Scalars['String']>;
  resmanInfoWithObfuscatedSecrets?: Maybe<BasicPmInfo>;
  section8Text?: Maybe<Scalars['String']>;
  showingDurationMins?: Maybe<Scalars['Int']>;
  showingPolicy?: Maybe<ShowingPolicy>;
  tasks: Array<LeasingTask>;
  timeCreated: Scalars['String'];
  tourTypes: Array<TourType>;
  yardiInfoWithObfuscatedSecrets?: Maybe<YardiInfo>;
};


export type FirmTasksArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  populateArchived?: InputMaybe<Scalars['Boolean']>;
  sortAlphabetically?: InputMaybe<Scalars['Boolean']>;
};

export type FirmInput = {
  acceptSection8?: InputMaybe<Scalars['Boolean']>;
  applicationDocsText?: InputMaybe<Scalars['String']>;
  config?: InputMaybe<Scalars['String']>;
  cosignerPolicyText?: InputMaybe<Scalars['String']>;
  discountsText?: InputMaybe<Scalars['String']>;
  englishConversationOnly?: InputMaybe<Scalars['Boolean']>;
  firmName?: InputMaybe<Scalars['String']>;
  firmType?: InputMaybe<FirmType>;
  id: Scalars['Int'];
  leaseTermsText?: InputMaybe<Scalars['String']>;
  maxAcceptedPerShowing?: InputMaybe<Scalars['Int']>;
  moveInCostText?: InputMaybe<Scalars['String']>;
  officePhone?: InputMaybe<Scalars['String']>;
  petPolicyText?: InputMaybe<Scalars['String']>;
  propertyListingsUrl?: InputMaybe<Scalars['String']>;
  qualificationText?: InputMaybe<Scalars['String']>;
  realtorText?: InputMaybe<Scalars['String']>;
  secrets?: InputMaybe<Scalars['String']>;
  section8Text?: InputMaybe<Scalars['String']>;
  showingDurationMins?: InputMaybe<Scalars['Int']>;
  showingPolicy?: InputMaybe<ShowingPolicy>;
  tourTypes?: InputMaybe<Array<TourType>>;
};

export type FirmServiceStatus = {
  __typename?: 'FirmServiceStatus';
  firm: Firm;
  lastUpdated?: Maybe<Scalars['String']>;
  statusMonitorType: StatusMonitorType;
  warnLevel: WarnLevel;
};

export enum FirmType {
  ADMIN = 'ADMIN',
  DISABLED = 'DISABLED',
  LEASING = 'LEASING'
}

export type FloorPlan = {
  __typename?: 'FloorPlan';
  availableOn?: Maybe<Scalars['String']>;
  bathrooms?: Maybe<Scalars['Float']>;
  bedrooms?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  maxRentUSD?: Maybe<Scalars['Int']>;
  minRentUSD?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  num: Scalars['Int'];
  numShowable: Scalars['Int'];
  showableOn?: Maybe<Scalars['String']>;
  sqft?: Maybe<Scalars['Int']>;
};

export type FloorPlanLink = {
  __typename?: 'FloorPlanLink';
  floorPlan: FloorPlan;
  leasingTask: LeasingTask;
};

export type GSuiteCreds = {
  __typename?: 'GSuiteCreds';
  clientId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  password?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
};

export type GSuiteCredsInput = {
  clientId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  refreshToken?: InputMaybe<Scalars['String']>;
};

export type Geolocation = {
  __typename?: 'Geolocation';
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  tzName: Scalars['String'];
};

export type InquirySummary = {
  __typename?: 'InquirySummary';
  inquiry: Scalars['String'];
  questionsAnswered: Array<MessageQuestion>;
  rentQuoted?: Maybe<Scalars['String']>;
};

export type Job = {
  __typename?: 'Job';
  id: Scalars['String'];
  jobKey: Scalars['String'];
  jobName: JobName;
  jobStatus: JobStatus;
  pmType?: Maybe<Scalars['String']>;
  pmTypeDisplayName?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  timeCreated: Scalars['String'];
  timeFinished?: Maybe<Scalars['String']>;
};

export enum JobName {
  ADMIN_ADD_ENT_ROUTER_ITEMS = 'ADMIN_ADD_ENT_ROUTER_ITEMS',
  ADMIN_ADD_SHIFT = 'ADMIN_ADD_SHIFT',
  ADMIN_BACKFILL_GUEST_CARDS = 'ADMIN_BACKFILL_GUEST_CARDS',
  ADMIN_BACKFILL_GUEST_CARDS_FOR_ALL_FIRMS = 'ADMIN_BACKFILL_GUEST_CARDS_FOR_ALL_FIRMS',
  ADMIN_BALANCE_PODS = 'ADMIN_BALANCE_PODS',
  ADMIN_BALANCE_STATIONS = 'ADMIN_BALANCE_STATIONS',
  ADMIN_BULK_MERGE_TASKS = 'ADMIN_BULK_MERGE_TASKS',
  ADMIN_BULK_UPDATE_CONTACT_PHONE_NUMBER = 'ADMIN_BULK_UPDATE_CONTACT_PHONE_NUMBER',
  ADMIN_BUY_MISSING_ENDPOINTS = 'ADMIN_BUY_MISSING_ENDPOINTS',
  ADMIN_CLEAR_PM_DATA = 'ADMIN_CLEAR_PM_DATA',
  ADMIN_CLEAR_REALPAGE_PM_ITEM_KEYS_FROM_THREADS = 'ADMIN_CLEAR_REALPAGE_PM_ITEM_KEYS_FROM_THREADS',
  ADMIN_COVID_LOCKDOWN_FOR_TASK_IDS = 'ADMIN_COVID_LOCKDOWN_FOR_TASK_IDS',
  ADMIN_CREATE_LOCALHOST_FIRM = 'ADMIN_CREATE_LOCALHOST_FIRM',
  ADMIN_CREATE_NEXT_WEEK_SHIFTS = 'ADMIN_CREATE_NEXT_WEEK_SHIFTS',
  ADMIN_CREATE_REPORTS = 'ADMIN_CREATE_REPORTS',
  ADMIN_CREATE_TEAM = 'ADMIN_CREATE_TEAM',
  ADMIN_DELETE_DUPE_CAL_EVENT = 'ADMIN_DELETE_DUPE_CAL_EVENT',
  ADMIN_FETCH_CALENDARS = 'ADMIN_FETCH_CALENDARS',
  ADMIN_FETCH_SINGLE_CALENDAR = 'ADMIN_FETCH_SINGLE_CALENDAR',
  ADMIN_FORECAST_NEXT_WEEK_SHIFT = 'ADMIN_FORECAST_NEXT_WEEK_SHIFT',
  ADMIN_GALAXY_TRAINING = 'ADMIN_GALAXY_TRAINING',
  ADMIN_GENERATE_AUDIO_URL = 'ADMIN_GENERATE_AUDIO_URL',
  ADMIN_GENERIC = 'ADMIN_GENERIC',
  ADMIN_GET_TASKS_PHONE_TREES = 'ADMIN_GET_TASKS_PHONE_TREES',
  ADMIN_GSUITE_OAUTH = 'ADMIN_GSUITE_OAUTH',
  ADMIN_HASH_GARBAGE_COLLECT = 'ADMIN_HASH_GARBAGE_COLLECT',
  ADMIN_ILS_PARSER_TRAINING = 'ADMIN_ILS_PARSER_TRAINING',
  ADMIN_INGEST_ONBOARDING_SPREADSHEET_AGENTS = 'ADMIN_INGEST_ONBOARDING_SPREADSHEET_AGENTS',
  ADMIN_INGEST_ONBOARDING_SPREADSHEET_PROPERTIES = 'ADMIN_INGEST_ONBOARDING_SPREADSHEET_PROPERTIES',
  ADMIN_LOGOUT_ALL_USERS = 'ADMIN_LOGOUT_ALL_USERS',
  ADMIN_MARKETING_WATCHDOG = 'ADMIN_MARKETING_WATCHDOG',
  ADMIN_MICROSOFT_OAUTH = 'ADMIN_MICROSOFT_OAUTH',
  ADMIN_MIGRATE_AIR_EMAILS = 'ADMIN_MIGRATE_AIR_EMAILS',
  ADMIN_MIGRATE_HASH_VALUES_TO_S3 = 'ADMIN_MIGRATE_HASH_VALUES_TO_S3',
  ADMIN_MIGRATE_HASH_VALUES_TO_S3_V2 = 'ADMIN_MIGRATE_HASH_VALUES_TO_S3_V2',
  ADMIN_MIGRATE_PM_ITEM_KEYS = 'ADMIN_MIGRATE_PM_ITEM_KEYS',
  ADMIN_MIGRATE_TWILIO_NUMBERS = 'ADMIN_MIGRATE_TWILIO_NUMBERS',
  ADMIN_MIGRATE_VHOST = 'ADMIN_MIGRATE_VHOST',
  ADMIN_MSG_VOLUME_TRAINING = 'ADMIN_MSG_VOLUME_TRAINING',
  ADMIN_OPEN_AI = 'ADMIN_OPEN_AI',
  ADMIN_POST_ONE_WEEK_SHIFT_FORECAST_TO_SLACK = 'ADMIN_POST_ONE_WEEK_SHIFT_FORECAST_TO_SLACK',
  ADMIN_REBUILD_REDIS_SEARCH_INDEX = 'ADMIN_REBUILD_REDIS_SEARCH_INDEX',
  ADMIN_REBUILD_SEARCH_INDEX = 'ADMIN_REBUILD_SEARCH_INDEX',
  ADMIN_RECEIVE_EMAIL = 'ADMIN_RECEIVE_EMAIL',
  ADMIN_RECEIVE_ILS_EMAIL = 'ADMIN_RECEIVE_ILS_EMAIL',
  ADMIN_REC_TRAINING = 'ADMIN_REC_TRAINING',
  ADMIN_REFRESH_THREAD_PM_ITEMS = 'ADMIN_REFRESH_THREAD_PM_ITEMS',
  ADMIN_REMOVE_SEARCH_RESULT = 'ADMIN_REMOVE_SEARCH_RESULT',
  ADMIN_REPOST_ALL_LISTABLES = 'ADMIN_REPOST_ALL_LISTABLES',
  ADMIN_RERUN_AUDITS = 'ADMIN_RERUN_AUDITS',
  ADMIN_RERUN_FAILED_BOTACTIONS = 'ADMIN_RERUN_FAILED_BOTACTIONS',
  ADMIN_RESEND_FAILED_MESSAGES = 'ADMIN_RESEND_FAILED_MESSAGES',
  ADMIN_ROTATE_FIRM_TASK_NUMBER = 'ADMIN_ROTATE_FIRM_TASK_NUMBER',
  ADMIN_RUN_OPERATOR_MATCHING_ROUND = 'ADMIN_RUN_OPERATOR_MATCHING_ROUND',
  ADMIN_SAVE_GUESTCARD = 'ADMIN_SAVE_GUESTCARD',
  ADMIN_SEND_ONE_MONTH_SHIFT_FORECAST_TO_AF_EVENT_STREAM = 'ADMIN_SEND_ONE_MONTH_SHIFT_FORECAST_TO_AF_EVENT_STREAM',
  ADMIN_SETUP_APM_TESTING = 'ADMIN_SETUP_APM_TESTING',
  ADMIN_SET_APM_INFO = 'ADMIN_SET_APM_INFO',
  ADMIN_SET_PM_INFO = 'ADMIN_SET_PM_INFO',
  ADMIN_SET_SEARCH_DATA_SOURCE = 'ADMIN_SET_SEARCH_DATA_SOURCE',
  ADMIN_SET_SERVER_TIME = 'ADMIN_SET_SERVER_TIME',
  ADMIN_SET_THREAD_TIME_UPDATED_TO_7_DAYS_OLD = 'ADMIN_SET_THREAD_TIME_UPDATED_TO_7_DAYS_OLD',
  ADMIN_SHOWING_NEGOTIATOR_TRAINING = 'ADMIN_SHOWING_NEGOTIATOR_TRAINING',
  ADMIN_TEST_MASS_CANCELLATIONS = 'ADMIN_TEST_MASS_CANCELLATIONS',
  ADMIN_TIMESERIES_SYNC = 'ADMIN_TIMESERIES_SYNC',
  ADMIN_UPDATE_CONTACT_PHONE_NUMBER = 'ADMIN_UPDATE_CONTACT_PHONE_NUMBER',
  ADMIN_UPDATE_SEARCH_INDEX_FOR_THREADS = 'ADMIN_UPDATE_SEARCH_INDEX_FOR_THREADS',
  ADMIN_WARN_BOSS_TOUR_TYPE_POLICY_CONFLICTS = 'ADMIN_WARN_BOSS_TOUR_TYPE_POLICY_CONFLICTS',
  AMDIN_MIGRATE_HASH_VALUES_TO_S3_PM_ITEMS = 'AMDIN_MIGRATE_HASH_VALUES_TO_S3_PM_ITEMS',
  APPFOLIO_BULK_SYNC = 'APPFOLIO_BULK_SYNC',
  APPFOLIO_SAVE_PROPERTY = 'APPFOLIO_SAVE_PROPERTY',
  APPFOLIO_SAVE_PROSPECT = 'APPFOLIO_SAVE_PROSPECT',
  ENTRATA_API_REQUEST_LEADS = 'ENTRATA_API_REQUEST_LEADS',
  ENTRATA_API_REQUEST_PROPERTIES = 'ENTRATA_API_REQUEST_PROPERTIES',
  ENTRATA_API_REQUEST_PROPERTYUNITS = 'ENTRATA_API_REQUEST_PROPERTYUNITS',
  ENTRATA_GET_FIRM = 'ENTRATA_GET_FIRM',
  ENTRATA_SAVE_PROSPECT = 'ENTRATA_SAVE_PROSPECT',
  POST_UNIT = 'POST_UNIT',
  QA_FIRE_AGENT = 'QA_FIRE_AGENT',
  REALPAGE_API_REQUEST_DELETETASK = 'REALPAGE_API_REQUEST_DELETETASK',
  REALPAGE_API_REQUEST_GETFLOORPLANLIST = 'REALPAGE_API_REQUEST_GETFLOORPLANLIST',
  REALPAGE_API_REQUEST_GETLEASINGAGENTSBYPROPERTY = 'REALPAGE_API_REQUEST_GETLEASINGAGENTSBYPROPERTY',
  REALPAGE_API_REQUEST_GETMARKETINGSOURCESBYPROPERTY = 'REALPAGE_API_REQUEST_GETMARKETINGSOURCESBYPROPERTY',
  REALPAGE_API_REQUEST_GETPICKLISTPROSPECT = 'REALPAGE_API_REQUEST_GETPICKLISTPROSPECT',
  REALPAGE_API_REQUEST_GETRENTMATRIX = 'REALPAGE_API_REQUEST_GETRENTMATRIX',
  REALPAGE_API_REQUEST_GETSITELIST = 'REALPAGE_API_REQUEST_GETSITELIST',
  REALPAGE_API_REQUEST_GETUNITLIST = 'REALPAGE_API_REQUEST_GETUNITLIST',
  REALPAGE_API_REQUEST_GETUNITSBYPROPERTY = 'REALPAGE_API_REQUEST_GETUNITSBYPROPERTY',
  REALPAGE_API_REQUEST_INSERTFOLLOWUP = 'REALPAGE_API_REQUEST_INSERTFOLLOWUP',
  REALPAGE_API_REQUEST_INSERTPROSPECT = 'REALPAGE_API_REQUEST_INSERTPROSPECT',
  REALPAGE_API_REQUEST_PROSPECTSEARCH = 'REALPAGE_API_REQUEST_PROSPECTSEARCH',
  REALPAGE_API_REQUEST_RETRIEVELEASETERMS = 'REALPAGE_API_REQUEST_RETRIEVELEASETERMS',
  REALPAGE_API_REQUEST_UPDATEPROSPECT = 'REALPAGE_API_REQUEST_UPDATEPROSPECT',
  REALPAGE_GET_FIRM = 'REALPAGE_GET_FIRM',
  REALPAGE_SAVE_PROSPECT = 'REALPAGE_SAVE_PROSPECT',
  RESMAN_API_REQUEST_ACCOUNT_GETACCOUNTID = 'RESMAN_API_REQUEST_ACCOUNT_GETACCOUNTID',
  RESMAN_API_REQUEST_ACCOUNT_GETPROPERTIES = 'RESMAN_API_REQUEST_ACCOUNT_GETPROPERTIES',
  RESMAN_API_REQUEST_LEASING_GETEMPLOYEES = 'RESMAN_API_REQUEST_LEASING_GETEMPLOYEES',
  RESMAN_API_REQUEST_LEASING_GETLOSTPROSPECTREASONS = 'RESMAN_API_REQUEST_LEASING_GETLOSTPROSPECTREASONS',
  RESMAN_API_REQUEST_LEASING_GETPROSPECTSOURCES = 'RESMAN_API_REQUEST_LEASING_GETPROSPECTSOURCES',
  RESMAN_API_REQUEST_MITS_GETMARKETING4_0 = 'RESMAN_API_REQUEST_MITS_GETMARKETING4_0',
  RESMAN_API_REQUEST_MITS_POSTLEADMANAGEMENT4_0 = 'RESMAN_API_REQUEST_MITS_POSTLEADMANAGEMENT4_0',
  RESMAN_API_REQUEST_MITS_SEARCHPROSPECTS = 'RESMAN_API_REQUEST_MITS_SEARCHPROSPECTS',
  RESMAN_GET_FIRM = 'RESMAN_GET_FIRM',
  RESMAN_SAVE_PROSPECT = 'RESMAN_SAVE_PROSPECT',
  SAVE_AUDIT = 'SAVE_AUDIT',
  UNPOST_UNIT = 'UNPOST_UNIT',
  YARDI_API_REQUEST_GETILSGUESTCARDCONFIGURATION = 'YARDI_API_REQUEST_GETILSGUESTCARDCONFIGURATION',
  YARDI_API_REQUEST_GETPROPERTYCONFIGURATIONS = 'YARDI_API_REQUEST_GETPROPERTYCONFIGURATIONS',
  YARDI_API_REQUEST_GETVERSIONNUMBER = 'YARDI_API_REQUEST_GETVERSIONNUMBER',
  YARDI_API_REQUEST_GETYARDIAGENTSSOURCESRESULTS_LOGIN = 'YARDI_API_REQUEST_GETYARDIAGENTSSOURCESRESULTS_LOGIN',
  YARDI_API_REQUEST_GETYARDIGUESTACTIVITY_SEARCH = 'YARDI_API_REQUEST_GETYARDIGUESTACTIVITY_SEARCH',
  YARDI_API_REQUEST_IMPORTYARDIGUEST_LOGIN = 'YARDI_API_REQUEST_IMPORTYARDIGUEST_LOGIN',
  YARDI_API_REQUEST_UNITAVAILABILITY_LOGIN = 'YARDI_API_REQUEST_UNITAVAILABILITY_LOGIN',
  YARDI_GET_FIRM = 'YARDI_GET_FIRM',
  YARDI_SAVE_PROSPECT = 'YARDI_SAVE_PROSPECT'
}

export enum JobStatus {
  CANCELLED = 'CANCELLED',
  FAILED = 'FAILED',
  STARTED = 'STARTED',
  SUCCEEDED = 'SUCCEEDED'
}

export enum Language {
  BULGARIAN = 'BULGARIAN',
  CHINESE = 'CHINESE',
  CZECH = 'CZECH',
  DANISH = 'DANISH',
  DUTCH = 'DUTCH',
  ENGLISH = 'ENGLISH',
  ESTONIAN = 'ESTONIAN',
  FINNISH = 'FINNISH',
  FRENCH = 'FRENCH',
  GERMAN = 'GERMAN',
  GREEK = 'GREEK',
  HUNGARIAN = 'HUNGARIAN',
  ITALIAN = 'ITALIAN',
  JAPANESE = 'JAPANESE',
  LATVIAN = 'LATVIAN',
  LITHUANIAN = 'LITHUANIAN',
  POLISH = 'POLISH',
  PORTUGUESE = 'PORTUGUESE',
  ROMANIAN = 'ROMANIAN',
  RUSSIAN = 'RUSSIAN',
  SLOVAK = 'SLOVAK',
  SLOVENIAN = 'SLOVENIAN',
  SPANISH = 'SPANISH',
  SWEDISH = 'SWEDISH'
}

export enum LeasePropertyType {
  CONSTRUCTION = 'CONSTRUCTION',
  MF = 'MF',
  SENIOR = 'SENIOR',
  SFR = 'SFR',
  STUDENT = 'STUDENT'
}

export enum LeasingAttributionSource {
  ABODO_COM = 'ABODO_COM',
  AFFORDABLEHOUSING_COM = 'AFFORDABLEHOUSING_COM',
  AFFORDABLE_HOUSING_HUD_GOV = 'AFFORDABLE_HOUSING_HUD_GOV',
  AFTER_55 = 'AFTER_55',
  AGENCY_FIFTY3 = 'AGENCY_FIFTY3',
  AGENT_REACHOUT_REQUEST = 'AGENT_REACHOUT_REQUEST',
  AHRN_COM = 'AHRN_COM',
  ALN_APARTMENT_DATA = 'ALN_APARTMENT_DATA',
  AMBS_CALL_CENTER = 'AMBS_CALL_CENTER',
  APARTAMENTOS_COM = 'APARTAMENTOS_COM',
  APARTMENTS_247 = 'APARTMENTS_247',
  APARTMENTS_COM = 'APARTMENTS_COM',
  APARTMENT_FINDER = 'APARTMENT_FINDER',
  APARTMENT_GUIDE = 'APARTMENT_GUIDE',
  APARTMENT_GUIDE_EMAIL_BLAST = 'APARTMENT_GUIDE_EMAIL_BLAST',
  APARTMENT_HOME_LIVING = 'APARTMENT_HOME_LIVING',
  APARTMENT_LIST = 'APARTMENT_LIST',
  APARTMENT_MAGZ = 'APARTMENT_MAGZ',
  APARTMENT_RATINGS = 'APARTMENT_RATINGS',
  APARTMENT_SEARCH_COM = 'APARTMENT_SEARCH_COM',
  APPLE_MAPS = 'APPLE_MAPS',
  ARTCENTER_EDU = 'ARTCENTER_EDU',
  ASK_COM = 'ASK_COM',
  ATL_APT_MAG_COM = 'ATL_APT_MAG_COM',
  A_PLACE_FOR_MOM = 'A_PLACE_FOR_MOM',
  BENSON_BANNER = 'BENSON_BANNER',
  BING = 'BING',
  BIRDEYE = 'BIRDEYE',
  BRIDGEW_EDU = 'BRIDGEW_EDU',
  B_CHANNEL = 'B_CHANNEL',
  CAL_RENTALS = 'CAL_RENTALS',
  CARE_PATROL = 'CARE_PATROL',
  CHAMBER_OF_COMMERCE = 'CHAMBER_OF_COMMERCE',
  CHATBOT_30_LINES = 'CHATBOT_30_LINES',
  CHATBOT_RESPAGE = 'CHATBOT_RESPAGE',
  CHATTANOOGA_APARTMENT_GUIDE = 'CHATTANOOGA_APARTMENT_GUIDE',
  CHOOZLE = 'CHOOZLE',
  CLICK_TO_CALL = 'CLICK_TO_CALL',
  COLLEGE_RENTALS_COM = 'COLLEGE_RENTALS_COM',
  CORPORATE_WEBSITE = 'CORPORATE_WEBSITE',
  CRAIGSLIST = 'CRAIGSLIST',
  CROSS_SELL = 'CROSS_SELL',
  CUMBERLAND_MALL_ADVERTISEMENT = 'CUMBERLAND_MALL_ADVERTISEMENT',
  DAILY_NORTHWESTERN = 'DAILY_NORTHWESTERN',
  DENVER_RELOCATION_GUIDE = 'DENVER_RELOCATION_GUIDE',
  DIGIBLE_NATIVE_ADS = 'DIGIBLE_NATIVE_ADS',
  DOMU = 'DOMU',
  DOORSTEPS_COM = 'DOORSTEPS_COM',
  DUPONT_REGISTRY_MAGAZINE = 'DUPONT_REGISTRY_MAGAZINE',
  DWELLSY = 'DWELLSY',
  EMAIL_CAMPAIGN = 'EMAIL_CAMPAIGN',
  ENGRAIN_SIGHTMAP = 'ENGRAIN_SIGHTMAP',
  EVERYRENT_COM = 'EVERYRENT_COM',
  FACEBOOK = 'FACEBOOK',
  FACEBOOK_ADS = 'FACEBOOK_ADS',
  FACEBOOK_MARKETPLACE = 'FACEBOOK_MARKETPLACE',
  FOR_RENT = 'FOR_RENT',
  FREE_RENTAL_SITE = 'FREE_RENTAL_SITE',
  FULLSAIL_EDU_HOUSING_GUIDE = 'FULLSAIL_EDU_HOUSING_GUIDE',
  FULTON_GRACE = 'FULTON_GRACE',
  GEORGIA_HOUSING_SEARCH = 'GEORGIA_HOUSING_SEARCH',
  GET_G5_COM = 'GET_G5_COM',
  GMU_EDU = 'GMU_EDU',
  GOOGLE = 'GOOGLE',
  GOOGLE_ADS = 'GOOGLE_ADS',
  GOOGLE_IN_MARKET = 'GOOGLE_IN_MARKET',
  GOSECTION8 = 'GOSECTION8',
  HARVARD_EDU = 'HARVARD_EDU',
  HAR_COM = 'HAR_COM',
  HOMES_MIL = 'HOMES_MIL',
  HOTPADS = 'HOTPADS',
  HOUSING_FAIR = 'HOUSING_FAIR',
  HUNT_COM = 'HUNT_COM',
  ILS = 'ILS',
  INDULGE_MAGAZINE = 'INDULGE_MAGAZINE',
  INSTAGRAM = 'INSTAGRAM',
  INSTAGRAM_ADS = 'INSTAGRAM_ADS',
  JHU_EDU = 'JHU_EDU',
  KELLOGG_HOUSING_GUIDE = 'KELLOGG_HOUSING_GUIDE',
  KSL_COM = 'KSL_COM',
  LEASELOCK = 'LEASELOCK',
  LEASING_KC = 'LEASING_KC',
  LET_GO = 'LET_GO',
  LINKEDIN_ADS = 'LINKEDIN_ADS',
  LOCATOR = 'LOCATOR',
  LOVELY = 'LOVELY',
  LUXE_LIST_HOME = 'LUXE_LIST_HOME',
  MADISON_APARTMENT_LIVING = 'MADISON_APARTMENT_LIVING',
  MANSION_GLOBAL_MAGAZINE = 'MANSION_GLOBAL_MAGAZINE',
  MIDDLE_INCOME = 'MIDDLE_INCOME',
  MLS = 'MLS',
  NATIONAL_CORPORATE_HOUSING = 'NATIONAL_CORPORATE_HOUSING',
  NEW_HIRE_HOUSING_GUIDE_COM = 'NEW_HIRE_HOUSING_GUIDE_COM',
  NEXTDOOR = 'NEXTDOOR',
  NEXT_STEPS_FOR_SENIORS = 'NEXT_STEPS_FOR_SENIORS',
  OFF_CAMPUS_PARTNERS = 'OFF_CAMPUS_PARTNERS',
  OUTTHERE_COLORADO = 'OUTTHERE_COLORADO',
  PADFINDERS = 'PADFINDERS',
  PADMAPPER_COM = 'PADMAPPER_COM',
  PENTHOUSES_AT_PALAZZO = 'PENTHOUSES_AT_PALAZZO',
  PEOPLE_WITH_PETS_COM = 'PEOPLE_WITH_PETS_COM',
  PERQ = 'PERQ',
  PHILLY_MAG = 'PHILLY_MAG',
  PIEDMONT_HEALTH_PORTAL = 'PIEDMONT_HEALTH_PORTAL',
  PINTEREST_ADS = 'PINTEREST_ADS',
  PIPELINE = 'PIPELINE',
  PLACES_4_STUDENTS = 'PLACES_4_STUDENTS',
  POST_TO_INTERNET = 'POST_TO_INTERNET',
  PREFERRED_EMPLOYER_PROGRAM = 'PREFERRED_EMPLOYER_PROGRAM',
  PRINT_ADS = 'PRINT_ADS',
  PROMOTIONAL_GIVEAWAYS = 'PROMOTIONAL_GIVEAWAYS',
  PROMOVE = 'PROMOVE',
  PROPERTY_WEBSITE = 'PROPERTY_WEBSITE',
  RADIO = 'RADIO',
  REACH_LOCAL = 'REACH_LOCAL',
  REACH_LOCAL_GEOFENCE = 'REACH_LOCAL_GEOFENCE',
  REALTOR = 'REALTOR',
  RELATE_24_7 = 'RELATE_24_7',
  RENTALS_COM = 'RENTALS_COM',
  RENTCAFE = 'RENTCAFE',
  RENTGRATA = 'RENTGRATA',
  RENTLER = 'RENTLER',
  RENTLINX = 'RENTLINX',
  RENTLY = 'RENTLY',
  RENTPATH_COM = 'RENTPATH_COM',
  RENTVISION = 'RENTVISION',
  RENT_COLLEGE_PADS = 'RENT_COLLEGE_PADS',
  RENT_COM = 'RENT_COM',
  RENT_JUNGLE = 'RENT_JUNGLE',
  RESIDENT_REFERRAL = 'RESIDENT_REFERRAL',
  SAS_CALL_CENTER = 'SAS_CALL_CENTER',
  SELF_SCHEDULED_SHOWING = 'SELF_SCHEDULED_SHOWING',
  SENIOR_HOUSING_NET = 'SENIOR_HOUSING_NET',
  SHOW_ME_THE_RENT = 'SHOW_ME_THE_RENT',
  SIGNAGE = 'SIGNAGE',
  SOCIALSERVE = 'SOCIALSERVE',
  STELLAR_MLS = 'STELLAR_MLS',
  STREET_EASY = 'STREET_EASY',
  SWAMP_RENTALS = 'SWAMP_RENTALS',
  TEMPLE_EDU = 'TEMPLE_EDU',
  TIK_TOK = 'TIK_TOK',
  TOURVISTA = 'TOURVISTA',
  TRULIA = 'TRULIA',
  TURBO_TENANT = 'TURBO_TENANT',
  UCSC_EDU = 'UCSC_EDU',
  UC_DENVER_EDU = 'UC_DENVER_EDU',
  UHOUZZ = 'UHOUZZ',
  ULOOP = 'ULOOP',
  UMD_EDU = 'UMD_EDU',
  UNBOUNCE = 'UNBOUNCE',
  UNIVERSITY_OF_PENNSYLVANIA_EDU = 'UNIVERSITY_OF_PENNSYLVANIA_EDU',
  UNIVERSITY_OF_THE_ARTS_EDU = 'UNIVERSITY_OF_THE_ARTS_EDU',
  UNKNOWN = 'UNKNOWN',
  VALLEY_CHANNEL = 'VALLEY_CHANNEL',
  VANDERBILT_EDU = 'VANDERBILT_EDU',
  VERANDA_MAGAZINE = 'VERANDA_MAGAZINE',
  VERY_APT_COM = 'VERY_APT_COM',
  VIRTUAL_PROPERTY_TOURS = 'VIRTUAL_PROPERTY_TOURS',
  WEB_DIRECTORY = 'WEB_DIRECTORY',
  YAHOO = 'YAHOO',
  YELLOW_PAGES_COM = 'YELLOW_PAGES_COM',
  YELP = 'YELP',
  YOUTUBE = 'YOUTUBE',
  ZILLOW = 'ZILLOW',
  ZILLOW_BOOST = 'ZILLOW_BOOST',
  ZILLOW_RENT_CONNECT = 'ZILLOW_RENT_CONNECT',
  ZOOM_MEDIA = 'ZOOM_MEDIA',
  ZUMPER = 'ZUMPER',
  ZUMPER_DIRECT_CONTRACT = 'ZUMPER_DIRECT_CONTRACT'
}

export type LeasingInfo = {
  __typename?: 'LeasingInfo';
  acceptSection8?: Maybe<Scalars['Boolean']>;
  amenitiesText?: Maybe<Scalars['String']>;
  applicationDocsText?: Maybe<Scalars['String']>;
  applicationUrl?: Maybe<Scalars['String']>;
  areAgentsOnsite?: Maybe<Scalars['Boolean']>;
  buildingName?: Maybe<Scalars['String']>;
  cosignerPolicyText?: Maybe<Scalars['String']>;
  discountsText?: Maybe<Scalars['String']>;
  floorPlansUrl?: Maybe<Scalars['String']>;
  handicappedUnitsText?: Maybe<Scalars['String']>;
  isFurnished?: Maybe<Scalars['Boolean']>;
  laundryText?: Maybe<Scalars['String']>;
  leaseTermsText?: Maybe<Scalars['String']>;
  leasingSpecials: Array<LeasingSpecial>;
  leasingSpecialsText?: Maybe<Scalars['String']>;
  maxAcceptedPerShowing?: Maybe<Scalars['Int']>;
  maxSimultaneousShowings?: Maybe<Scalars['Int']>;
  meetingDirections?: Maybe<Scalars['String']>;
  moveInCostText?: Maybe<Scalars['String']>;
  officePhone?: Maybe<Scalars['String']>;
  parkingText?: Maybe<Scalars['String']>;
  petPolicyText?: Maybe<Scalars['String']>;
  propertyType?: Maybe<LeasePropertyType>;
  propertyWebsite?: Maybe<Scalars['String']>;
  qualificationText?: Maybe<Scalars['String']>;
  realtorText?: Maybe<Scalars['String']>;
  section8Text?: Maybe<Scalars['String']>;
  selfGuidedMeetingDirections?: Maybe<Scalars['String']>;
  showingDurationMins?: Maybe<Scalars['Int']>;
  showingPolicy?: Maybe<ShowingPolicy>;
  tourTypes?: Maybe<Array<TourType>>;
  utilitiesText?: Maybe<Scalars['String']>;
  yardiPropertyCode?: Maybe<Scalars['String']>;
};

export type LeasingSpecial = {
  __typename?: 'LeasingSpecial';
  endDate?: Maybe<Scalars['String']>;
  text: Scalars['String'];
};

export type LeasingSpecialInput = {
  endDate?: InputMaybe<Scalars['String']>;
  text: Scalars['String'];
};

export type LeasingTask = {
  __typename?: 'LeasingTask';
  address?: Maybe<Address>;
  addressEmail?: Maybe<Scalars['String']>;
  addressPhone?: Maybe<Scalars['String']>;
  archivedThreads: Array<Thread>;
  displayName: Scalars['String'];
  endpoints: Array<Endpoint>;
  firm: Firm;
  firmTaskId?: Maybe<Scalars['Int']>;
  floorPlans: Array<FloorPlan>;
  hasLaunched: Scalars['Boolean'];
  hasOffboarded: Scalars['Boolean'];
  holidays?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isArchived: Scalars['Boolean'];
  isBotDisabled: Scalars['Boolean'];
  launchDate?: Maybe<Scalars['String']>;
  leasingInfo?: Maybe<LeasingInfo>;
  numUnits?: Maybe<Scalars['Int']>;
  offboardDate?: Maybe<Scalars['String']>;
  onboardingInfo: OnboardingInfo;
  pmCampaigns: Array<PmCampaign>;
  pmItemKeys: Array<PmItemKey>;
  pmUnits: Array<PmPostableUnit>;
  primaryPmKeyJson?: Maybe<Scalars['String']>;
  primaryPmProperty?: Maybe<PmProperty>;
  recentActions: Array<SavedAction>;
  showingHours?: Maybe<Scalars['String']>;
  showings: Array<Showing>;
  streetViewAddress?: Maybe<Scalars['String']>;
  taskAgents: Array<TaskAgent>;
  taskType: TaskType;
  threads: Array<Thread>;
  timeCreated: Scalars['String'];
  tourTypes: Array<TourType>;
  unitTypes: Array<UnitType>;
  unitTypesShowableOnAnyDate: Array<UnitType>;
};


export type LeasingTaskEndpointsArgs = {
  released?: InputMaybe<Scalars['Boolean']>;
};


export type LeasingTaskRecentActionsArgs = {
  limit: Scalars['Int'];
};


export type LeasingTaskShowingsArgs = {
  showingsFilterInput?: InputMaybe<ShowingsFilterInput>;
};

export type LeasingTaskInput = {
  acceptSection8?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<Scalars['String']>;
  amenitiesText?: InputMaybe<Scalars['String']>;
  applicationDocsText?: InputMaybe<Scalars['String']>;
  applicationUrl?: InputMaybe<Scalars['String']>;
  areAgentsOnsite?: InputMaybe<Scalars['Boolean']>;
  bookedTrainingStatus?: InputMaybe<OnboardingStatus>;
  buildingName?: InputMaybe<Scalars['String']>;
  confirmedMarketLaunchDateStatus?: InputMaybe<OnboardingStatus>;
  confirmedSourcesStatus?: InputMaybe<OnboardingStatus>;
  cosignerPolicyText?: InputMaybe<Scalars['String']>;
  discountsText?: InputMaybe<Scalars['String']>;
  floorPlansUrl?: InputMaybe<Scalars['String']>;
  handicappedUnitsText?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  isBotDisabled?: InputMaybe<Scalars['Boolean']>;
  isFurnished?: InputMaybe<Scalars['Boolean']>;
  launchDate?: InputMaybe<Scalars['String']>;
  laundryText?: InputMaybe<Scalars['String']>;
  leaseTermsText?: InputMaybe<Scalars['String']>;
  leasingSpecialEndDate?: InputMaybe<Scalars['String']>;
  leasingSpecialText?: InputMaybe<Scalars['String']>;
  leasingSpecials?: InputMaybe<Array<LeasingSpecialInput>>;
  leasingSpecialsText?: InputMaybe<Scalars['String']>;
  maxAcceptedPerShowing?: InputMaybe<Scalars['Int']>;
  maxSimultaneousShowings?: InputMaybe<Scalars['Int']>;
  meetingDirections?: InputMaybe<Scalars['String']>;
  moveInCostText?: InputMaybe<Scalars['String']>;
  offboardDate?: InputMaybe<Scalars['String']>;
  officePhone?: InputMaybe<Scalars['String']>;
  parkingText?: InputMaybe<Scalars['String']>;
  petPolicyText?: InputMaybe<Scalars['String']>;
  propertyDetailsStatus?: InputMaybe<OnboardingStatus>;
  propertyType?: InputMaybe<LeasePropertyType>;
  propertyWebsite?: InputMaybe<Scalars['String']>;
  qualificationText?: InputMaybe<Scalars['String']>;
  realtorText?: InputMaybe<Scalars['String']>;
  section8Text?: InputMaybe<Scalars['String']>;
  selfGuidedMeetingDirections?: InputMaybe<Scalars['String']>;
  showingDurationMins?: InputMaybe<Scalars['Int']>;
  showingPolicy?: InputMaybe<ShowingPolicy>;
  streetViewAddress?: InputMaybe<Scalars['String']>;
  tourTypes?: InputMaybe<Array<TourType>>;
  utilitiesText?: InputMaybe<Scalars['String']>;
  yardiPropertyCode?: InputMaybe<Scalars['String']>;
};

export type LeasingTaskLink = {
  __typename?: 'LeasingTaskLink';
  leasingTask: LeasingTask;
};

export type Link = FloorPlanLink | LeasingTaskLink;

export type LisaSummary = {
  __typename?: 'LisaSummary';
  inquirySummaries: Array<InquirySummary>;
  lastContacted: Scalars['String'];
};

export enum ListingStatus {
  LISTING_DOES_NOT_EXIST = 'LISTING_DOES_NOT_EXIST',
  LISTING_EXISTS_PHONE_INVALID = 'LISTING_EXISTS_PHONE_INVALID',
  LISTING_EXISTS_PHONE_MISSING = 'LISTING_EXISTS_PHONE_MISSING',
  LISTING_EXISTS_PHONE_WORKS = 'LISTING_EXISTS_PHONE_WORKS',
  PENDING = 'PENDING',
  READY_FOR_POSTING = 'READY_FOR_POSTING'
}

export type Message = {
  __typename?: 'Message';
  actionId?: Maybe<Scalars['Int']>;
  actionUrl?: Maybe<Scalars['String']>;
  addressFrom: Scalars['String'];
  addressTo: Scalars['String'];
  annotations: Array<MessageAnnotation>;
  author?: Maybe<User>;
  calEventId?: Maybe<Scalars['String']>;
  callDuration?: Maybe<Scalars['Int']>;
  callStart?: Maybe<Scalars['String']>;
  callStatus?: Maybe<VoiceCallStatus>;
  censoredShortBody: Scalars['String'];
  censoredTranslatedShortBody?: Maybe<Scalars['String']>;
  classification?: Maybe<Scalars['String']>;
  contactThem: Contact;
  emailSubject?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  externalUrl?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isIlsInbound?: Maybe<Scalars['Boolean']>;
  isInbound: Scalars['Boolean'];
  leasingAttributionSource?: Maybe<Scalars['String']>;
  leasingAttributionSourceDisplayName?: Maybe<Scalars['String']>;
  mediaUrl?: Maybe<Scalars['String']>;
  messageDetails: Scalars['String'];
  messageLLMInfo?: Maybe<Array<MessageTag>>;
  messageStatus: MessageStatus;
  messageType: MessageType;
  outboundTags: Array<OutboundTag>;
  routedTo?: Maybe<Scalars['String']>;
  shortBody: Scalars['String'];
  tags: Array<MessageTag>;
  task?: Maybe<LeasingTask>;
  thread: Thread;
  timeCreated: Scalars['String'];
  translatedEmailSubject?: Maybe<Scalars['String']>;
  translatedShortBody?: Maybe<Scalars['String']>;
};

export type MessageAnnotation = {
  __typename?: 'MessageAnnotation';
  brainResultJson?: Maybe<Scalars['String']>;
  classification?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  tags?: Maybe<Array<MessageTag>>;
  timeCreated: Scalars['String'];
  user?: Maybe<User>;
};

export type MessageAnnotationInput = {
  classification: Scalars['String'];
  messageId: Scalars['Int'];
  tags: Array<MessageTag>;
};

export type MessageInput = {
  body: Scalars['String'];
  emailSubject?: InputMaybe<Scalars['String']>;
  isInbound?: InputMaybe<Scalars['Boolean']>;
  mediaUrl?: InputMaybe<Scalars['String']>;
  replyToMessageId?: InputMaybe<Scalars['Int']>;
  threadId: Scalars['Int'];
};

export type MessageLink = {
  __typename?: 'MessageLink';
  link: Link;
  phrase: Scalars['String'];
};

export type MessageLoadOptionsInput = {
  limit?: InputMaybe<Scalars['Int']>;
  messageId?: InputMaybe<Scalars['Int']>;
  messagesBefore?: InputMaybe<Scalars['Int']>;
};

export type MessageQuestion = {
  __typename?: 'MessageQuestion';
  messageId: Scalars['Int'];
  question: Scalars['String'];
  threadId: Scalars['Int'];
};

export enum MessageStatus {
  RECEIVED = 'RECEIVED',
  SENDING = 'SENDING',
  SEND_FAILED = 'SEND_FAILED',
  SENT = 'SENT'
}

export enum MessageTag {
  FEEDBACK_FOR_SITE = 'FEEDBACK_FOR_SITE',
  GRATITUDE = 'GRATITUDE',
  LANGUAGE_CHINESE = 'LANGUAGE_CHINESE',
  LANGUAGE_ENGLISH = 'LANGUAGE_ENGLISH',
  LANGUAGE_FRENCH = 'LANGUAGE_FRENCH',
  LANGUAGE_GERMAN = 'LANGUAGE_GERMAN',
  LANGUAGE_ITALIAN = 'LANGUAGE_ITALIAN',
  LANGUAGE_OTHER = 'LANGUAGE_OTHER',
  LANGUAGE_PORTUGUESE = 'LANGUAGE_PORTUGUESE',
  LANGUAGE_RUSSIAN = 'LANGUAGE_RUSSIAN',
  LANGUAGE_SPANISH = 'LANGUAGE_SPANISH',
  Q_ADDRESS = 'Q_ADDRESS',
  Q_AMENITIES = 'Q_AMENITIES',
  Q_APPLICATION_DOCS = 'Q_APPLICATION_DOCS',
  Q_APPLICATION_LINK = 'Q_APPLICATION_LINK',
  Q_APPLICATION_STATUS = 'Q_APPLICATION_STATUS',
  Q_AVAILABLE_ON = 'Q_AVAILABLE_ON',
  Q_CALL_ME = 'Q_CALL_ME',
  Q_CANT_CALL = 'Q_CANT_CALL',
  Q_CAN_I_WALK_IN = 'Q_CAN_I_WALK_IN',
  Q_COSIGNER_POLICY = 'Q_COSIGNER_POLICY',
  Q_DEFINE_TOUR_TYPE_IN_PERSON = 'Q_DEFINE_TOUR_TYPE_IN_PERSON',
  Q_DEFINE_TOUR_TYPE_SELF_GUIDED = 'Q_DEFINE_TOUR_TYPE_SELF_GUIDED',
  Q_DEFINE_TOUR_TYPE_VIRTUAL = 'Q_DEFINE_TOUR_TYPE_VIRTUAL',
  Q_DISCOUNTS = 'Q_DISCOUNTS',
  Q_FAIR_HOUSING = 'Q_FAIR_HOUSING',
  Q_FEATURE_REQUEST = 'Q_FEATURE_REQUEST',
  Q_FLOOR_PLAN_LINK = 'Q_FLOOR_PLAN_LINK',
  Q_FURNISHED = 'Q_FURNISHED',
  Q_FUTURE_AVAILABILITY = 'Q_FUTURE_AVAILABILITY',
  Q_HANDICAPPED_UNITS = 'Q_HANDICAPPED_UNITS',
  Q_HOW_TO_START_VIRTUAL_TOUR = 'Q_HOW_TO_START_VIRTUAL_TOUR',
  Q_LAUNDRY = 'Q_LAUNDRY',
  Q_LEASE_TERMS = 'Q_LEASE_TERMS',
  Q_LEASING_SPECIALS = 'Q_LEASING_SPECIALS',
  Q_LISTINGS = 'Q_LISTINGS',
  Q_MOVE_IN_COST = 'Q_MOVE_IN_COST',
  Q_NOT_A_BOT = 'Q_NOT_A_BOT',
  Q_OFFICE_PHONE = 'Q_OFFICE_PHONE',
  Q_PARKING = 'Q_PARKING',
  Q_PET_POLICY = 'Q_PET_POLICY',
  Q_QUALIFICATIONS = 'Q_QUALIFICATIONS',
  Q_REALTOR = 'Q_REALTOR',
  Q_REDIRECT_TO_AGENT = 'Q_REDIRECT_TO_AGENT',
  Q_RENT = 'Q_RENT',
  Q_RESIDENT = 'Q_RESIDENT',
  Q_SCHOOLS_NEARBY = 'Q_SCHOOLS_NEARBY',
  Q_SECTION8 = 'Q_SECTION8',
  Q_SERVICE_ANIMAL = 'Q_SERVICE_ANIMAL',
  Q_SHOWING_DURATION = 'Q_SHOWING_DURATION',
  Q_SHOWING_HOURS = 'Q_SHOWING_HOURS',
  Q_SQFT = 'Q_SQFT',
  Q_SUPPORT = 'Q_SUPPORT',
  Q_TOUR_TYPES_OFFERED = 'Q_TOUR_TYPES_OFFERED',
  Q_UNIT_UNAVAILABLE = 'Q_UNIT_UNAVAILABLE',
  Q_UTILITIES = 'Q_UTILITIES',
  Q_WHATS_YOUR_EMAIL = 'Q_WHATS_YOUR_EMAIL',
  Q_WHATS_YOUR_LAST_NAME = 'Q_WHATS_YOUR_LAST_NAME',
  Q_WHATS_YOUR_NAME = 'Q_WHATS_YOUR_NAME',
  Q_WHATS_YOUR_NUMBER = 'Q_WHATS_YOUR_NUMBER',
  TOUR_IN_PERSON = 'TOUR_IN_PERSON',
  TOUR_SELF_GUIDED = 'TOUR_SELF_GUIDED',
  TOUR_VIRTUAL = 'TOUR_VIRTUAL',
  UNIT_BR1 = 'UNIT_BR1',
  UNIT_BR2 = 'UNIT_BR2',
  UNIT_BR3 = 'UNIT_BR3',
  UNIT_BR4 = 'UNIT_BR4',
  UNIT_BR5PLUS = 'UNIT_BR5PLUS',
  UNIT_STUDIO = 'UNIT_STUDIO'
}

export enum MessageType {
  CALENDAR = 'CALENDAR',
  EMAIL = 'EMAIL',
  MMS = 'MMS',
  SMS = 'SMS',
  VOICE = 'VOICE'
}

export type MessagesWithLinks = {
  __typename?: 'MessagesWithLinks';
  messageLinks: Array<MessageLink>;
  messages: Array<Message>;
  waitingForShowing: Scalars['Boolean'];
};

export type ModelFilter = {
  __typename?: 'ModelFilter';
  firmId: Scalars['Int'];
  taskId: Scalars['Int'];
};

export type ModelFilterInput = {
  firmId?: InputMaybe<Scalars['Int']>;
  operatorId?: InputMaybe<Scalars['Int']>;
  taskId?: InputMaybe<Scalars['Int']>;
};

export enum ModelType {
  CAL = 'CAL',
  CONTACT = 'CONTACT',
  FIRM = 'FIRM',
  MESSAGE = 'MESSAGE',
  OPERATOR_SHIFT = 'OPERATOR_SHIFT',
  SAVED_ACTION = 'SAVED_ACTION',
  SHOWING = 'SHOWING',
  SHOWING_CONTACT = 'SHOWING_CONTACT',
  STATION = 'STATION',
  TASK = 'TASK',
  THREAD = 'THREAD'
}

export type MsGraphCreds = {
  __typename?: 'MsGraphCreds';
  clientId: Scalars['String'];
  clientSecret?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  homeAccountId?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  tokenCache?: Maybe<Scalars['String']>;
};

export type MsGraphCredsInput = {
  clientId?: InputMaybe<Scalars['String']>;
  clientSecret?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  homeAccountId?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  tokenCache?: InputMaybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  annotateMessage: Message;
  bulkUpdateTasks: Array<LeasingTask>;
  clearError: Scalars['Boolean'];
  createAgentsByEmails: Array<Thread>;
  createBossesByEmails: Array<Thread>;
  createEndpoint: LeasingTask;
  createFirm: Firm;
  createMergedTask: Firm;
  createTasks: Firm;
  createThread: Thread;
  createUser: User;
  deleteEndpoint: LeasingTask;
  deleteTaskAgent: LeasingTask;
  disableFeatureFlag: FeatureFlag;
  enableFeatureFlag: FeatureFlag;
  postAction: Thread;
  postUnit: LeasingTask;
  receiveCall: Thread;
  retryAction: SavedAction;
  runAdminTask: Scalars['String'];
  saveOperatorSurvey: Scalars['Boolean'];
  saveTaskAgent: LeasingTask;
  sendMessage: Thread;
  setAutoStationEnabledForUser: User;
  setClockedIn: OperatorClockEvent;
  setIsTyping: Scalars['Boolean'];
  setLookingAtUser: User;
  setSetting: Setting;
  setThreadPreferredTourType: Thread;
  setThreadUnitTypes: Thread;
  stepIn: Thread;
  unlinkTask: LeasingTask;
  updateContact: Contact;
  updateEndpoint: LeasingTask;
  updateFirm: Firm;
  updateFirmApmInfo: Scalars['Boolean'];
  updateFirmEntrataInfo: Scalars['Boolean'];
  updateFirmExchangeCreds: Scalars['Boolean'];
  updateFirmGSuiteCreds: Scalars['Boolean'];
  updateFirmMsGraphCreds: Scalars['Boolean'];
  updateFirmRealpageInfo: Scalars['Boolean'];
  updateFirmResmanInfo: Scalars['Boolean'];
  updateFirmYardiInfo: Scalars['Boolean'];
  updateLeasingTask: LeasingTask;
  updateLeasingTaskPhoneManagerClientId: LeasingTask;
  updateNote?: Maybe<Note>;
  updateShowing: LeasingTask;
  updateThread: Thread;
  updateUser: User;
};


export type MutationAnnotateMessageArgs = {
  annotation: MessageAnnotationInput;
};


export type MutationBulkUpdateTasksArgs = {
  externalUser?: InputMaybe<ExternalUserInput>;
  field: BulkUpdateOp;
  taskIds: Array<Scalars['Int']>;
  value?: InputMaybe<Scalars['String']>;
};


export type MutationClearErrorArgs = {
  errorId: Scalars['Int'];
};


export type MutationCreateAgentsByEmailsArgs = {
  apmVhost: Scalars['String'];
  propertyUsers: Array<PropertyUserInput>;
};


export type MutationCreateBossesByEmailsArgs = {
  apmVhost: Scalars['String'];
  propertyUsers: Array<PropertyUserInput>;
};


export type MutationCreateEndpointArgs = {
  addr?: InputMaybe<Scalars['String']>;
  leasingAttributionSource?: InputMaybe<LeasingAttributionSource>;
  taskId: Scalars['Int'];
};


export type MutationCreateFirmArgs = {
  addressId: Scalars['Int'];
  firmName: Scalars['String'];
  pmFirm?: InputMaybe<Scalars['String']>;
  pmType: PmType;
  salesforceVPlusObjectId?: InputMaybe<Scalars['String']>;
};


export type MutationCreateMergedTaskArgs = {
  firmId: Scalars['Int'];
  launchDate: Scalars['String'];
  pmItemKeyJsons: Array<Scalars['String']>;
};


export type MutationCreateTasksArgs = {
  firmId: Scalars['Int'];
  launchDate: Scalars['String'];
  pmItemKeyJsons: Array<Scalars['String']>;
};


export type MutationCreateThreadArgs = {
  addressThem: Scalars['String'];
  addressUs: Scalars['String'];
};


export type MutationCreateUserArgs = {
  user: UserInput;
};


export type MutationDeleteEndpointArgs = {
  id: Scalars['Int'];
  taskId: Scalars['Int'];
};


export type MutationDeleteTaskAgentArgs = {
  agentId: Scalars['Int'];
  externalUser?: InputMaybe<ExternalUserInput>;
  taskId: Scalars['Int'];
};


export type MutationDisableFeatureFlagArgs = {
  featureName: Scalars['String'];
  firmId: Scalars['Int'];
  firmTaskId: Scalars['Int'];
};


export type MutationEnableFeatureFlagArgs = {
  featureName: Scalars['String'];
  firmId: Scalars['Int'];
  firmTaskId: Scalars['Int'];
};


export type MutationPostActionArgs = {
  action: ActionInput;
  actionCount?: InputMaybe<Scalars['Int']>;
  threadId: Scalars['Int'];
};


export type MutationPostUnitArgs = {
  auditKeyJson: Scalars['String'];
  jobName: PostJobName;
};


export type MutationReceiveCallArgs = {
  threadId: Scalars['Int'];
};


export type MutationRetryActionArgs = {
  actionId: Scalars['Int'];
  threadId: Scalars['Int'];
};


export type MutationRunAdminTaskArgs = {
  argumentsJson: Scalars['String'];
};


export type MutationSaveOperatorSurveyArgs = {
  comment: Scalars['String'];
  maxScore: Scalars['Int'];
  minScore: Scalars['Int'];
  questionAsked: Scalars['String'];
  score: Scalars['Int'];
};


export type MutationSaveTaskAgentArgs = {
  agentId: Scalars['Int'];
  externalUser?: InputMaybe<ExternalUserInput>;
  onboardingRoles?: InputMaybe<Scalars['String']>;
  precedence?: InputMaybe<Scalars['Int']>;
  taskId: Scalars['Int'];
  workHours?: InputMaybe<Scalars['String']>;
};


export type MutationSendMessageArgs = {
  actionCount?: InputMaybe<Scalars['Int']>;
  message: MessageInput;
  operatorResponseTimeMs?: InputMaybe<Scalars['Int']>;
};


export type MutationSetAutoStationEnabledForUserArgs = {
  enabled: Scalars['Boolean'];
  userId: Scalars['Int'];
};


export type MutationSetClockedInArgs = {
  isClockedIn: Scalars['Boolean'];
  userId?: InputMaybe<Scalars['Int']>;
};


export type MutationSetIsTypingArgs = {
  isTyping: Scalars['Boolean'];
  threadId: Scalars['Int'];
};


export type MutationSetLookingAtUserArgs = {
  observedUserId?: InputMaybe<Scalars['Int']>;
};


export type MutationSetSettingArgs = {
  key: Scalars['String'];
  value: Scalars['String'];
};


export type MutationSetThreadPreferredTourTypeArgs = {
  preferredTourType?: InputMaybe<TourType>;
  threadId: Scalars['Int'];
};


export type MutationSetThreadUnitTypesArgs = {
  threadId: Scalars['Int'];
  unitTypes: Array<UnitType>;
};


export type MutationStepInArgs = {
  threadId: Scalars['Int'];
};


export type MutationUnlinkTaskArgs = {
  taskId: Scalars['Int'];
};


export type MutationUpdateContactArgs = {
  contact: ContactInput;
};


export type MutationUpdateEndpointArgs = {
  id: Scalars['Int'];
  listingStatus: ListingStatus;
  listingUrl?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateFirmArgs = {
  externalUser?: InputMaybe<ExternalUserInput>;
  firm: FirmInput;
};


export type MutationUpdateFirmApmInfoArgs = {
  apmInfo: ApmInfoInput;
  firmId: Scalars['Int'];
};


export type MutationUpdateFirmEntrataInfoArgs = {
  entrataInfo: EntrataInfoInput;
  firmId: Scalars['Int'];
};


export type MutationUpdateFirmExchangeCredsArgs = {
  exchangeCreds: ExchangeCredsInput;
  firmId: Scalars['Int'];
};


export type MutationUpdateFirmGSuiteCredsArgs = {
  firmId: Scalars['Int'];
  gSuiteCreds: GSuiteCredsInput;
};


export type MutationUpdateFirmMsGraphCredsArgs = {
  firmId: Scalars['Int'];
  msGraphCreds: MsGraphCredsInput;
};


export type MutationUpdateFirmRealpageInfoArgs = {
  firmId: Scalars['Int'];
  realpageInfo: RealpageInfoInput;
};


export type MutationUpdateFirmResmanInfoArgs = {
  firmId: Scalars['Int'];
  resmanInfo: BasicPmInfoInput;
};


export type MutationUpdateFirmYardiInfoArgs = {
  firmId: Scalars['Int'];
  yardiInfo: YardiInfoInput;
};


export type MutationUpdateLeasingTaskArgs = {
  externalUser?: InputMaybe<ExternalUserInput>;
  task: LeasingTaskInput;
};


export type MutationUpdateLeasingTaskPhoneManagerClientIdArgs = {
  phoneManagerClientId: Scalars['String'];
  taskId: Scalars['Int'];
};


export type MutationUpdateNoteArgs = {
  body?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};


export type MutationUpdateShowingArgs = {
  showingId: Scalars['Int'];
  showingStatus: ShowingStatus;
};


export type MutationUpdateThreadArgs = {
  archiveDays?: InputMaybe<Scalars['Int']>;
  botStatus?: InputMaybe<ThreadBotStatus>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  lastReadMessageId?: InputMaybe<Scalars['Int']>;
  leasingAttributionSource?: InputMaybe<Scalars['String']>;
  threadId: Scalars['Int'];
};


export type MutationUpdateUserArgs = {
  user: UserInput;
};

export type Note = {
  __typename?: 'Note';
  agentName?: Maybe<Scalars['String']>;
  author: User;
  authorId: Scalars['Int'];
  body: Scalars['String'];
  id: Scalars['Int'];
  messageId?: Maybe<Scalars['Int']>;
  threadId?: Maybe<Scalars['Int']>;
  timeCreated: Scalars['String'];
};

export type OnboardingInfo = {
  __typename?: 'OnboardingInfo';
  addedLisaDynastyStatus: OnboardingStatus;
  bookedTrainingStatus: OnboardingStatus;
  confirmedMarketLaunchDateStatus: OnboardingStatus;
  confirmedSourcesStatus: OnboardingStatus;
  enabledPmStatus: OnboardingStatus;
  propertyDetailsStatus: OnboardingStatus;
  provisionedEmailStatus: OnboardingStatus;
};

export enum OnboardingStatus {
  COMPLETED = 'COMPLETED',
  NOT_REQUESTED = 'NOT_REQUESTED',
  REQUESTED = 'REQUESTED'
}

export enum OpShiftState {
  CANCELED = 'CANCELED',
  MATCHED = 'MATCHED',
  RANKING = 'RANKING'
}

export type OperatorCal = {
  __typename?: 'OperatorCal';
  hoursScheduled: Scalars['Float'];
  maxNumShifts: Scalars['Int'];
  operatorShifts: Array<OperatorShift>;
};

export type OperatorClockEvent = {
  __typename?: 'OperatorClockEvent';
  clockInTime: Scalars['String'];
  clockOutTime?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  user: User;
};

export type OperatorShift = {
  __typename?: 'OperatorShift';
  id: Scalars['Int'];
  rank?: Maybe<Scalars['Int']>;
  shift: Shift;
  state: OpShiftState;
  userId: Scalars['Int'];
};

export type OperatorSurvey = {
  __typename?: 'OperatorSurvey';
  maxScore: Scalars['Int'];
  minScore: Scalars['Int'];
  questionToAsk: Scalars['String'];
};

export enum OutboundTag {
  AB_1176_CONTROL = 'AB_1176_CONTROL',
  AB_1176_TREAT = 'AB_1176_TREAT',
  AB_3654_CONTROL = 'AB_3654_CONTROL',
  AB_3654_TREAT = 'AB_3654_TREAT',
  AB_4413_CONTROL = 'AB_4413_CONTROL',
  AB_4413_TREAT = 'AB_4413_TREAT',
  AB_4758_CONTROL = 'AB_4758_CONTROL',
  AB_4758_TREAT = 'AB_4758_TREAT',
  AB_5128_CONTROL = 'AB_5128_CONTROL',
  AB_5128_TREAT = 'AB_5128_TREAT',
  AB_5229_CONTROL = 'AB_5229_CONTROL',
  AB_5229_TREAT = 'AB_5229_TREAT',
  AGENT_ALL_PROSPECTS_CANCELLED = 'AGENT_ALL_PROSPECTS_CANCELLED',
  AGENT_COLLEAGUE_ACCEPTED_SHOWING = 'AGENT_COLLEAGUE_ACCEPTED_SHOWING',
  AGENT_NO_PROSPECTS_CONFIRMED = 'AGENT_NO_PROSPECTS_CONFIRMED',
  AGENT_NO_RESPONSE_PUNISHMENT = 'AGENT_NO_RESPONSE_PUNISHMENT',
  AGENT_PROPERTY_LEASED = 'AGENT_PROPERTY_LEASED',
  AGENT_SWITCH_TO_SELF_GUIDED_TOUR_TYPE = 'AGENT_SWITCH_TO_SELF_GUIDED_TOUR_TYPE',
  BOSS_OPS_WARN_TOUR_TYPE_POLICY_CONFLICTS = 'BOSS_OPS_WARN_TOUR_TYPE_POLICY_CONFLICTS',
  PROSPECT_ROUTED_TO_OFFICE = 'PROSPECT_ROUTED_TO_OFFICE',
  SET_TOURTYPE_IN_PERSON = 'SET_TOURTYPE_IN_PERSON',
  SET_TOURTYPE_SELF_GUIDED = 'SET_TOURTYPE_SELF_GUIDED',
  SET_TOURTYPE_VIRTUAL = 'SET_TOURTYPE_VIRTUAL',
  T_ACK_ACCEPT_SHOW_1 = 'T_ACK_ACCEPT_SHOW_1',
  T_ACK_ACCEPT_SHOW_2 = 'T_ACK_ACCEPT_SHOW_2',
  T_ACK_ACCEPT_SHOW_3 = 'T_ACK_ACCEPT_SHOW_3',
  T_ACK_ACCEPT_SHOW_4 = 'T_ACK_ACCEPT_SHOW_4',
  T_ACK_ACCEPT_SHOW_5 = 'T_ACK_ACCEPT_SHOW_5',
  T_ACK_ACCEPT_SHOW_6 = 'T_ACK_ACCEPT_SHOW_6',
  T_ACK_ACCEPT_SHOW_7 = 'T_ACK_ACCEPT_SHOW_7',
  T_ACK_MOVE_IN_DATE_1 = 'T_ACK_MOVE_IN_DATE_1',
  T_ACK_MOVE_IN_DATE_2 = 'T_ACK_MOVE_IN_DATE_2',
  T_ACK_MOVE_IN_DATE_3 = 'T_ACK_MOVE_IN_DATE_3',
  T_ACK_MOVE_IN_DATE_4 = 'T_ACK_MOVE_IN_DATE_4',
  T_ACK_MOVE_IN_DATE_5 = 'T_ACK_MOVE_IN_DATE_5',
  T_ACK_MOVE_IN_DATE_6 = 'T_ACK_MOVE_IN_DATE_6',
  T_ARE_YOU_A_BOT_1 = 'T_ARE_YOU_A_BOT_1',
  T_ARE_YOU_A_BOT_2 = 'T_ARE_YOU_A_BOT_2',
  T_ASK_NAME_1 = 'T_ASK_NAME_1',
  T_ASK_NAME_2 = 'T_ASK_NAME_2',
  T_ASK_NAME_3 = 'T_ASK_NAME_3',
  T_ASK_NAME_4 = 'T_ASK_NAME_4',
  T_ASK_NAME_5 = 'T_ASK_NAME_5',
  T_ASK_NAME_6 = 'T_ASK_NAME_6',
  T_ASK_NAME_7 = 'T_ASK_NAME_7',
  T_AUGMENT_MESSAGE_OUTSIDE_OFFICE_HOURS_1 = 'T_AUGMENT_MESSAGE_OUTSIDE_OFFICE_HOURS_1',
  T_AUGMENT_MESSAGE_OUTSIDE_OFFICE_HOURS_2 = 'T_AUGMENT_MESSAGE_OUTSIDE_OFFICE_HOURS_2',
  T_DEFINE_TOUR_TYPE_IN_PERSON_1 = 'T_DEFINE_TOUR_TYPE_IN_PERSON_1',
  T_DEFINE_TOUR_TYPE_IN_PERSON_2 = 'T_DEFINE_TOUR_TYPE_IN_PERSON_2',
  T_DEFINE_TOUR_TYPE_IN_PERSON_3 = 'T_DEFINE_TOUR_TYPE_IN_PERSON_3',
  T_DEFINE_TOUR_TYPE_SELF_GUIDED_1 = 'T_DEFINE_TOUR_TYPE_SELF_GUIDED_1',
  T_DEFINE_TOUR_TYPE_SELF_GUIDED_2 = 'T_DEFINE_TOUR_TYPE_SELF_GUIDED_2',
  T_DEFINE_TOUR_TYPE_SELF_GUIDED_3 = 'T_DEFINE_TOUR_TYPE_SELF_GUIDED_3',
  T_DEFINE_TOUR_TYPE_VIRTUAL_1 = 'T_DEFINE_TOUR_TYPE_VIRTUAL_1',
  T_DEFINE_TOUR_TYPE_VIRTUAL_2 = 'T_DEFINE_TOUR_TYPE_VIRTUAL_2',
  T_DEFINE_TOUR_TYPE_VIRTUAL_3 = 'T_DEFINE_TOUR_TYPE_VIRTUAL_3',
  T_FIX_PM_MARK_AS_LEASED_1 = 'T_FIX_PM_MARK_AS_LEASED_1',
  T_FIX_PM_MARK_AS_LEASED_2 = 'T_FIX_PM_MARK_AS_LEASED_2',
  T_FIX_PM_MARK_AS_LEASED_3 = 'T_FIX_PM_MARK_AS_LEASED_3',
  T_FIX_PM_POST_LISTING_1 = 'T_FIX_PM_POST_LISTING_1',
  T_FIX_PM_POST_LISTING_2 = 'T_FIX_PM_POST_LISTING_2',
  T_FIX_PM_POST_LISTING_3 = 'T_FIX_PM_POST_LISTING_3',
  T_FIX_PM_RENT_PRICE_1 = 'T_FIX_PM_RENT_PRICE_1',
  T_FIX_PM_RENT_PRICE_2 = 'T_FIX_PM_RENT_PRICE_2',
  T_FIX_PM_RENT_PRICE_3 = 'T_FIX_PM_RENT_PRICE_3',
  T_FIX_PM_SET_SHOWABLE_ON_DATE_1 = 'T_FIX_PM_SET_SHOWABLE_ON_DATE_1',
  T_FIX_PM_SET_SHOWABLE_ON_DATE_2 = 'T_FIX_PM_SET_SHOWABLE_ON_DATE_2',
  T_FIX_PM_SET_SHOWABLE_ON_DATE_3 = 'T_FIX_PM_SET_SHOWABLE_ON_DATE_3',
  T_FIX_PM_UNPOST_LISTING_1 = 'T_FIX_PM_UNPOST_LISTING_1',
  T_FIX_PM_UNPOST_LISTING_2 = 'T_FIX_PM_UNPOST_LISTING_2',
  T_FIX_PM_UNPOST_LISTING_3 = 'T_FIX_PM_UNPOST_LISTING_3',
  T_MISSED_CALL_1 = 'T_MISSED_CALL_1',
  T_MISSED_CALL_2 = 'T_MISSED_CALL_2',
  T_MISSED_CALL_3 = 'T_MISSED_CALL_3',
  T_MISSED_CALL_4 = 'T_MISSED_CALL_4',
  T_MISSED_CALL_5 = 'T_MISSED_CALL_5',
  T_MISSED_CALL_6 = 'T_MISSED_CALL_6',
  T_MULTIPLE_TOUR_TYPE_IN_PERSON_SELF_GUIDED_1 = 'T_MULTIPLE_TOUR_TYPE_IN_PERSON_SELF_GUIDED_1',
  T_MULTIPLE_TOUR_TYPE_IN_PERSON_SELF_GUIDED_2 = 'T_MULTIPLE_TOUR_TYPE_IN_PERSON_SELF_GUIDED_2',
  T_MULTIPLE_TOUR_TYPE_IN_PERSON_SELF_GUIDED_VIRTUAL_1 = 'T_MULTIPLE_TOUR_TYPE_IN_PERSON_SELF_GUIDED_VIRTUAL_1',
  T_MULTIPLE_TOUR_TYPE_IN_PERSON_SELF_GUIDED_VIRTUAL_2 = 'T_MULTIPLE_TOUR_TYPE_IN_PERSON_SELF_GUIDED_VIRTUAL_2',
  T_MULTIPLE_TOUR_TYPE_IN_PERSON_VIRTUAL_1 = 'T_MULTIPLE_TOUR_TYPE_IN_PERSON_VIRTUAL_1',
  T_MULTIPLE_TOUR_TYPE_IN_PERSON_VIRTUAL_2 = 'T_MULTIPLE_TOUR_TYPE_IN_PERSON_VIRTUAL_2',
  T_MULTIPLE_TOUR_TYPE_IN_PERSON_VIRTUAL_3 = 'T_MULTIPLE_TOUR_TYPE_IN_PERSON_VIRTUAL_3',
  T_MULTIPLE_TOUR_TYPE_SELF_GUIDED_VIRTUAL_1 = 'T_MULTIPLE_TOUR_TYPE_SELF_GUIDED_VIRTUAL_1',
  T_MULTIPLE_TOUR_TYPE_SELF_GUIDED_VIRTUAL_2 = 'T_MULTIPLE_TOUR_TYPE_SELF_GUIDED_VIRTUAL_2',
  T_MULTIPLE_TOUR_TYPE_SELF_GUIDED_VIRTUAL_3 = 'T_MULTIPLE_TOUR_TYPE_SELF_GUIDED_VIRTUAL_3',
  T_NOT_QUALIFY_1 = 'T_NOT_QUALIFY_1',
  T_NOT_QUALIFY_2 = 'T_NOT_QUALIFY_2',
  T_NOT_QUALIFY_3 = 'T_NOT_QUALIFY_3',
  T_NOT_QUALIFY_4 = 'T_NOT_QUALIFY_4',
  T_OFFER_SHOW_COULD_YOU = 'T_OFFER_SHOW_COULD_YOU',
  T_OFFER_SHOW_DO_YOU_WANT_SHOWING = 'T_OFFER_SHOW_DO_YOU_WANT_SHOWING',
  T_OFFER_SHOW_HOW_ABOUT = 'T_OFFER_SHOW_HOW_ABOUT',
  T_OFFER_SHOW_WE_HAVE_AVAIL_DO_YOU_WANT_SHOWING = 'T_OFFER_SHOW_WE_HAVE_AVAIL_DO_YOU_WANT_SHOWING',
  T_OFFER_SHOW_WHAT_ABOUT = 'T_OFFER_SHOW_WHAT_ABOUT',
  T_OFFER_SHOW_WOULD_DAY_WORK = 'T_OFFER_SHOW_WOULD_DAY_WORK',
  T_OFFICE_PHONE_1 = 'T_OFFICE_PHONE_1',
  T_OFFICE_PHONE_2 = 'T_OFFICE_PHONE_2',
  T_OFFICE_PHONE_3 = 'T_OFFICE_PHONE_3',
  T_OFFICE_PHONE_4 = 'T_OFFICE_PHONE_4',
  T_OFFICE_PHONE_5 = 'T_OFFICE_PHONE_5',
  T_OFFICE_PHONE_6 = 'T_OFFICE_PHONE_6',
  T_OFFICE_PHONE_7 = 'T_OFFICE_PHONE_7',
  T_OFFICE_PHONE_8 = 'T_OFFICE_PHONE_8',
  T_OFFICE_PHONE_9 = 'T_OFFICE_PHONE_9',
  T_OFFICE_PHONE_10 = 'T_OFFICE_PHONE_10',
  T_SEND_FOLLOW_UP_1 = 'T_SEND_FOLLOW_UP_1',
  T_SEND_FOLLOW_UP_2 = 'T_SEND_FOLLOW_UP_2',
  T_SEND_FOLLOW_UP_3 = 'T_SEND_FOLLOW_UP_3',
  T_SEND_FOLLOW_UP_4 = 'T_SEND_FOLLOW_UP_4',
  T_SEND_FOLLOW_UP_5 = 'T_SEND_FOLLOW_UP_5',
  T_SEND_FOLLOW_UP_6 = 'T_SEND_FOLLOW_UP_6',
  T_SEND_VIRTUAL_SHOWING_REMINDER_1 = 'T_SEND_VIRTUAL_SHOWING_REMINDER_1',
  T_SEND_VIRTUAL_SHOWING_REMINDER_2 = 'T_SEND_VIRTUAL_SHOWING_REMINDER_2',
  T_SEND_VIRTUAL_SHOWING_REMINDER_3 = 'T_SEND_VIRTUAL_SHOWING_REMINDER_3',
  T_SENIOR_HOUSING_1 = 'T_SENIOR_HOUSING_1',
  T_SENIOR_HOUSING_2 = 'T_SENIOR_HOUSING_2',
  T_SENIOR_HOUSING_3 = 'T_SENIOR_HOUSING_3',
  T_SENIOR_HOUSING_4 = 'T_SENIOR_HOUSING_4',
  T_SERVICE_ANIMALS_1 = 'T_SERVICE_ANIMALS_1',
  T_SERVICE_ANIMALS_2 = 'T_SERVICE_ANIMALS_2',
  T_SERVICE_ANIMALS_3 = 'T_SERVICE_ANIMALS_3',
  T_SHOWING_DURATION_1 = 'T_SHOWING_DURATION_1',
  T_SHOWING_DURATION_2 = 'T_SHOWING_DURATION_2',
  T_SHOWING_DURATION_3 = 'T_SHOWING_DURATION_3',
  T_SHOWING_HOURS_1 = 'T_SHOWING_HOURS_1',
  T_SHOWING_HOURS_2 = 'T_SHOWING_HOURS_2',
  T_SHOWING_HOURS_3 = 'T_SHOWING_HOURS_3',
  T_SOURCE_REFERENCE_1 = 'T_SOURCE_REFERENCE_1',
  T_SOURCE_REFERENCE_2 = 'T_SOURCE_REFERENCE_2',
  T_SOURCE_REFERENCE_3 = 'T_SOURCE_REFERENCE_3',
  T_SOURCE_REFERENCE_4 = 'T_SOURCE_REFERENCE_4',
  T_STUDENT_HOUSING_1 = 'T_STUDENT_HOUSING_1',
  T_STUDENT_HOUSING_2 = 'T_STUDENT_HOUSING_2',
  T_STUDENT_HOUSING_3 = 'T_STUDENT_HOUSING_3',
  T_STUDENT_HOUSING_4 = 'T_STUDENT_HOUSING_4',
  T_WANT_HELP_1 = 'T_WANT_HELP_1',
  T_WANT_HELP_2 = 'T_WANT_HELP_2',
  T_WANT_TO_SCHEDULE_1 = 'T_WANT_TO_SCHEDULE_1',
  T_WANT_TO_SCHEDULE_2 = 'T_WANT_TO_SCHEDULE_2',
  T_WANT_TO_SCHEDULE_3 = 'T_WANT_TO_SCHEDULE_3',
  T_WORK_FOR_YOU_1 = 'T_WORK_FOR_YOU_1',
  T_WORK_FOR_YOU_2 = 'T_WORK_FOR_YOU_2',
  T_WORK_FOR_YOU_3 = 'T_WORK_FOR_YOU_3'
}

export type Permissions = {
  __typename?: 'Permissions';
  canCreateTask: Scalars['Boolean'];
  canEditAgents: Scalars['Boolean'];
  canEditTaskDetails: Scalars['Boolean'];
  canModifyLeasingSpecials: Scalars['Boolean'];
  canModifyNotes: Scalars['Boolean'];
  canModifyOperatorShifts: Scalars['Boolean'];
  canModifySeniorOperatorShifts: Scalars['Boolean'];
  canRemoveShiftAssignment: Scalars['Boolean'];
  canResendAllowedActionViolations?: Maybe<Scalars['Boolean']>;
  canResendInvalidBodyViolations?: Maybe<Scalars['Boolean']>;
  canResendMassCancellationViolations?: Maybe<Scalars['Boolean']>;
  canResendTcpaViolations: Scalars['Boolean'];
  canRunBasicJobs: Scalars['Boolean'];
  canViewAdminPage: Scalars['Boolean'];
  canViewBotAction: Scalars['Boolean'];
  canViewCalEventUrls: Scalars['Boolean'];
  canViewCoreTaskInfo: Scalars['Boolean'];
  canViewFirmSecrets: Scalars['Boolean'];
  canViewOccupancy: Scalars['Boolean'];
  canViewSuperDashboard: Scalars['Boolean'];
  canViewSuperTaskDetails: Scalars['Boolean'];
  canViewUnitsAndMarketing: Scalars['Boolean'];
};

export type PmCampaign = {
  __typename?: 'PmCampaign';
  auditKeyJson: Scalars['String'];
  availableOnDate?: Maybe<Scalars['String']>;
  bathrooms?: Maybe<Scalars['Float']>;
  bedrooms?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  isPosted?: Maybe<Scalars['Boolean']>;
  jsonUrl: Scalars['String'];
  marketingDescription?: Maybe<Scalars['String']>;
  marketingTitle?: Maybe<Scalars['String']>;
  maxRentUSD?: Maybe<Scalars['Int']>;
  minRentUSD?: Maybe<Scalars['Int']>;
  sqft?: Maybe<Scalars['Int']>;
};

export type PmItemKey = {
  __typename?: 'PmItemKey';
  externalPmUrl?: Maybe<Scalars['String']>;
  firm: Scalars['String'];
  pmType: Scalars['String'];
  property: Scalars['String'];
};

export enum PmItemType {
  APPLICATION = 'APPLICATION',
  APPOINTMENT = 'APPOINTMENT',
  CAMPAIGN = 'CAMPAIGN',
  FIRM = 'FIRM',
  FLOOR_PLAN = 'FLOOR_PLAN',
  PROPERTY = 'PROPERTY',
  PROSPECT = 'PROSPECT',
  UNIT = 'UNIT'
}

export type PmPostableUnit = {
  __typename?: 'PmPostableUnit';
  id: Scalars['String'];
  latestJobs: Array<Job>;
  suggestedPostAction: SuggestedPostAction;
  unit: PmUnit;
};

export type PmProperty = {
  __typename?: 'PmProperty';
  apmUuid?: Maybe<Scalars['String']>;
  auditKeyJson: Scalars['String'];
  cleanAddress?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  id: Scalars['String'];
  jsonUrl: Scalars['String'];
  numUnits: Scalars['Int'];
  numUnitsUnrented: Scalars['Int'];
  pmUrl: Scalars['String'];
  propertyName?: Maybe<Scalars['String']>;
  units: Array<PmUnit>;
};

export enum PmType {
  APPFOLIO = 'APPFOLIO',
  ENTRATA = 'ENTRATA',
  FIRM_MAA = 'FIRM_MAA',
  PROPERTY_WEBSITE = 'PROPERTY_WEBSITE',
  REALPAGE = 'REALPAGE',
  RESMAN = 'RESMAN',
  YARDI = 'YARDI'
}

export type PmUnit = {
  __typename?: 'PmUnit';
  auditKeyJson: Scalars['String'];
  bathrooms?: Maybe<Scalars['Float']>;
  bedrooms?: Maybe<Scalars['Int']>;
  displayName: Scalars['String'];
  id: Scalars['String'];
  isPosted?: Maybe<Scalars['Boolean']>;
  jsonUrl: Scalars['String'];
  marketingDescription?: Maybe<Scalars['String']>;
  marketingTitle?: Maybe<Scalars['String']>;
  maxRentUSD?: Maybe<Scalars['Int']>;
  minRentUSD?: Maybe<Scalars['Int']>;
  photoUrls: Array<Scalars['String']>;
  pmUrl: Scalars['String'];
  sqft?: Maybe<Scalars['Int']>;
  status: UnitStatus;
};

export enum PolicyText {
  ADA_UNITS = 'ADA_UNITS',
  AMENITIES = 'AMENITIES',
  APPLICATION_DOCS = 'APPLICATION_DOCS',
  COSIGNERS = 'COSIGNERS',
  DISCOUNTS = 'DISCOUNTS',
  FURNISHED = 'FURNISHED',
  LAUNDRY = 'LAUNDRY',
  LEASE_TERMS = 'LEASE_TERMS',
  MOVE_IN_COST = 'MOVE_IN_COST',
  PARKING = 'PARKING',
  PETS = 'PETS',
  QUALIFICATIONS = 'QUALIFICATIONS',
  REALTOR = 'REALTOR',
  SECTION_8 = 'SECTION_8',
  UTILITIES = 'UTILITIES'
}

export enum PostJobName {
  POST = 'POST',
  UNPOST = 'UNPOST'
}

export type PropertyUserInput = {
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
};

export type ProspectVirtualTour = {
  __typename?: 'ProspectVirtualTour';
  dailyCallOptions: DailyCallOptions;
};

export type Query = {
  __typename?: 'Query';
  action: Action;
  addressAutocomplete: Array<Scalars['String']>;
  addressLookup?: Maybe<Address>;
  agentCalendar: AgentCalendar;
  agentVirtualTour?: Maybe<AgentVirtualTour>;
  allFirmTasks: Array<LeasingTask>;
  allFirms: Array<Firm>;
  allLeasingTasks: Array<LeasingTask>;
  allShowings: Array<Showing>;
  allTeams: Array<Team>;
  allUsers: Array<User>;
  apmFirm: Firm;
  apmTask?: Maybe<LeasingTask>;
  botThread?: Maybe<BotThread>;
  contact: Contact;
  contactByAddress: Contact;
  contactThread: Thread;
  countdowns: Array<BotThread>;
  entrataInfo?: Maybe<EntrataInfo>;
  errors: Array<ErrorState>;
  exchangeCreds?: Maybe<ExchangeCreds>;
  featureFlags: Array<FeatureFlag>;
  firm: Firm;
  gSuiteCreds?: Maybe<GSuiteCreds>;
  isTyping: Array<Scalars['String']>;
  jobs: Array<Job>;
  latestErrors: Array<ErrorState>;
  latestPmSyncJob?: Maybe<Job>;
  lisaSummary: LisaSummary;
  message: Message;
  messages: Array<Message>;
  msGraphCreds?: Maybe<MsGraphCreds>;
  notes: Array<Note>;
  onboardingPropertyTasks: Array<LeasingTask>;
  onboardingTasks: Array<LeasingTask>;
  prospectVirtualTour?: Maybe<ProspectVirtualTour>;
  quickActions: Array<QuickActionResult>;
  search: Array<SearchResult>;
  self: User;
  settings: Array<Setting>;
  shifts: Array<Shift>;
  showing: Showing;
  showingAvailability: ShowingAvailabilitySlots;
  statusBoard: Array<FirmServiceStatus>;
  task: LeasingTask;
  thread: Thread;
  timeseries: Array<SeriesPoint>;
  transcript?: Maybe<Transcript>;
  transcriptsByInquiry: Array<Transcript>;
  user: User;
  yardiInfo?: Maybe<YardiInfo>;
};


export type QueryActionArgs = {
  savedActionId: Scalars['Int'];
};


export type QueryAddressAutocompleteArgs = {
  prefix?: InputMaybe<Scalars['String']>;
};


export type QueryAddressLookupArgs = {
  inputAddress?: InputMaybe<Scalars['String']>;
};


export type QueryAgentCalendarArgs = {
  date?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};


export type QueryAgentVirtualTourArgs = {
  agentId: Scalars['String'];
  firmId: Scalars['String'];
  hash: Scalars['String'];
};


export type QueryAllLeasingTasksArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']>;
};


export type QueryAllShowingsArgs = {
  includePast?: InputMaybe<Scalars['Boolean']>;
};


export type QueryApmFirmArgs = {
  apmVhost: Scalars['String'];
};


export type QueryApmTaskArgs = {
  apmVhost: Scalars['String'];
  propertyId: Scalars['String'];
};


export type QueryBotThreadArgs = {
  contactId: Scalars['Int'];
  taskId: Scalars['Int'];
};


export type QueryContactArgs = {
  contactId: Scalars['Int'];
};


export type QueryContactByAddressArgs = {
  address: Scalars['String'];
};


export type QueryContactThreadArgs = {
  contactId: Scalars['Int'];
  taskId: Scalars['Int'];
};


export type QueryCountdownsArgs = {
  n: Scalars['Int'];
};


export type QueryEntrataInfoArgs = {
  firmId: Scalars['Int'];
};


export type QueryErrorsArgs = {
  errorType: ModelType;
  parentId: Scalars['Int'];
};


export type QueryExchangeCredsArgs = {
  firmId: Scalars['Int'];
};


export type QueryFeatureFlagsArgs = {
  firmId: Scalars['Int'];
};


export type QueryFirmArgs = {
  firmId: Scalars['Int'];
};


export type QueryGSuiteCredsArgs = {
  firmId: Scalars['Int'];
};


export type QueryIsTypingArgs = {
  threadId: Scalars['Int'];
};


export type QueryJobsArgs = {
  jobKey: Scalars['String'];
};


export type QueryLatestPmSyncJobArgs = {
  firmId: Scalars['Int'];
  taskId?: InputMaybe<Scalars['Int']>;
};


export type QueryLisaSummaryArgs = {
  apmVhost: Scalars['String'];
  inquiries: Array<Scalars['String']>;
};


export type QueryMessageArgs = {
  messageId: Scalars['Int'];
};


export type QueryMessagesArgs = {
  n?: InputMaybe<Scalars['Int']>;
  sinceId?: InputMaybe<Scalars['Int']>;
};


export type QueryMsGraphCredsArgs = {
  firmId: Scalars['Int'];
};


export type QueryNotesArgs = {
  noteType: ModelType;
  parentId: Scalars['Int'];
};


export type QueryOnboardingPropertyTasksArgs = {
  apmVhost: Scalars['String'];
};


export type QueryProspectVirtualTourArgs = {
  hash: Scalars['String'];
  showingContactId: Scalars['String'];
};


export type QueryQuickActionsArgs = {
  maxResults: Scalars['Int'];
  prefix: Scalars['String'];
  resetCache: Scalars['Boolean'];
  threadId: Scalars['Int'];
};


export type QuerySearchArgs = {
  prefix: Scalars['String'];
};


export type QueryShiftsArgs = {
  timeFrom: Scalars['String'];
  timeTo: Scalars['String'];
};


export type QueryShowingArgs = {
  showingId: Scalars['Int'];
};


export type QueryShowingAvailabilityArgs = {
  endDate?: InputMaybe<Scalars['String']>;
  messageId: Scalars['Int'];
  startDate?: InputMaybe<Scalars['String']>;
};


export type QueryTaskArgs = {
  taskId: Scalars['Int'];
};


export type QueryThreadArgs = {
  threadId: Scalars['Int'];
  updateLastRead?: InputMaybe<Scalars['Boolean']>;
};


export type QueryTimeseriesArgs = {
  modelFilter?: InputMaybe<ModelFilterInput>;
  tsName: TimeseriesName;
};


export type QueryTranscriptArgs = {
  threadUUID: Scalars['String'];
};


export type QueryTranscriptsByInquiryArgs = {
  apmVhost: Scalars['String'];
  inquiry: Scalars['String'];
};


export type QueryUserArgs = {
  userId: Scalars['Int'];
};


export type QueryYardiInfoArgs = {
  firmId: Scalars['Int'];
};

export enum Question {
  ADDRESS = 'ADDRESS',
  ADD_AGENT = 'ADD_AGENT',
  AMENITIES = 'AMENITIES',
  APPLICATION_DOCS = 'APPLICATION_DOCS',
  APPLICATION_LINK = 'APPLICATION_LINK',
  APPLICATION_STATUS = 'APPLICATION_STATUS',
  AVAILABLE_ON = 'AVAILABLE_ON',
  CALL_ME = 'CALL_ME',
  CANT_CALL = 'CANT_CALL',
  CAN_I_WALK_IN = 'CAN_I_WALK_IN',
  COSIGNER_POLICY = 'COSIGNER_POLICY',
  DEFINE_TOUR_TYPE_IN_PERSON = 'DEFINE_TOUR_TYPE_IN_PERSON',
  DEFINE_TOUR_TYPE_SELF_GUIDED = 'DEFINE_TOUR_TYPE_SELF_GUIDED',
  DEFINE_TOUR_TYPE_VIRTUAL = 'DEFINE_TOUR_TYPE_VIRTUAL',
  DISCOUNTS = 'DISCOUNTS',
  FAIR_HOUSING = 'FAIR_HOUSING',
  FEATURE_REQUEST = 'FEATURE_REQUEST',
  FLOOR_PLAN_LINK = 'FLOOR_PLAN_LINK',
  FURNISHED = 'FURNISHED',
  FUTURE_AVAILABILITY = 'FUTURE_AVAILABILITY',
  GO_FIX_PM_SOFTWARE = 'GO_FIX_PM_SOFTWARE',
  HANDICAPPED_UNITS = 'HANDICAPPED_UNITS',
  HOW_TO_ACCEPT_INVITE = 'HOW_TO_ACCEPT_INVITE',
  HOW_TO_ACCEPT_SHOWING_FROM_CALENDAR = 'HOW_TO_ACCEPT_SHOWING_FROM_CALENDAR',
  HOW_TO_BLOCK_YOUR_CALENDAR = 'HOW_TO_BLOCK_YOUR_CALENDAR',
  HOW_TO_START_VIRTUAL_TOUR = 'HOW_TO_START_VIRTUAL_TOUR',
  HOW_TO_UNBLOCK_YOUR_CALENDAR = 'HOW_TO_UNBLOCK_YOUR_CALENDAR',
  HOW_TO_VIEW_SHOWING_DETAILS = 'HOW_TO_VIEW_SHOWING_DETAILS',
  LAUNDRY = 'LAUNDRY',
  LEASE_TERMS = 'LEASE_TERMS',
  LEASING_SPECIALS = 'LEASING_SPECIALS',
  LISTINGS = 'LISTINGS',
  MOVE_IN_COST = 'MOVE_IN_COST',
  NOT_A_BOT = 'NOT_A_BOT',
  OFFICE_PHONE = 'OFFICE_PHONE',
  PARKING = 'PARKING',
  PET_POLICY = 'PET_POLICY',
  QUALIFICATIONS = 'QUALIFICATIONS',
  REALTOR = 'REALTOR',
  REDIRECT_TO_AGENT = 'REDIRECT_TO_AGENT',
  RENT = 'RENT',
  RESIDENT = 'RESIDENT',
  SCHOOLS_NEARBY = 'SCHOOLS_NEARBY',
  SECTION8 = 'SECTION8',
  SERVICE_ANIMAL = 'SERVICE_ANIMAL',
  SHOWING_DURATION = 'SHOWING_DURATION',
  SHOWING_HOURS = 'SHOWING_HOURS',
  SQFT = 'SQFT',
  SUPPORT_REQUEST = 'SUPPORT_REQUEST',
  TOUR_TYPES_OFFERED = 'TOUR_TYPES_OFFERED',
  UNIT_UNAVAILABLE = 'UNIT_UNAVAILABLE',
  UTILITIES = 'UTILITIES',
  WHATS_YOUR_EMAIL = 'WHATS_YOUR_EMAIL',
  WHATS_YOUR_LAST_NAME = 'WHATS_YOUR_LAST_NAME',
  WHATS_YOUR_NAME = 'WHATS_YOUR_NAME',
  WHATS_YOUR_NUMBER = 'WHATS_YOUR_NUMBER',
  WHY_PHOTO_ID = 'WHY_PHOTO_ID'
}

export type QuickActionResult = {
  __typename?: 'QuickActionResult';
  action?: Maybe<Action>;
  body?: Maybe<Scalars['String']>;
  composerJson?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  hasError: Scalars['Boolean'];
  snippet: Scalars['String'];
};

export type Range = {
  __typename?: 'Range';
  lowerBound: Scalars['String'];
  upperBound: Scalars['String'];
};

export type RealpageInfo = {
  __typename?: 'RealpageInfo';
  pmFirm: Scalars['String'];
  pmType: Scalars['String'];
  pmcId: Scalars['String'];
  siteId: Scalars['String'];
};

export type RealpageInfoInput = {
  pmFirm?: InputMaybe<Scalars['String']>;
  pmType?: InputMaybe<Scalars['String']>;
  pmcId?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['String']>;
};

export type SavedAction = {
  __typename?: 'SavedAction';
  actionDisplayName: Scalars['String'];
  actionName?: Maybe<ActionName>;
  contact?: Maybe<Contact>;
  contactId?: Maybe<Scalars['Int']>;
  description: Scalars['String'];
  externalUserId?: Maybe<Scalars['String']>;
  firmId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  preview: Scalars['String'];
  summary: Scalars['String'];
  task?: Maybe<LeasingTask>;
  taskId?: Maybe<Scalars['Int']>;
  threadId?: Maybe<Scalars['Int']>;
  timeCreated: Scalars['String'];
  user?: Maybe<User>;
  uuid?: Maybe<Scalars['String']>;
  validationErrors: Array<BotActionValidationError>;
};

export type ScheduleShowingInput = {
  timeStart: Scalars['String'];
  unitType?: InputMaybe<Scalars['String']>;
};

export type SearchResult = {
  __typename?: 'SearchResult';
  deemphasize: Scalars['Boolean'];
  displayName: Scalars['String'];
  path: Scalars['String'];
  snippet: Scalars['String'];
  timeUpdated: Scalars['String'];
  type: SearchResultType;
};

export enum SearchResultType {
  TASK = 'TASK',
  TASK_FIRM = 'TASK_FIRM',
  TASK_MULTI_FAMILY = 'TASK_MULTI_FAMILY',
  TASK_SENIOR = 'TASK_SENIOR',
  TASK_SINGLE_FAMILY = 'TASK_SINGLE_FAMILY',
  TASK_STUDENT = 'TASK_STUDENT',
  THREAD = 'THREAD',
  THREAD_AGENT = 'THREAD_AGENT',
  THREAD_BOSS = 'THREAD_BOSS',
  THREAD_PROSPECT = 'THREAD_PROSPECT'
}

export enum SendQueue {
  IMMEDIATE = 'IMMEDIATE',
  IMMEDIATE_NO_ADVANCE_NOTICE = 'IMMEDIATE_NO_ADVANCE_NOTICE',
  SCHEDULED = 'SCHEDULED'
}

export type SeriesPoint = {
  __typename?: 'SeriesPoint';
  date: Scalars['String'];
  modelFilter?: Maybe<ModelFilter>;
  tsName: TimeseriesName;
  value: Scalars['Float'];
};

export type Setting = {
  __typename?: 'Setting';
  description: Scalars['String'];
  id: Scalars['Int'];
  key: Scalars['String'];
  timeCreated: Scalars['String'];
  value: Scalars['String'];
};

export type Shift = {
  __typename?: 'Shift';
  id: Scalars['Int'];
  maxNumSlots: Scalars['Int'];
  numAvailableSlots: Scalars['Int'];
  operatorShifts: Array<OperatorShift>;
  operatorsSnippet: Scalars['String'];
  shiftType: ShiftType;
  timeEnd: Scalars['String'];
  timeStart: Scalars['String'];
};

export enum ShiftType {
  OPERATOR = 'OPERATOR',
  SENIOR_OPERATOR = 'SENIOR_OPERATOR'
}

export type Showing = {
  __typename?: 'Showing';
  calEvent?: Maybe<CalEvent>;
  calEventUrl?: Maybe<Scalars['String']>;
  history: Array<ShowingContactHistory>;
  id: Scalars['Int'];
  leasingTask: LeasingTask;
  leasingTaskId: Scalars['Int'];
  showingContacts: Array<ShowingContact>;
  showingContactsPlanningToAttend: Array<ShowingContact>;
  showingStatus: ShowingStatus;
  timeCreated: Scalars['String'];
  timeStart: Scalars['String'];
  tourType?: Maybe<TourType>;
  unitType?: Maybe<UnitType>;
};

export type ShowingAvailabilitySlot = {
  __typename?: 'ShowingAvailabilitySlot';
  timeStart: Scalars['String'];
};

export type ShowingAvailabilitySlots = {
  __typename?: 'ShowingAvailabilitySlots';
  closestAfterEnd?: Maybe<ShowingAvailabilitySlot>;
  closestBeforeStart?: Maybe<ShowingAvailabilitySlot>;
  earliestAvailable?: Maybe<ShowingAvailabilitySlot>;
  slots: Array<Maybe<ShowingAvailabilitySlot>>;
  timeZone: Scalars['String'];
};

export type ShowingContact = {
  __typename?: 'ShowingContact';
  calResponseStatus?: Maybe<CalResponseStatus>;
  confirmationStatus: ConfirmationStatus;
  contact: Contact;
  contactId: Scalars['Int'];
  history: Array<ShowingContactHistory>;
  isAgent: Scalars['Boolean'];
  showingId: Scalars['Int'];
  timeUpdated: Scalars['String'];
};

export type ShowingContactHistory = {
  __typename?: 'ShowingContactHistory';
  confirmationStatus: ConfirmationStatus;
  contactId: Scalars['Int'];
  showingId: Scalars['Int'];
  timeUpdated: Scalars['String'];
  user?: Maybe<User>;
};

export enum ShowingPolicy {
  ALWAYS = 'ALWAYS',
  DISABLED = 'DISABLED',
  NOTICE = 'NOTICE',
  VACANT = 'VACANT',
  VACANT_READY = 'VACANT_READY'
}

export enum ShowingStatus {
  CREATED = 'CREATED',
  REJECTED = 'REJECTED'
}

export type ShowingsFilterInput = {
  endDayOffset?: InputMaybe<Scalars['Int']>;
  startDayOffset?: InputMaybe<Scalars['Int']>;
  threadId?: InputMaybe<Scalars['Int']>;
};

export enum StatusMonitorType {
  CALENDAR_POLL = 'CALENDAR_POLL',
  CSV_API = 'CSV_API',
  LISA_CALENDAR_POLL = 'LISA_CALENDAR_POLL',
  PM_PROPERTY_AUDIT = 'PM_PROPERTY_AUDIT'
}

export type Subscription = {
  __typename?: 'Subscription';
  calUpdates: Array<Cal>;
  contactUpdates: Array<Contact>;
  messageUpdates: Array<Message>;
  showingUpdates: Array<Showing>;
  threadUpdates: Array<Thread>;
};


export type SubscriptionCalUpdatesArgs = {
  threadId: Scalars['Int'];
};


export type SubscriptionContactUpdatesArgs = {
  contactId: Scalars['Int'];
};


export type SubscriptionMessageUpdatesArgs = {
  threadId: Scalars['Int'];
};


export type SubscriptionShowingUpdatesArgs = {
  contactId: Scalars['Int'];
  taskId?: InputMaybe<Scalars['Int']>;
};


export type SubscriptionThreadUpdatesArgs = {
  threadId: Scalars['Int'];
};

export enum SuggestedPostAction {
  NO_ACTION_NEEDED = 'NO_ACTION_NEEDED',
  POST = 'POST',
  REPOST = 'REPOST',
  UNPOST = 'UNPOST'
}

export type TaskAgent = {
  __typename?: 'TaskAgent';
  agent: Contact;
  firmTaskThreadType: ConversationType;
  id: Scalars['String'];
  isCurrentlyWorking?: Maybe<Scalars['Boolean']>;
  numTasks: Scalars['Int'];
  onboardingRoles?: Maybe<Array<Scalars['String']>>;
  precedence?: Maybe<Scalars['Int']>;
  workHours?: Maybe<Scalars['String']>;
};

export enum TaskType {
  GENERIC_TASK = 'GENERIC_TASK',
  LEASING_FIRM = 'LEASING_FIRM',
  LEASING_PROPERTY = 'LEASING_PROPERTY',
  OPERATOR_DRAFT = 'OPERATOR_DRAFT'
}

export type Team = {
  __typename?: 'Team';
  id: Scalars['Int'];
  name: Scalars['String'];
  slackChannelId?: Maybe<Scalars['String']>;
};

export type Thread = {
  __typename?: 'Thread';
  additionalOccupants?: Maybe<Scalars['Int']>;
  addressThem: Scalars['String'];
  addressUs: Scalars['String'];
  archiveUntil?: Maybe<Scalars['String']>;
  botStatus: ThreadBotStatus;
  botThread?: Maybe<BotThread>;
  calView?: Maybe<CalView>;
  calendar?: Maybe<Cal>;
  contactThem: Contact;
  conversationType: ConversationType;
  id: Scalars['Int'];
  isAgentSteppedIn: Scalars['Boolean'];
  isArchived: Scalars['Boolean'];
  isTyping: Array<Scalars['String']>;
  isUnsubscribed: Scalars['Boolean'];
  lastInboundMessageId: Scalars['Int'];
  lastInboundMessageTime: Scalars['String'];
  lastMessageId: Scalars['Int'];
  lastMessageInbound: Scalars['Boolean'];
  lastMessageSnippet?: Maybe<Scalars['String']>;
  lastMessageTime?: Maybe<Scalars['String']>;
  lastReadMessageId: Scalars['Int'];
  leasingAttributionSource: LeasingAttributionSource;
  leasingTask: LeasingTask;
  messageType: MessageType;
  messages: Array<Message>;
  messagesWithLinks: MessagesWithLinks;
  moveInDate?: Maybe<Scalars['String']>;
  pmItemKeyJsons: Array<Scalars['String']>;
  preferredTourType?: Maybe<TourType>;
  prospectId?: Maybe<Scalars['String']>;
  recentActions: Array<SavedAction>;
  relatedThreads: Array<Thread>;
  sortTime: Scalars['String'];
  taskName: Scalars['String'];
  timeCreated: Scalars['String'];
  transcriptUrl: Scalars['String'];
  unitTypesInterested: Array<UnitType>;
  uuid: Scalars['String'];
};


export type ThreadMessagesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


export type ThreadMessagesWithLinksArgs = {
  loadOptions?: InputMaybe<MessageLoadOptionsInput>;
};


export type ThreadRecentActionsArgs = {
  limit: Scalars['Int'];
};

export enum ThreadBotStatus {
  ACTIVE = 'ACTIVE',
  FIRM_BLOCKED = 'FIRM_BLOCKED',
  STOPPED = 'STOPPED'
}

export enum TimeseriesName {
  CONVERSION_ACCEPTED_CONFIRMED = 'CONVERSION_ACCEPTED_CONFIRMED',
  CONVERSION_LEAD_CONFIRMED = 'CONVERSION_LEAD_CONFIRMED',
  CONVERSION_LEAD_OFFERED = 'CONVERSION_LEAD_OFFERED',
  CONVERSION_OFFERED_ACCEPTED = 'CONVERSION_OFFERED_ACCEPTED',
  FAILED_INBOUND_SMS = 'FAILED_INBOUND_SMS',
  FAILED_INBOUND_VOICE = 'FAILED_INBOUND_VOICE',
  ILS_LANDLINE_ONLY = 'ILS_LANDLINE_ONLY',
  MARKETING_SWITCH = 'MARKETING_SWITCH',
  MESSAGES = 'MESSAGES',
  OCCUPANCY = 'OCCUPANCY',
  SHOWABLE_UNIT_COUNT = 'SHOWABLE_UNIT_COUNT',
  SHOWINGS = 'SHOWINGS',
  TURING_TEST_FAIL = 'TURING_TEST_FAIL',
  UNIMPORTED_FAILED_INBOUND_SMS = 'UNIMPORTED_FAILED_INBOUND_SMS',
  UNIMPORTED_FAILED_INBOUND_VOICE = 'UNIMPORTED_FAILED_INBOUND_VOICE',
  UNIT_COUNT = 'UNIT_COUNT'
}

export enum TourType {
  IN_PERSON = 'IN_PERSON',
  SELF_GUIDED = 'SELF_GUIDED',
  VIRTUAL = 'VIRTUAL'
}

export type Transcript = {
  __typename?: 'Transcript';
  hidePhotoId: Scalars['Boolean'];
  lisaActive?: Maybe<Scalars['Boolean']>;
  messages: Array<Message>;
  showingContactHistories: Array<ShowingContactHistory>;
  showings: Array<Showing>;
  thread: Thread;
  timezone: Scalars['String'];
};

export enum UnitStatus {
  OCCUPIED_NO_NOTICE = 'OCCUPIED_NO_NOTICE',
  OCCUPIED_RENTED_NOTICE = 'OCCUPIED_RENTED_NOTICE',
  OCCUPIED_UNRENTED_NOTICE = 'OCCUPIED_UNRENTED_NOTICE',
  VACANT_RENTED = 'VACANT_RENTED',
  VACANT_RENTED_READY = 'VACANT_RENTED_READY',
  VACANT_UNRENTED = 'VACANT_UNRENTED',
  VACANT_UNRENTED_READY = 'VACANT_UNRENTED_READY'
}

export enum UnitType {
  BR1 = 'BR1',
  BR2 = 'BR2',
  BR3 = 'BR3',
  BR4 = 'BR4',
  BR5PLUS = 'BR5PLUS',
  STUDIO = 'STUDIO'
}

export type User = {
  __typename?: 'User';
  activeOperatorShift?: Maybe<OperatorShift>;
  adpFirstName?: Maybe<Scalars['String']>;
  adpLastName?: Maybe<Scalars['String']>;
  adpUserId?: Maybe<Scalars['String']>;
  autoStationAssignmentEnabled: Scalars['Boolean'];
  clockOutSurvey?: Maybe<OperatorSurvey>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  githubUsername?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isClockedIn: Scalars['Boolean'];
  lastName?: Maybe<Scalars['String']>;
  lookingAtUser?: Maybe<User>;
  mostRecentClockEvent?: Maybe<OperatorClockEvent>;
  name: Scalars['String'];
  nextShift?: Maybe<Shift>;
  oldestUnarchivedMessageTimeCreated?: Maybe<Scalars['String']>;
  operatorCal: OperatorCal;
  pagerDutyId?: Maybe<Scalars['String']>;
  permissions: Permissions;
  phone?: Maybe<Scalars['String']>;
  recentClockEvents: Array<OperatorClockEvent>;
  slackUserId?: Maybe<Scalars['String']>;
  team?: Maybe<Team>;
  teamName?: Maybe<Scalars['String']>;
  unarchivedMessageCount: Scalars['Int'];
  unarchivedThreads: Array<Thread>;
  userType: UserType;
};


export type UserOperatorCalArgs = {
  timeFrom?: InputMaybe<Scalars['String']>;
  timeTo?: InputMaybe<Scalars['String']>;
};


export type UserRecentClockEventsArgs = {
  count: Scalars['Int'];
};

export type UserInput = {
  adpFirstName?: InputMaybe<Scalars['String']>;
  adpLastName?: InputMaybe<Scalars['String']>;
  adpUserId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  githubUsername?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  maxNumShifts?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  pagerDutyId?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  slackUserId?: InputMaybe<Scalars['String']>;
  teamName?: InputMaybe<Scalars['String']>;
  userType: UserType;
};

export enum UserType {
  ANALYST = 'ANALYST',
  BPO_CUSTOMER_STEWARD = 'BPO_CUSTOMER_STEWARD',
  BPO_CUSTOMER_STEWARD_TRAINING = 'BPO_CUSTOMER_STEWARD_TRAINING',
  BPO_OPERATOR = 'BPO_OPERATOR',
  BPO_TRAINING = 'BPO_TRAINING',
  CUSTOMER_STEWARD = 'CUSTOMER_STEWARD',
  CUSTOMER_STEWARD_TRAINING = 'CUSTOMER_STEWARD_TRAINING',
  DISABLED = 'DISABLED',
  ENGINEER = 'ENGINEER',
  OPERATOR = 'OPERATOR',
  OPS_MANAGER = 'OPS_MANAGER',
  SALES = 'SALES',
  SENIOR_OPERATOR = 'SENIOR_OPERATOR',
  SUPPORT = 'SUPPORT',
  SUPPORT_LIMITED = 'SUPPORT_LIMITED',
  TEAM_LEAD = 'TEAM_LEAD',
  TRAINING = 'TRAINING'
}

export enum VoiceCallStatus {
  ANSWERED = 'ANSWERED',
  AUTOMATED = 'AUTOMATED',
  BUSY = 'BUSY',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  MISSED = 'MISSED',
  NO_ANSWER = 'NO_ANSWER',
  ROUTED = 'ROUTED'
}

export enum WarnLevel {
  ERROR = 'ERROR',
  OK = 'OK',
  WARN = 'WARN'
}

export type YardiInfo = {
  __typename?: 'YardiInfo';
  apiEntity: Scalars['String'];
  apiLicenseKey: Scalars['String'];
  database: Scalars['String'];
  databasePlatform: Scalars['String'];
  password: Scalars['String'];
  pmFirm: Scalars['String'];
  pmType: Scalars['String'];
  serverName: Scalars['String'];
  serviceUrl: Scalars['String'];
};

export type YardiInfoInput = {
  apiEntity?: InputMaybe<Scalars['String']>;
  apiLicenseKey?: InputMaybe<Scalars['String']>;
  database?: InputMaybe<Scalars['String']>;
  databasePlatform?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  pmFirm?: InputMaybe<Scalars['String']>;
  pmType?: InputMaybe<Scalars['String']>;
  serverName?: InputMaybe<Scalars['String']>;
  serviceUrl?: InputMaybe<Scalars['String']>;
};

export type FetchFirmTasksQueryVariables = Exact<{
  firmId: Scalars['Int'];
}>;


export type FetchFirmTasksQuery = { __typename?: 'Query', firm: { __typename?: 'Firm', id: number, tasks: Array<{ __typename?: 'LeasingTask', id: number, displayName: string, isArchived: boolean, timeCreated: string, launchDate?: string | null, offboardDate?: string | null, taskType: TaskType, leasingInfo?: { __typename?: 'LeasingInfo', propertyType?: LeasePropertyType | null } | null }> } };

export type RunAdminTaskTestMutationVariables = Exact<{
  argumentsJson: Scalars['String'];
}>;


export type RunAdminTaskTestMutation = { __typename?: 'Mutation', runAdminTask: string };

export type FetchJobsTestQueryVariables = Exact<{
  jobKey: Scalars['String'];
}>;


export type FetchJobsTestQuery = { __typename?: 'Query', jobs: Array<{ __typename?: 'Job', id: string, jobName: JobName, jobKey: string, jobStatus: JobStatus, timeCreated: string, timeFinished?: string | null }> };

export type FetchAgentCalendarQueryVariables = Exact<{
  id: Scalars['String'];
  date?: InputMaybe<Scalars['String']>;
}>;


export type FetchAgentCalendarQuery = { __typename?: 'Query', agentCalendar: { __typename?: 'AgentCalendar', date: string, isToday: boolean, startOfDay: string, endOfDay: string, timeZone: string, contact: { __typename?: 'Contact', id: number, firstName?: string | null, lastName?: string | null, displayName: string, addressEmail?: string | null }, workHours: Array<{ __typename?: 'Range', lowerBound: string, upperBound: string }>, offHours: Array<{ __typename?: 'Range', lowerBound: string, upperBound: string }>, calEvents: Array<{ __typename?: 'CalEvent', timeCreated: string, timeStart: string, timeEnd: string, summary?: string | null, showingId?: number | null, source?: string | null, attendees: Array<{ __typename?: 'Attendee', calId: string, responseStatus: CalResponseStatus }> }>, showings: Array<{ __typename?: 'Showing', id: number, timeStart: string, showingStatus: ShowingStatus, unitType?: UnitType | null, tourType?: TourType | null, history: Array<{ __typename?: 'ShowingContactHistory', contactId: number, confirmationStatus: ConfirmationStatus, timeUpdated: string }>, showingContacts: Array<{ __typename?: 'ShowingContact', confirmationStatus: ConfirmationStatus, isAgent: boolean, timeUpdated: string, contact: { __typename?: 'Contact', id: number, firstName?: string | null, lastName?: string | null, addressPhone?: string | null, addressEmail?: string | null, preferMessageType: MessageType, threads: Array<{ __typename?: 'Thread', transcriptUrl: string, messageType: MessageType, leasingTask: { __typename?: 'LeasingTask', id: number } }> } }>, leasingTask: { __typename?: 'LeasingTask', id: number, displayName: string, address?: { __typename?: 'Address', addressParts: { __typename?: 'AddressParts', street: string, city: string, state: string } } | null, floorPlans: Array<{ __typename?: 'FloorPlan', bedrooms?: number | null }>, leasingInfo?: { __typename?: 'LeasingInfo', showingDurationMins?: number | null, propertyType?: LeasePropertyType | null } | null, firm: { __typename?: 'Firm', showingDurationMins?: number | null } } }> } };

export type FetchAllUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchAllUsersQuery = { __typename?: 'Query', allUsers: Array<{ __typename?: 'User', id: number, userType: UserType, slackUserId?: string | null, githubUsername?: string | null, pagerDutyId?: string | null }> };

export type FetchTranscriptQueryVariables = Exact<{
  threadUUID: Scalars['String'];
}>;


export type FetchTranscriptQuery = { __typename?: 'Query', transcript?: { __typename?: 'Transcript', timezone: string, hidePhotoId: boolean, thread: { __typename?: 'Thread', id: number, addressThem: string, pmItemKeyJsons: Array<string>, leasingTask: { __typename?: 'LeasingTask', id: number }, relatedThreads: Array<{ __typename?: 'Thread', id: number, taskName: string, messageType: MessageType, lastInboundMessageTime: string, uuid: string }>, contactThem: { __typename?: 'Contact', firstName?: string | null, lastName?: string | null, addressPhone?: string | null, addressEmail?: string | null } }, showings: Array<{ __typename?: 'Showing', id: number, leasingTaskId: number, timeStart: string }>, showingContactHistories: Array<{ __typename?: 'ShowingContactHistory', showingId: number, confirmationStatus: ConfirmationStatus, timeUpdated: string }>, messages: Array<{ __typename?: 'Message', id: number, timeCreated: string, isInbound: boolean, messageType: MessageType, messageStatus: MessageStatus, classification?: string | null, routedTo?: string | null, leasingAttributionSource?: string | null, leasingAttributionSourceDisplayName?: string | null, addressFrom: string, addressTo: string, censoredShortBody: string, censoredTranslatedShortBody?: string | null, isIlsInbound?: boolean | null, mediaUrl?: string | null }> } | null };

export type FetchAgentVirtualTourQueryVariables = Exact<{
  agentId: Scalars['String'];
  firmId: Scalars['String'];
  hash: Scalars['String'];
}>;


export type FetchAgentVirtualTourQuery = { __typename?: 'Query', agentVirtualTour?: { __typename?: 'AgentVirtualTour', calendarLink: string, contact: { __typename?: 'Contact', id: number, firstName?: string | null }, showing?: { __typename?: 'Showing', id: number, unitType?: UnitType | null, leasingTask: { __typename?: 'LeasingTask', id: number, displayName: string }, showingContactsPlanningToAttend: Array<{ __typename?: 'ShowingContact', isAgent: boolean, contact: { __typename?: 'Contact', id: number, firstName?: string | null, lastName?: string | null } }>, calEvent?: { __typename?: 'CalEvent', id: string, timeStart: string, timeEnd: string } | null } | null, dailyCallOptions?: { __typename?: 'DailyCallOptions', url: string, token: string } | null } | null };

export type FetchProspectVirtualTourQueryVariables = Exact<{
  showingContactId: Scalars['String'];
  hash: Scalars['String'];
}>;


export type FetchProspectVirtualTourQuery = { __typename?: 'Query', prospectVirtualTour?: { __typename?: 'ProspectVirtualTour', dailyCallOptions: { __typename?: 'DailyCallOptions', url: string, token: string } } | null };

export type AddressFragment = { __typename?: 'Address', id: number, addressParts: { __typename?: 'AddressParts', street: string, city: string, state: string, zipcode: string }, geolocation: { __typename?: 'Geolocation', latitude: number, longitude: number, tzName: string } };

export type BotThreadFragment = { __typename?: 'BotThread', sendTime?: string | null, showCountdown: boolean, action?: { __typename?: 'Action', actionName: ActionName, preview: string, classification: string, sendQueue: SendQueue, commandJsons: Array<string>, uuid?: string | null, logSummary: string, hasArchiveCommand: boolean, hasSnoozeCommand: boolean, llmAction?: boolean | null, commandTypes: Array<CommandType>, commandPreviews: Array<string> } | null };

export type ContactFragment = { __typename?: 'Contact', id: number, firstName?: string | null, lastName?: string | null, addressEmail?: string | null, addressPhone?: string | null, workHours: string, language?: Language | null };

export type FirmFragment = { __typename?: 'Firm', id: number, firmName: string, firmType: FirmType, pmTypes: Array<string>, pmKeyJsons: Array<string>, maxAcceptedPerShowing?: number | null, showingDurationMins?: number | null, acceptSection8?: boolean | null, tourTypes: Array<TourType>, showingPolicy?: ShowingPolicy | null, section8Text?: string | null, qualificationText?: string | null, petPolicyText?: string | null, moveInCostText?: string | null, discountsText?: string | null, applicationDocsText?: string | null, leaseTermsText?: string | null, cosignerPolicyText?: string | null, realtorText?: string | null, officePhone?: string | null, propertyListingsUrl?: string | null, englishConversationOnly?: boolean | null, headsUpText?: string | null };

export type ExchangeCredsFragment = { __typename?: 'ExchangeCreds', email: string, ewsUrl: string, userName?: string | null, password?: string | null };

export type MsGraphCredsFragment = { __typename?: 'MsGraphCreds', email: string, clientId: string, tokenCache?: string | null, homeAccountId?: string | null, clientSecret?: string | null, password?: string | null };

export type GSuiteCredsFragment = { __typename?: 'GSuiteCreds', email: string, clientId?: string | null, refreshToken?: string | null, password?: string | null };

export type BasicPmInfoFragment = { __typename?: 'BasicPmInfo', pmType: string, pmFirm: string };

export type ApmInfoFragment = { __typename?: 'ApmInfo', pmType: string, pmFirm: string, additionalVhosts: Array<string>, showingsNotifyTenant: boolean };

export type EntrataInfoFragment = { __typename?: 'EntrataInfo', pmType: string, pmFirm: string, username: string, password: string };

export type YardiInfoFragment = { __typename?: 'YardiInfo', pmType: string, pmFirm: string, serviceUrl: string, serverName: string, database: string, databasePlatform: string, apiEntity: string, apiLicenseKey: string, password: string };

export type LeasingTaskFragment = { __typename?: 'LeasingTask', id: number, displayName: string, addressPhone?: string | null, addressEmail?: string | null, isArchived: boolean, taskType: TaskType, isBotDisabled: boolean, launchDate?: string | null, hasLaunched: boolean, offboardDate?: string | null, hasOffboarded: boolean, showingHours?: string | null, firmTaskId?: number | null, numUnits?: number | null, streetViewAddress?: string | null, primaryPmKeyJson?: string | null, tourTypes: Array<TourType>, address?: { __typename?: 'Address', id: number, addressParts: { __typename?: 'AddressParts', street: string, city: string, state: string, zipcode: string }, geolocation: { __typename?: 'Geolocation', latitude: number, longitude: number, tzName: string } } | null, firm: { __typename?: 'Firm', id: number, firmName: string, firmType: FirmType, pmTypes: Array<string>, pmKeyJsons: Array<string>, maxAcceptedPerShowing?: number | null, showingDurationMins?: number | null, acceptSection8?: boolean | null, tourTypes: Array<TourType>, showingPolicy?: ShowingPolicy | null, section8Text?: string | null, qualificationText?: string | null, petPolicyText?: string | null, moveInCostText?: string | null, discountsText?: string | null, applicationDocsText?: string | null, leaseTermsText?: string | null, cosignerPolicyText?: string | null, realtorText?: string | null, officePhone?: string | null, propertyListingsUrl?: string | null, englishConversationOnly?: boolean | null, headsUpText?: string | null }, taskAgents: Array<{ __typename?: 'TaskAgent', id: string, precedence?: number | null, numTasks: number, firmTaskThreadType: ConversationType, workHours?: string | null, agent: { __typename?: 'Contact', id: number, firstName?: string | null, lastName?: string | null, addressEmail?: string | null, addressPhone?: string | null, workHours: string, language?: Language | null } }>, leasingInfo?: { __typename?: 'LeasingInfo', buildingName?: string | null, meetingDirections?: string | null, selfGuidedMeetingDirections?: string | null, areAgentsOnsite?: boolean | null, officePhone?: string | null, acceptSection8?: boolean | null, tourTypes?: Array<TourType> | null, showingPolicy?: ShowingPolicy | null, section8Text?: string | null, applicationUrl?: string | null, propertyWebsite?: string | null, floorPlansUrl?: string | null, qualificationText?: string | null, petPolicyText?: string | null, moveInCostText?: string | null, discountsText?: string | null, applicationDocsText?: string | null, leaseTermsText?: string | null, cosignerPolicyText?: string | null, realtorText?: string | null, amenitiesText?: string | null, laundryText?: string | null, utilitiesText?: string | null, parkingText?: string | null, leasingSpecialsText?: string | null, handicappedUnitsText?: string | null, yardiPropertyCode?: string | null, propertyType?: LeasePropertyType | null, maxAcceptedPerShowing?: number | null, showingDurationMins?: number | null, isFurnished?: boolean | null, maxSimultaneousShowings?: number | null, leasingSpecials: Array<{ __typename?: 'LeasingSpecial', text: string, endDate?: string | null }> } | null };

export type LeasingTaskThreadsFragment = { __typename?: 'LeasingTask', id: number, isArchived: boolean, displayName: string, streetViewAddress?: string | null, threads: Array<{ __typename?: 'Thread', id: number, timeCreated: string, messageType: MessageType, conversationType: ConversationType, isArchived: boolean, archiveUntil?: string | null, botStatus: ThreadBotStatus, addressUs: string, addressThem: string, lastMessageId: number, lastReadMessageId: number, lastInboundMessageId: number, lastMessageInbound: boolean, lastMessageTime?: string | null, sortTime: string, preferredTourType?: TourType | null, contactThem: { __typename?: 'Contact', id: number, firstName?: string | null, lastName?: string | null, addressEmail?: string | null, addressPhone?: string | null, workHours: string, language?: Language | null }, botThread?: { __typename?: 'BotThread', showCountdown: boolean, sendTime?: string | null } | null, recentActions: Array<{ __typename?: 'SavedAction', id: number, timeCreated: string, actionName?: ActionName | null, actionDisplayName: string, summary: string, user?: { __typename?: 'User', id: number, name: string } | null }> }> };

export type MessageFragment = { __typename?: 'Message', id: number, timeCreated: string, addressFrom: string, addressTo: string, messageType: MessageType, messageStatus: MessageStatus, callStatus?: VoiceCallStatus | null, callStart?: string | null, callDuration?: number | null, isInbound: boolean, censoredShortBody: string, censoredTranslatedShortBody?: string | null, translatedEmailSubject?: string | null, emailSubject?: string | null, mediaUrl?: string | null, calEventId?: string | null, externalUrl?: string | null, errorMessage?: string | null, actionId?: number | null, actionUrl?: string | null, classification?: string | null, tags: Array<MessageTag>, outboundTags: Array<OutboundTag>, leasingAttributionSource?: string | null, messageLLMInfo?: Array<MessageTag> | null, author?: { __typename?: 'User', id: number, name: string } | null };

export type MessageUserAnnotationFragment = { __typename?: 'MessageAnnotation', id: number, timeCreated: string, classification?: string | null, tags?: Array<MessageTag> | null, user?: { __typename?: 'User', id: number, userType: UserType, name: string } | null };

export type NoteFragment = { __typename?: 'Note', id: number, timeCreated: string, body: string, messageId?: number | null, threadId?: number | null, agentName?: string | null, author: { __typename?: 'User', id: number, name: string } };

export type ErrorStateFragment = { __typename?: 'ErrorState', id: number, timeCreated: string, body: string };

export type ShowingFragment = { __typename?: 'Showing', id: number, timeCreated: string, timeStart: string, leasingTaskId: number, showingStatus: ShowingStatus, calEventUrl?: string | null, unitType?: UnitType | null, tourType?: TourType | null, showingContacts: Array<{ __typename?: 'ShowingContact', calResponseStatus?: CalResponseStatus | null, confirmationStatus: ConfirmationStatus, isAgent: boolean, timeUpdated: string, contact: { __typename?: 'Contact', id: number, firstName?: string | null, lastName?: string | null, addressEmail?: string | null, addressPhone?: string | null, workHours: string, language?: Language | null } }> };

export type ShowingContactHistoryFragment = { __typename?: 'ShowingContactHistory', timeUpdated: string, contactId: number, confirmationStatus: ConfirmationStatus, user?: { __typename?: 'User', id: number, name: string } | null };

export type ThreadFragment = { __typename?: 'Thread', id: number, timeCreated: string, messageType: MessageType, conversationType: ConversationType, isArchived: boolean, archiveUntil?: string | null, botStatus: ThreadBotStatus, addressUs: string, addressThem: string, lastMessageId: number, lastReadMessageId: number, lastInboundMessageId: number, lastMessageInbound: boolean, lastMessageTime?: string | null, sortTime: string, preferredTourType?: TourType | null, contactThem: { __typename?: 'Contact', id: number, firstName?: string | null, lastName?: string | null, addressEmail?: string | null, addressPhone?: string | null, workHours: string, language?: Language | null }, botThread?: { __typename?: 'BotThread', showCountdown: boolean, sendTime?: string | null } | null, recentActions: Array<{ __typename?: 'SavedAction', id: number, timeCreated: string, actionName?: ActionName | null, actionDisplayName: string, summary: string, user?: { __typename?: 'User', id: number, name: string } | null }> };

export type MessagesWithLinksFragment = { __typename?: 'MessagesWithLinks', waitingForShowing: boolean, messages: Array<{ __typename?: 'Message', id: number, timeCreated: string, addressFrom: string, addressTo: string, messageType: MessageType, messageStatus: MessageStatus, callStatus?: VoiceCallStatus | null, callStart?: string | null, callDuration?: number | null, isInbound: boolean, censoredShortBody: string, censoredTranslatedShortBody?: string | null, translatedEmailSubject?: string | null, emailSubject?: string | null, mediaUrl?: string | null, calEventId?: string | null, externalUrl?: string | null, errorMessage?: string | null, actionId?: number | null, actionUrl?: string | null, classification?: string | null, tags: Array<MessageTag>, outboundTags: Array<OutboundTag>, leasingAttributionSource?: string | null, messageLLMInfo?: Array<MessageTag> | null, author?: { __typename?: 'User', id: number, name: string } | null }>, messageLinks: Array<{ __typename?: 'MessageLink', phrase: string, link: { __typename: 'FloorPlanLink', leasingTask: { __typename?: 'LeasingTask', id: number, displayName: string } } | { __typename: 'LeasingTaskLink', leasingTask: { __typename?: 'LeasingTask', id: number, leasingInfo?: { __typename?: 'LeasingInfo', propertyType?: LeasePropertyType | null } | null } } }> };

export type ThreadMessagesFragment = { __typename?: 'Thread', id: number, messageType: MessageType, conversationType: ConversationType, addressUs: string, addressThem: string, isArchived: boolean, archiveUntil?: string | null, botStatus: ThreadBotStatus, lastMessageId: number, lastReadMessageId: number, lastMessageInbound: boolean, unitTypesInterested: Array<UnitType>, moveInDate?: string | null, additionalOccupants?: number | null, leasingAttributionSource: LeasingAttributionSource, messagesWithLinks: { __typename?: 'MessagesWithLinks', waitingForShowing: boolean, messages: Array<{ __typename?: 'Message', id: number, timeCreated: string, addressFrom: string, addressTo: string, messageType: MessageType, messageStatus: MessageStatus, callStatus?: VoiceCallStatus | null, callStart?: string | null, callDuration?: number | null, isInbound: boolean, censoredShortBody: string, censoredTranslatedShortBody?: string | null, translatedEmailSubject?: string | null, emailSubject?: string | null, mediaUrl?: string | null, calEventId?: string | null, externalUrl?: string | null, errorMessage?: string | null, actionId?: number | null, actionUrl?: string | null, classification?: string | null, tags: Array<MessageTag>, outboundTags: Array<OutboundTag>, leasingAttributionSource?: string | null, messageLLMInfo?: Array<MessageTag> | null, author?: { __typename?: 'User', id: number, name: string } | null }>, messageLinks: Array<{ __typename?: 'MessageLink', phrase: string, link: { __typename: 'FloorPlanLink', leasingTask: { __typename?: 'LeasingTask', id: number, displayName: string } } | { __typename: 'LeasingTaskLink', leasingTask: { __typename?: 'LeasingTask', id: number, leasingInfo?: { __typename?: 'LeasingInfo', propertyType?: LeasePropertyType | null } | null } } }> }, botThread?: { __typename?: 'BotThread', sendTime?: string | null, showCountdown: boolean, action?: { __typename?: 'Action', actionName: ActionName, preview: string, classification: string, sendQueue: SendQueue, commandJsons: Array<string>, uuid?: string | null, logSummary: string, hasArchiveCommand: boolean, hasSnoozeCommand: boolean, llmAction?: boolean | null, commandTypes: Array<CommandType>, commandPreviews: Array<string> } | null } | null, contactThem: { __typename?: 'Contact', id: number, firstName?: string | null, lastName?: string | null, addressEmail?: string | null, addressPhone?: string | null, workHours: string, language?: Language | null }, calendar?: { __typename?: 'Cal', id: string, timeLastAccess?: string | null } | null };

export type UserFragment = { __typename?: 'User', id: number, name: string, userType: UserType, permissions: { __typename?: 'Permissions', canViewAdminPage: boolean, canModifyLeasingSpecials: boolean, canModifyNotes: boolean, canViewSuperDashboard: boolean, canViewSuperTaskDetails: boolean, canViewCoreTaskInfo: boolean, canViewCalEventUrls: boolean, canCreateTask: boolean, canViewBotAction: boolean, canEditAgents: boolean, canModifyOperatorShifts: boolean, canModifySeniorOperatorShifts: boolean, canRunBasicJobs: boolean, canViewOccupancy: boolean, canEditTaskDetails: boolean, canViewUnitsAndMarketing: boolean, canResendTcpaViolations: boolean, canResendMassCancellationViolations?: boolean | null, canResendAllowedActionViolations?: boolean | null, canResendInvalidBodyViolations?: boolean | null } };

export type UserAdminDetailsFragment = { __typename?: 'User', id: number, phone?: string | null, email: string, name: string, userType: UserType, adpUserId?: string | null, adpFirstName?: string | null, adpLastName?: string | null, slackUserId?: string | null, githubUsername?: string | null, pagerDutyId?: string | null, teamName?: string | null, permissions: { __typename?: 'Permissions', canViewAdminPage: boolean, canModifyLeasingSpecials: boolean, canModifyNotes: boolean, canViewSuperDashboard: boolean, canViewSuperTaskDetails: boolean, canViewCoreTaskInfo: boolean, canViewCalEventUrls: boolean, canCreateTask: boolean, canViewBotAction: boolean, canEditAgents: boolean, canRunBasicJobs: boolean, canViewOccupancy: boolean, canEditTaskDetails: boolean, canViewUnitsAndMarketing: boolean, canResendTcpaViolations: boolean, canResendMassCancellationViolations?: boolean | null, canResendAllowedActionViolations?: boolean | null, canResendInvalidBodyViolations?: boolean | null, canModifyOperatorShifts: boolean, canModifySeniorOperatorShifts: boolean } };

export type ActionToExecFragment = { __typename?: 'Action', actionName: ActionName, preview: string, classification: string, sendQueue: SendQueue, commandJsons: Array<string>, uuid?: string | null, logSummary: string, hasArchiveCommand: boolean, hasSnoozeCommand: boolean, llmAction?: boolean | null, commandTypes: Array<CommandType>, commandPreviews: Array<string> };

export type LookingAtFragmentFragment = { __typename?: 'User', lookingAtUser?: { __typename?: 'User', id: number, name: string } | null };

export type ThreadListItemFragment = { __typename?: 'Thread', id: number, conversationType: ConversationType, isArchived: boolean, botStatus: ThreadBotStatus, lastReadMessageId: number, lastInboundMessageId: number, lastMessageInbound: boolean, sortTime: string, contactThem: { __typename?: 'Contact', id: number, firstName?: string | null, lastName?: string | null, addressEmail?: string | null, addressPhone?: string | null }, botThread?: { __typename?: 'BotThread', showCountdown: boolean, sendTime?: string | null } | null };

export type ThreadLeasingTaskFragment = { __typename?: 'LeasingTask', id: number, displayName: string, isArchived: boolean, taskType: TaskType, isBotDisabled: boolean, launchDate?: string | null, hasLaunched: boolean, offboardDate?: string | null, hasOffboarded: boolean, showingHours?: string | null, firmTaskId?: number | null, tourTypes: Array<TourType>, holidays?: string | null, address?: { __typename?: 'Address', id: number, geolocation: { __typename?: 'Geolocation', tzName: string } } | null, firm: { __typename?: 'Firm', id: number, firmName: string, pmTypes: Array<string>, englishConversationOnly?: boolean | null, headsUpText?: string | null }, leasingInfo?: { __typename?: 'LeasingInfo', areAgentsOnsite?: boolean | null, propertyWebsite?: string | null, propertyType?: LeasePropertyType | null, leasingSpecials: Array<{ __typename?: 'LeasingSpecial', text: string, endDate?: string | null }> } | null };

export type TaskListItemFragment = { __typename?: 'LeasingTask', id: number, isArchived: boolean, displayName: string, streetViewAddress?: string | null, leasingInfo?: { __typename?: 'LeasingInfo', propertyType?: LeasePropertyType | null } | null, threads: Array<{ __typename?: 'Thread', id: number, conversationType: ConversationType, isArchived: boolean, botStatus: ThreadBotStatus, lastReadMessageId: number, lastInboundMessageId: number, lastMessageInbound: boolean, sortTime: string, contactThem: { __typename?: 'Contact', id: number, firstName?: string | null, lastName?: string | null, addressEmail?: string | null, addressPhone?: string | null }, botThread?: { __typename?: 'BotThread', showCountdown: boolean, sendTime?: string | null } | null }> };

export type TaskDetailFragment = { __typename?: 'LeasingTask', addressPhone?: string | null, addressEmail?: string | null, taskType: TaskType, isBotDisabled: boolean, launchDate?: string | null, hasLaunched: boolean, offboardDate?: string | null, hasOffboarded: boolean, showingHours?: string | null, firmTaskId?: number | null, streetViewAddress?: string | null, primaryPmKeyJson?: string | null, tourTypes: Array<TourType>, address?: { __typename?: 'Address', id: number, addressParts: { __typename?: 'AddressParts', street: string, city: string, state: string, zipcode: string }, geolocation: { __typename?: 'Geolocation', tzName: string } } | null, firm: { __typename?: 'Firm', id: number, firmName: string, pmTypes: Array<string>, pmKeyJsons: Array<string>, maxAcceptedPerShowing?: number | null, showingDurationMins?: number | null, acceptSection8?: boolean | null, tourTypes: Array<TourType>, showingPolicy?: ShowingPolicy | null, section8Text?: string | null, qualificationText?: string | null, petPolicyText?: string | null, moveInCostText?: string | null, discountsText?: string | null, applicationDocsText?: string | null, leaseTermsText?: string | null, cosignerPolicyText?: string | null, realtorText?: string | null, officePhone?: string | null, propertyListingsUrl?: string | null }, taskAgents: Array<{ __typename?: 'TaskAgent', id: string, precedence?: number | null, numTasks: number, firmTaskThreadType: ConversationType, isCurrentlyWorking?: boolean | null, agent: { __typename?: 'Contact', id: number, firstName?: string | null, lastName?: string | null, addressEmail?: string | null, addressPhone?: string | null, workHours: string } }>, leasingInfo?: { __typename?: 'LeasingInfo', buildingName?: string | null, meetingDirections?: string | null, selfGuidedMeetingDirections?: string | null, areAgentsOnsite?: boolean | null, officePhone?: string | null, acceptSection8?: boolean | null, tourTypes?: Array<TourType> | null, showingPolicy?: ShowingPolicy | null, section8Text?: string | null, applicationUrl?: string | null, propertyWebsite?: string | null, floorPlansUrl?: string | null, qualificationText?: string | null, petPolicyText?: string | null, moveInCostText?: string | null, discountsText?: string | null, applicationDocsText?: string | null, leaseTermsText?: string | null, cosignerPolicyText?: string | null, realtorText?: string | null, amenitiesText?: string | null, laundryText?: string | null, utilitiesText?: string | null, parkingText?: string | null, leasingSpecialsText?: string | null, handicappedUnitsText?: string | null, yardiPropertyCode?: string | null, propertyType?: LeasePropertyType | null, maxAcceptedPerShowing?: number | null, showingDurationMins?: number | null, isFurnished?: boolean | null, maxSimultaneousShowings?: number | null, leasingSpecials: Array<{ __typename?: 'LeasingSpecial', text: string, endDate?: string | null }> } | null };

export type UpdateTaskMutationVariables = Exact<{
  task: LeasingTaskInput;
}>;


export type UpdateTaskMutation = { __typename?: 'Mutation', updateLeasingTask: { __typename?: 'LeasingTask', id: number, displayName: string, addressPhone?: string | null, addressEmail?: string | null, isArchived: boolean, taskType: TaskType, isBotDisabled: boolean, launchDate?: string | null, hasLaunched: boolean, offboardDate?: string | null, hasOffboarded: boolean, showingHours?: string | null, firmTaskId?: number | null, numUnits?: number | null, streetViewAddress?: string | null, primaryPmKeyJson?: string | null, tourTypes: Array<TourType>, address?: { __typename?: 'Address', id: number, addressParts: { __typename?: 'AddressParts', street: string, city: string, state: string, zipcode: string }, geolocation: { __typename?: 'Geolocation', latitude: number, longitude: number, tzName: string } } | null, firm: { __typename?: 'Firm', id: number, firmName: string, firmType: FirmType, pmTypes: Array<string>, pmKeyJsons: Array<string>, maxAcceptedPerShowing?: number | null, showingDurationMins?: number | null, acceptSection8?: boolean | null, tourTypes: Array<TourType>, showingPolicy?: ShowingPolicy | null, section8Text?: string | null, qualificationText?: string | null, petPolicyText?: string | null, moveInCostText?: string | null, discountsText?: string | null, applicationDocsText?: string | null, leaseTermsText?: string | null, cosignerPolicyText?: string | null, realtorText?: string | null, officePhone?: string | null, propertyListingsUrl?: string | null, englishConversationOnly?: boolean | null, headsUpText?: string | null }, taskAgents: Array<{ __typename?: 'TaskAgent', id: string, precedence?: number | null, numTasks: number, firmTaskThreadType: ConversationType, workHours?: string | null, agent: { __typename?: 'Contact', id: number, firstName?: string | null, lastName?: string | null, addressEmail?: string | null, addressPhone?: string | null, workHours: string, language?: Language | null } }>, leasingInfo?: { __typename?: 'LeasingInfo', buildingName?: string | null, meetingDirections?: string | null, selfGuidedMeetingDirections?: string | null, areAgentsOnsite?: boolean | null, officePhone?: string | null, acceptSection8?: boolean | null, tourTypes?: Array<TourType> | null, showingPolicy?: ShowingPolicy | null, section8Text?: string | null, applicationUrl?: string | null, propertyWebsite?: string | null, floorPlansUrl?: string | null, qualificationText?: string | null, petPolicyText?: string | null, moveInCostText?: string | null, discountsText?: string | null, applicationDocsText?: string | null, leaseTermsText?: string | null, cosignerPolicyText?: string | null, realtorText?: string | null, amenitiesText?: string | null, laundryText?: string | null, utilitiesText?: string | null, parkingText?: string | null, leasingSpecialsText?: string | null, handicappedUnitsText?: string | null, yardiPropertyCode?: string | null, propertyType?: LeasePropertyType | null, maxAcceptedPerShowing?: number | null, showingDurationMins?: number | null, isFurnished?: boolean | null, maxSimultaneousShowings?: number | null, leasingSpecials: Array<{ __typename?: 'LeasingSpecial', text: string, endDate?: string | null }> } | null } };

export type UpdateFirmMutationVariables = Exact<{
  firm: FirmInput;
}>;


export type UpdateFirmMutation = { __typename?: 'Mutation', updateFirm: { __typename?: 'Firm', id: number, firmName: string, firmType: FirmType, pmTypes: Array<string>, pmKeyJsons: Array<string>, maxAcceptedPerShowing?: number | null, showingDurationMins?: number | null, acceptSection8?: boolean | null, tourTypes: Array<TourType>, showingPolicy?: ShowingPolicy | null, section8Text?: string | null, qualificationText?: string | null, petPolicyText?: string | null, moveInCostText?: string | null, discountsText?: string | null, applicationDocsText?: string | null, leaseTermsText?: string | null, cosignerPolicyText?: string | null, realtorText?: string | null, officePhone?: string | null, propertyListingsUrl?: string | null, englishConversationOnly?: boolean | null, headsUpText?: string | null } };

export type UpdateFirmConfigMutationVariables = Exact<{
  firm: FirmInput;
}>;


export type UpdateFirmConfigMutation = { __typename?: 'Mutation', updateFirm: { __typename?: 'Firm', config?: string | null, id: number, firmName: string, firmType: FirmType, pmTypes: Array<string>, pmKeyJsons: Array<string>, maxAcceptedPerShowing?: number | null, showingDurationMins?: number | null, acceptSection8?: boolean | null, tourTypes: Array<TourType>, showingPolicy?: ShowingPolicy | null, section8Text?: string | null, qualificationText?: string | null, petPolicyText?: string | null, moveInCostText?: string | null, discountsText?: string | null, applicationDocsText?: string | null, leaseTermsText?: string | null, cosignerPolicyText?: string | null, realtorText?: string | null, officePhone?: string | null, propertyListingsUrl?: string | null, englishConversationOnly?: boolean | null, headsUpText?: string | null } };

export type UpdateContactMutationVariables = Exact<{
  contact: ContactInput;
}>;


export type UpdateContactMutation = { __typename?: 'Mutation', updateContact: { __typename?: 'Contact', id: number, firstName?: string | null, lastName?: string | null, addressEmail?: string | null, addressPhone?: string | null, workHours: string, language?: Language | null } };

export type UpdateContactNameMutationVariables = Exact<{
  contact: ContactInput;
}>;


export type UpdateContactNameMutation = { __typename?: 'Mutation', updateContact: { __typename?: 'Contact', id: number, firstName?: string | null, lastName?: string | null } };

export type UpdateThreadMutationVariables = Exact<{
  threadId: Scalars['Int'];
  isArchived?: InputMaybe<Scalars['Boolean']>;
  botStatus?: InputMaybe<ThreadBotStatus>;
  lastReadMessageId?: InputMaybe<Scalars['Int']>;
  archiveDays?: InputMaybe<Scalars['Int']>;
  leasingAttributionSource?: InputMaybe<Scalars['String']>;
}>;


export type UpdateThreadMutation = { __typename?: 'Mutation', updateThread: { __typename?: 'Thread', id: number, isArchived: boolean, archiveUntil?: string | null, botStatus: ThreadBotStatus, lastMessageId: number, lastReadMessageId: number } };

export type SetIsTypingMutationVariables = Exact<{
  threadId: Scalars['Int'];
  isTyping: Scalars['Boolean'];
}>;


export type SetIsTypingMutation = { __typename?: 'Mutation', setIsTyping: boolean };

export type PostActionMutationVariables = Exact<{
  threadId: Scalars['Int'];
  action: ActionInput;
  actionCount?: InputMaybe<Scalars['Int']>;
}>;


export type PostActionMutation = { __typename?: 'Mutation', postAction: { __typename?: 'Thread', id: number, messageType: MessageType, conversationType: ConversationType, addressUs: string, addressThem: string, isArchived: boolean, archiveUntil?: string | null, botStatus: ThreadBotStatus, lastMessageId: number, lastReadMessageId: number, lastMessageInbound: boolean, unitTypesInterested: Array<UnitType>, moveInDate?: string | null, additionalOccupants?: number | null, leasingAttributionSource: LeasingAttributionSource, messagesWithLinks: { __typename?: 'MessagesWithLinks', waitingForShowing: boolean, messages: Array<{ __typename?: 'Message', id: number, timeCreated: string, addressFrom: string, addressTo: string, messageType: MessageType, messageStatus: MessageStatus, callStatus?: VoiceCallStatus | null, callStart?: string | null, callDuration?: number | null, isInbound: boolean, censoredShortBody: string, censoredTranslatedShortBody?: string | null, translatedEmailSubject?: string | null, emailSubject?: string | null, mediaUrl?: string | null, calEventId?: string | null, externalUrl?: string | null, errorMessage?: string | null, actionId?: number | null, actionUrl?: string | null, classification?: string | null, tags: Array<MessageTag>, outboundTags: Array<OutboundTag>, leasingAttributionSource?: string | null, messageLLMInfo?: Array<MessageTag> | null, author?: { __typename?: 'User', id: number, name: string } | null }>, messageLinks: Array<{ __typename?: 'MessageLink', phrase: string, link: { __typename: 'FloorPlanLink', leasingTask: { __typename?: 'LeasingTask', id: number, displayName: string } } | { __typename: 'LeasingTaskLink', leasingTask: { __typename?: 'LeasingTask', id: number, leasingInfo?: { __typename?: 'LeasingInfo', propertyType?: LeasePropertyType | null } | null } } }> }, botThread?: { __typename?: 'BotThread', sendTime?: string | null, showCountdown: boolean, action?: { __typename?: 'Action', actionName: ActionName, preview: string, classification: string, sendQueue: SendQueue, commandJsons: Array<string>, uuid?: string | null, logSummary: string, hasArchiveCommand: boolean, hasSnoozeCommand: boolean, llmAction?: boolean | null, commandTypes: Array<CommandType>, commandPreviews: Array<string> } | null } | null, contactThem: { __typename?: 'Contact', id: number, firstName?: string | null, lastName?: string | null, addressEmail?: string | null, addressPhone?: string | null, workHours: string, language?: Language | null }, calendar?: { __typename?: 'Cal', id: string, timeLastAccess?: string | null } | null } };

export type RetryActionMutationVariables = Exact<{
  threadId: Scalars['Int'];
  actionId: Scalars['Int'];
}>;


export type RetryActionMutation = { __typename?: 'Mutation', retryAction: { __typename?: 'SavedAction', id: number } };

export type RunAdminTaskMutationVariables = Exact<{
  argumentsJson: Scalars['String'];
}>;


export type RunAdminTaskMutation = { __typename?: 'Mutation', runAdminTask: string };

export type UpdateTasksMutationVariables = Exact<{
  taskIds: Array<Scalars['Int']> | Scalars['Int'];
  field: BulkUpdateOp;
  value?: InputMaybe<Scalars['String']>;
}>;


export type UpdateTasksMutation = { __typename?: 'Mutation', bulkUpdateTasks: Array<{ __typename?: 'LeasingTask', id: number, displayName: string, offboardDate?: string | null, launchDate?: string | null, taskType: TaskType, isArchived: boolean, leasingInfo?: { __typename?: 'LeasingInfo', propertyType?: LeasePropertyType | null } | null }> };

export type LookAtUserMutationVariables = Exact<{
  observedUserId?: InputMaybe<Scalars['Int']>;
}>;


export type LookAtUserMutation = { __typename?: 'Mutation', setLookingAtUser: { __typename?: 'User', id: number, lookingAtUser?: { __typename?: 'User', id: number, name: string } | null } };

export type FetchAppContextQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchAppContextQuery = { __typename?: 'Query', allFirms: Array<{ __typename?: 'Firm', firmName: string }> };

export type UserClockFragment = { __typename?: 'User', id: number, name: string, isClockedIn: boolean, mostRecentClockEvent?: { __typename?: 'OperatorClockEvent', id: number, clockInTime: string, clockOutTime?: string | null } | null };

export type ChangeClockMutationMutationVariables = Exact<{
  isClockedIn: Scalars['Boolean'];
}>;


export type ChangeClockMutationMutation = { __typename?: 'Mutation', setClockedIn: { __typename?: 'OperatorClockEvent', id: number, user: { __typename?: 'User', id: number, name: string, isClockedIn: boolean, mostRecentClockEvent?: { __typename?: 'OperatorClockEvent', id: number, clockInTime: string, clockOutTime?: string | null } | null } } };

export type FetchMostRecentClockEventQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchMostRecentClockEventQuery = { __typename?: 'Query', self: { __typename?: 'User', id: number, name: string, isClockedIn: boolean, mostRecentClockEvent?: { __typename?: 'OperatorClockEvent', id: number, clockInTime: string, clockOutTime?: string | null } | null } };

export type FetchContactThreadLinksQueryVariables = Exact<{
  contactId: Scalars['Int'];
}>;


export type FetchContactThreadLinksQuery = { __typename?: 'Query', contact: { __typename?: 'Contact', threads: Array<{ __typename?: 'Thread', id: number, conversationType: ConversationType, messageType: MessageType, lastMessageTime?: string | null, lastMessageSnippet?: string | null, leasingTask: { __typename?: 'LeasingTask', id: number, displayName: string, taskType: TaskType, leasingInfo?: { __typename?: 'LeasingInfo', propertyType?: LeasePropertyType | null } | null, firm: { __typename?: 'Firm', id: number, firmName: string } } }> } };

export type FetchThreadQueryVariables = Exact<{
  threadId: Scalars['Int'];
  loadOptions: MessageLoadOptionsInput;
}>;


export type FetchThreadQuery = { __typename?: 'Query', thread: { __typename?: 'Thread', id: number, timeCreated: string, messageType: MessageType, conversationType: ConversationType, isArchived: boolean, archiveUntil?: string | null, addressUs: string, addressThem: string, botStatus: ThreadBotStatus, preferredTourType?: TourType | null, unitTypesInterested: Array<UnitType>, moveInDate?: string | null, additionalOccupants?: number | null, leasingAttributionSource: LeasingAttributionSource, transcriptUrl: string, isTyping: Array<string>, isUnsubscribed: boolean, isAgentSteppedIn: boolean, contactThem: { __typename?: 'Contact', customAgentNamePhone?: string | null, preferMessageType: MessageType, id: number, firstName?: string | null, lastName?: string | null, addressEmail?: string | null, addressPhone?: string | null, workHours: string, language?: Language | null }, botThread?: { __typename?: 'BotThread', sendTime?: string | null, showCountdown: boolean, action?: { __typename?: 'Action', actionName: ActionName, preview: string, classification: string, sendQueue: SendQueue, commandJsons: Array<string>, uuid?: string | null, logSummary: string, hasArchiveCommand: boolean, hasSnoozeCommand: boolean, llmAction?: boolean | null, commandTypes: Array<CommandType>, commandPreviews: Array<string> } | null } | null, recentActions: Array<{ __typename?: 'SavedAction', id: number, timeCreated: string, actionName?: ActionName | null, actionDisplayName: string, summary: string, user?: { __typename?: 'User', id: number, name: string } | null, validationErrors: Array<{ __typename?: 'BotActionValidationError', validationType: BotActionValidationType, errorDescription: string, canBeRerunInCC: boolean }> }>, messagesWithLinks: { __typename?: 'MessagesWithLinks', waitingForShowing: boolean, messages: Array<{ __typename?: 'Message', id: number, timeCreated: string, addressFrom: string, addressTo: string, messageType: MessageType, messageStatus: MessageStatus, callStatus?: VoiceCallStatus | null, callStart?: string | null, callDuration?: number | null, isInbound: boolean, censoredShortBody: string, censoredTranslatedShortBody?: string | null, translatedEmailSubject?: string | null, emailSubject?: string | null, mediaUrl?: string | null, calEventId?: string | null, externalUrl?: string | null, errorMessage?: string | null, actionId?: number | null, actionUrl?: string | null, classification?: string | null, tags: Array<MessageTag>, outboundTags: Array<OutboundTag>, leasingAttributionSource?: string | null, messageLLMInfo?: Array<MessageTag> | null, author?: { __typename?: 'User', id: number, name: string } | null }>, messageLinks: Array<{ __typename?: 'MessageLink', phrase: string, link: { __typename: 'FloorPlanLink', leasingTask: { __typename?: 'LeasingTask', id: number, displayName: string } } | { __typename: 'LeasingTaskLink', leasingTask: { __typename?: 'LeasingTask', id: number, leasingInfo?: { __typename?: 'LeasingInfo', propertyType?: LeasePropertyType | null } | null } } }> }, calendar?: { __typename?: 'Cal', id: string, timeLastAccess?: string | null } | null } };

export type FetchUserContextQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchUserContextQuery = { __typename?: 'Query', self: { __typename?: 'User', id: number, name: string, email: string, isClockedIn: boolean, userType: UserType, autoStationAssignmentEnabled: boolean, permissions: { __typename?: 'Permissions', canViewAdminPage: boolean, canViewFirmSecrets: boolean, canModifyLeasingSpecials: boolean, canModifyNotes: boolean, canViewSuperDashboard: boolean, canViewSuperTaskDetails: boolean, canViewCoreTaskInfo: boolean, canViewCalEventUrls: boolean, canCreateTask: boolean, canViewBotAction: boolean, canEditAgents: boolean, canRunBasicJobs: boolean, canViewOccupancy: boolean, canEditTaskDetails: boolean, canViewUnitsAndMarketing: boolean, canResendTcpaViolations: boolean, canResendMassCancellationViolations?: boolean | null, canResendAllowedActionViolations?: boolean | null, canResendInvalidBodyViolations?: boolean | null, canRemoveShiftAssignment: boolean, canModifyOperatorShifts: boolean, canModifySeniorOperatorShifts: boolean }, unarchivedThreads: Array<{ __typename?: 'Thread', id: number, isArchived: boolean, lastReadMessageId: number, lastInboundMessageId: number }>, lookingAtUser?: { __typename?: 'User', id: number, name: string } | null, activeOperatorShift?: { __typename?: 'OperatorShift', id: number, shift: { __typename?: 'Shift', id: number, timeStart: string, timeEnd: string } } | null, mostRecentClockEvent?: { __typename?: 'OperatorClockEvent', id: number, clockInTime: string, clockOutTime?: string | null } | null } };

export type FetchInboxQueryVariables = Exact<{
  threadId: Scalars['Int'];
  taskId: Scalars['Int'];
  contactId: Scalars['Int'];
  hasThreadId: Scalars['Boolean'];
  hasTaskIdAndContactId: Scalars['Boolean'];
}>;


export type FetchInboxQuery = { __typename?: 'Query', self: { __typename?: 'User', id: number, unarchivedThreads: Array<{ __typename?: 'Thread', id: number, conversationType: ConversationType, isArchived: boolean, botStatus: ThreadBotStatus, lastReadMessageId: number, lastInboundMessageId: number, lastMessageInbound: boolean, sortTime: string, contactThem: { __typename?: 'Contact', id: number, firstName?: string | null, lastName?: string | null, addressEmail?: string | null, addressPhone?: string | null }, botThread?: { __typename?: 'BotThread', showCountdown: boolean, sendTime?: string | null } | null }> }, thread?: { __typename?: 'Thread', id: number, conversationType: ConversationType, isArchived: boolean, botStatus: ThreadBotStatus, lastReadMessageId: number, lastInboundMessageId: number, lastMessageInbound: boolean, sortTime: string, leasingTask: { __typename?: 'LeasingTask', id: number, displayName: string, isArchived: boolean, taskType: TaskType, isBotDisabled: boolean, launchDate?: string | null, hasLaunched: boolean, offboardDate?: string | null, hasOffboarded: boolean, showingHours?: string | null, firmTaskId?: number | null, tourTypes: Array<TourType>, holidays?: string | null, address?: { __typename?: 'Address', id: number, geolocation: { __typename?: 'Geolocation', tzName: string } } | null, firm: { __typename?: 'Firm', id: number, firmName: string, pmTypes: Array<string>, englishConversationOnly?: boolean | null, headsUpText?: string | null }, leasingInfo?: { __typename?: 'LeasingInfo', areAgentsOnsite?: boolean | null, propertyWebsite?: string | null, propertyType?: LeasePropertyType | null, leasingSpecials: Array<{ __typename?: 'LeasingSpecial', text: string, endDate?: string | null }> } | null }, contactThem: { __typename?: 'Contact', id: number, firstName?: string | null, lastName?: string | null, addressEmail?: string | null, addressPhone?: string | null }, botThread?: { __typename?: 'BotThread', showCountdown: boolean, sendTime?: string | null } | null }, contactThread?: { __typename?: 'Thread', id: number } };

export type FetchTasksPageQueryVariables = Exact<{
  threadId: Scalars['Int'];
  taskId: Scalars['Int'];
  contactId: Scalars['Int'];
  hasThreadId: Scalars['Boolean'];
  hasTaskId: Scalars['Boolean'];
  hasTaskIdAndContactId: Scalars['Boolean'];
}>;


export type FetchTasksPageQuery = { __typename?: 'Query', allFirmTasks: Array<{ __typename?: 'LeasingTask', id: number, isArchived: boolean, displayName: string, streetViewAddress?: string | null, leasingInfo?: { __typename?: 'LeasingInfo', propertyType?: LeasePropertyType | null } | null, threads: Array<{ __typename?: 'Thread', id: number, conversationType: ConversationType, isArchived: boolean, botStatus: ThreadBotStatus, lastReadMessageId: number, lastInboundMessageId: number, lastMessageInbound: boolean, sortTime: string, contactThem: { __typename?: 'Contact', id: number, firstName?: string | null, lastName?: string | null, addressEmail?: string | null, addressPhone?: string | null }, botThread?: { __typename?: 'BotThread', showCountdown: boolean, sendTime?: string | null } | null }> }>, thread?: { __typename?: 'Thread', id: number, conversationType: ConversationType, isArchived: boolean, botStatus: ThreadBotStatus, lastReadMessageId: number, lastInboundMessageId: number, lastMessageInbound: boolean, sortTime: string, leasingTask: { __typename?: 'LeasingTask', holidays?: string | null, id: number, displayName: string, isArchived: boolean, taskType: TaskType, isBotDisabled: boolean, launchDate?: string | null, hasLaunched: boolean, offboardDate?: string | null, hasOffboarded: boolean, showingHours?: string | null, firmTaskId?: number | null, tourTypes: Array<TourType>, streetViewAddress?: string | null, address?: { __typename?: 'Address', id: number, geolocation: { __typename?: 'Geolocation', tzName: string } } | null, firm: { __typename?: 'Firm', id: number, firmName: string, pmTypes: Array<string>, englishConversationOnly?: boolean | null, headsUpText?: string | null }, leasingInfo?: { __typename?: 'LeasingInfo', areAgentsOnsite?: boolean | null, propertyWebsite?: string | null, propertyType?: LeasePropertyType | null, leasingSpecials: Array<{ __typename?: 'LeasingSpecial', text: string, endDate?: string | null }> } | null, threads: Array<{ __typename?: 'Thread', id: number, conversationType: ConversationType, isArchived: boolean, botStatus: ThreadBotStatus, lastReadMessageId: number, lastInboundMessageId: number, lastMessageInbound: boolean, sortTime: string, contactThem: { __typename?: 'Contact', id: number, firstName?: string | null, lastName?: string | null, addressEmail?: string | null, addressPhone?: string | null }, botThread?: { __typename?: 'BotThread', showCountdown: boolean, sendTime?: string | null } | null }> }, contactThem: { __typename?: 'Contact', id: number, firstName?: string | null, lastName?: string | null, addressEmail?: string | null, addressPhone?: string | null }, botThread?: { __typename?: 'BotThread', showCountdown: boolean, sendTime?: string | null } | null }, task?: { __typename?: 'LeasingTask', holidays?: string | null, id: number, isArchived: boolean, displayName: string, streetViewAddress?: string | null, addressPhone?: string | null, addressEmail?: string | null, taskType: TaskType, isBotDisabled: boolean, launchDate?: string | null, hasLaunched: boolean, offboardDate?: string | null, hasOffboarded: boolean, showingHours?: string | null, firmTaskId?: number | null, primaryPmKeyJson?: string | null, tourTypes: Array<TourType>, leasingInfo?: { __typename?: 'LeasingInfo', propertyType?: LeasePropertyType | null, buildingName?: string | null, meetingDirections?: string | null, selfGuidedMeetingDirections?: string | null, areAgentsOnsite?: boolean | null, officePhone?: string | null, acceptSection8?: boolean | null, tourTypes?: Array<TourType> | null, showingPolicy?: ShowingPolicy | null, section8Text?: string | null, applicationUrl?: string | null, propertyWebsite?: string | null, floorPlansUrl?: string | null, qualificationText?: string | null, petPolicyText?: string | null, moveInCostText?: string | null, discountsText?: string | null, applicationDocsText?: string | null, leaseTermsText?: string | null, cosignerPolicyText?: string | null, realtorText?: string | null, amenitiesText?: string | null, laundryText?: string | null, utilitiesText?: string | null, parkingText?: string | null, leasingSpecialsText?: string | null, handicappedUnitsText?: string | null, yardiPropertyCode?: string | null, maxAcceptedPerShowing?: number | null, showingDurationMins?: number | null, isFurnished?: boolean | null, maxSimultaneousShowings?: number | null, leasingSpecials: Array<{ __typename?: 'LeasingSpecial', text: string, endDate?: string | null }> } | null, threads: Array<{ __typename?: 'Thread', id: number, conversationType: ConversationType, isArchived: boolean, botStatus: ThreadBotStatus, lastReadMessageId: number, lastInboundMessageId: number, lastMessageInbound: boolean, sortTime: string, contactThem: { __typename?: 'Contact', id: number, firstName?: string | null, lastName?: string | null, addressEmail?: string | null, addressPhone?: string | null }, botThread?: { __typename?: 'BotThread', showCountdown: boolean, sendTime?: string | null } | null }>, address?: { __typename?: 'Address', id: number, addressParts: { __typename?: 'AddressParts', street: string, city: string, state: string, zipcode: string }, geolocation: { __typename?: 'Geolocation', tzName: string } } | null, firm: { __typename?: 'Firm', id: number, firmName: string, pmTypes: Array<string>, pmKeyJsons: Array<string>, maxAcceptedPerShowing?: number | null, showingDurationMins?: number | null, acceptSection8?: boolean | null, tourTypes: Array<TourType>, showingPolicy?: ShowingPolicy | null, section8Text?: string | null, qualificationText?: string | null, petPolicyText?: string | null, moveInCostText?: string | null, discountsText?: string | null, applicationDocsText?: string | null, leaseTermsText?: string | null, cosignerPolicyText?: string | null, realtorText?: string | null, officePhone?: string | null, propertyListingsUrl?: string | null }, taskAgents: Array<{ __typename?: 'TaskAgent', id: string, precedence?: number | null, numTasks: number, firmTaskThreadType: ConversationType, isCurrentlyWorking?: boolean | null, agent: { __typename?: 'Contact', id: number, firstName?: string | null, lastName?: string | null, addressEmail?: string | null, addressPhone?: string | null, workHours: string } }> }, contactThread?: { __typename?: 'Thread', id: number } };

export type ShiftFragment = { __typename?: 'Shift', id: number, timeStart: string, timeEnd: string, shiftType: ShiftType, numAvailableSlots: number, operatorsSnippet: string, maxNumSlots: number, operatorShifts: Array<{ __typename?: 'OperatorShift', id: number, userId: number, state: OpShiftState, rank?: number | null }> };

export type FetchLobbyQueryVariables = Exact<{
  from: Scalars['String'];
  to: Scalars['String'];
}>;


export type FetchLobbyQuery = { __typename?: 'Query', shifts: Array<{ __typename?: 'Shift', id: number, timeStart: string, timeEnd: string, shiftType: ShiftType, numAvailableSlots: number, operatorsSnippet: string, maxNumSlots: number, operatorShifts: Array<{ __typename?: 'OperatorShift', id: number, userId: number, state: OpShiftState, rank?: number | null }> }>, self: { __typename?: 'User', id: number, name: string, userType: UserType, operatorCal: { __typename?: 'OperatorCal', maxNumShifts: number }, permissions: { __typename?: 'Permissions', canViewAdminPage: boolean, canModifyLeasingSpecials: boolean, canModifyNotes: boolean, canViewSuperDashboard: boolean, canViewSuperTaskDetails: boolean, canViewCoreTaskInfo: boolean, canViewCalEventUrls: boolean, canCreateTask: boolean, canViewBotAction: boolean, canEditAgents: boolean, canModifyOperatorShifts: boolean, canModifySeniorOperatorShifts: boolean, canRunBasicJobs: boolean, canViewOccupancy: boolean, canEditTaskDetails: boolean, canViewUnitsAndMarketing: boolean, canResendTcpaViolations: boolean, canResendMassCancellationViolations?: boolean | null, canResendAllowedActionViolations?: boolean | null, canResendInvalidBodyViolations?: boolean | null } } };

export type FetchAllUsersQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchAllUsersQueryQuery = { __typename?: 'Query', self: { __typename?: 'User', id: number }, allUsers: Array<{ __typename?: 'User', id: number, name: string, isClockedIn: boolean, userType: UserType, autoStationAssignmentEnabled: boolean, unarchivedMessageCount: number, oldestUnarchivedMessageTimeCreated?: string | null, mostRecentClockEvent?: { __typename?: 'OperatorClockEvent', id: number, clockInTime: string, clockOutTime?: string | null } | null, activeOperatorShift?: { __typename?: 'OperatorShift', id: number, shift: { __typename?: 'Shift', id: number, timeStart: string, timeEnd: string } } | null, lookingAtUser?: { __typename?: 'User', id: number, name: string } | null }> };

export type AddressLookupQueryVariables = Exact<{
  inputAddress: Scalars['String'];
}>;


export type AddressLookupQuery = { __typename?: 'Query', addressLookup?: { __typename?: 'Address', id: number, addressParts: { __typename?: 'AddressParts', street: string, city: string, state: string, zipcode: string }, geolocation: { __typename?: 'Geolocation', latitude: number, longitude: number } } | null };

export type FetchIsTypingQueryVariables = Exact<{
  threadId: Scalars['Int'];
}>;


export type FetchIsTypingQuery = { __typename?: 'Query', isTyping: Array<string> };

export type FetchShowingsQueryVariables = Exact<{
  taskId: Scalars['Int'];
  showingsFilterInput?: InputMaybe<ShowingsFilterInput>;
}>;


export type FetchShowingsQuery = { __typename?: 'Query', task: { __typename?: 'LeasingTask', id: number, showings: Array<{ __typename?: 'Showing', id: number, timeCreated: string, timeStart: string, leasingTaskId: number, showingStatus: ShowingStatus, calEventUrl?: string | null, unitType?: UnitType | null, tourType?: TourType | null, showingContacts: Array<{ __typename?: 'ShowingContact', calResponseStatus?: CalResponseStatus | null, confirmationStatus: ConfirmationStatus, isAgent: boolean, timeUpdated: string, contact: { __typename?: 'Contact', id: number, firstName?: string | null, lastName?: string | null, addressEmail?: string | null, addressPhone?: string | null, workHours: string, language?: Language | null } }> }> } };

export type FetchContactShowingsQueryVariables = Exact<{
  contactId: Scalars['Int'];
  taskId?: InputMaybe<Scalars['Int']>;
}>;


export type FetchContactShowingsQuery = { __typename?: 'Query', contact: { __typename?: 'Contact', id: number, showings: Array<{ __typename?: 'Showing', id: number, timeCreated: string, timeStart: string, leasingTaskId: number, showingStatus: ShowingStatus, calEventUrl?: string | null, unitType?: UnitType | null, tourType?: TourType | null, showingContacts: Array<{ __typename?: 'ShowingContact', calResponseStatus?: CalResponseStatus | null, confirmationStatus: ConfirmationStatus, isAgent: boolean, timeUpdated: string, contact: { __typename?: 'Contact', id: number, firstName?: string | null, lastName?: string | null, addressEmail?: string | null, addressPhone?: string | null, workHours: string, language?: Language | null } }> }> } };

export type FetchTasksAndPropertiesQueryVariables = Exact<{
  firmId: Scalars['Int'];
}>;


export type FetchTasksAndPropertiesQuery = { __typename?: 'Query', firm: { __typename?: 'Firm', id: number, tasks: Array<{ __typename?: 'LeasingTask', id: number, displayName: string, isArchived: boolean, timeCreated: string, launchDate?: string | null, offboardDate?: string | null, taskType: TaskType, leasingInfo?: { __typename?: 'LeasingInfo', propertyType?: LeasePropertyType | null } | null }>, pmPropertiesWithoutTasks: Array<{ __typename?: 'PmProperty', id: string, displayName: string, auditKeyJson: string, jsonUrl: string, pmUrl: string, numUnits: number, numUnitsUnrented: number, cleanAddress?: string | null }> } };

export type ShowingUpdatesSubscriptionSubscriptionVariables = Exact<{
  contactId: Scalars['Int'];
  taskId?: InputMaybe<Scalars['Int']>;
}>;


export type ShowingUpdatesSubscriptionSubscription = { __typename?: 'Subscription', showingUpdates: Array<{ __typename?: 'Showing', id: number }> };

export type ThreadUpdatesSubscriptionSubscriptionVariables = Exact<{
  threadId: Scalars['Int'];
}>;


export type ThreadUpdatesSubscriptionSubscription = { __typename?: 'Subscription', threadUpdates: Array<{ __typename?: 'Thread', id: number }> };

export type ContactUpdatesSubscriptionSubscriptionVariables = Exact<{
  contactId: Scalars['Int'];
}>;


export type ContactUpdatesSubscriptionSubscription = { __typename?: 'Subscription', contactUpdates: Array<{ __typename?: 'Contact', id: number }> };

export type MessageUpdatesSubscriptionSubscriptionVariables = Exact<{
  threadId: Scalars['Int'];
}>;


export type MessageUpdatesSubscriptionSubscription = { __typename?: 'Subscription', messageUpdates: Array<{ __typename?: 'Message', id: number }> };

export type CalUpdatesSubscriptionSubscriptionVariables = Exact<{
  threadId: Scalars['Int'];
}>;


export type CalUpdatesSubscriptionSubscription = { __typename?: 'Subscription', calUpdates: Array<{ __typename?: 'Cal', id: string }> };

export type MessageFirehoseQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type MessageFirehoseQueryQuery = { __typename?: 'Query', countdowns: Array<{ __typename?: 'BotThread', sendTime?: string | null, actionMessageType?: MessageType | null, contact: { __typename?: 'Contact', id: number, firstName?: string | null, lastName?: string | null, addressEmail?: string | null, addressPhone?: string | null, workHours: string, language?: Language | null }, task: { __typename?: 'LeasingTask', id: number, isArchived: boolean, isBotDisabled: boolean, launchDate?: string | null, offboardDate?: string | null, displayName: string, firm: { __typename?: 'Firm', id: number, firmName: string } }, action?: { __typename?: 'Action', classification: string, preview: string } | null }>, messages: Array<{ __typename?: 'Message', id: number, timeCreated: string, isInbound: boolean, addressFrom: string, addressTo: string, messageType: MessageType, classification?: string | null, actionUrl?: string | null, shortBody: string, thread: { __typename?: 'Thread', id: number, contactThem: { __typename?: 'Contact', id: number, firstName?: string | null, lastName?: string | null, addressEmail?: string | null, addressPhone?: string | null, workHours: string, language?: Language | null } }, task?: { __typename?: 'LeasingTask', id: number, isArchived: boolean, isBotDisabled: boolean, launchDate?: string | null, offboardDate?: string | null, displayName: string, firm: { __typename?: 'Firm', id: number, firmName: string } } | null, author?: { __typename?: 'User', id: number, name: string } | null }> };

export type CountdownFragment = { __typename?: 'BotThread', sendTime?: string | null, actionMessageType?: MessageType | null, contact: { __typename?: 'Contact', id: number, firstName?: string | null, lastName?: string | null, addressEmail?: string | null, addressPhone?: string | null, workHours: string, language?: Language | null }, task: { __typename?: 'LeasingTask', id: number, isArchived: boolean, isBotDisabled: boolean, launchDate?: string | null, offboardDate?: string | null, displayName: string, firm: { __typename?: 'Firm', id: number, firmName: string } }, action?: { __typename?: 'Action', classification: string, preview: string } | null };

export type MessageLogFragment = { __typename?: 'Message', id: number, timeCreated: string, isInbound: boolean, addressFrom: string, addressTo: string, messageType: MessageType, classification?: string | null, actionUrl?: string | null, shortBody: string, thread: { __typename?: 'Thread', id: number, contactThem: { __typename?: 'Contact', id: number, firstName?: string | null, lastName?: string | null, addressEmail?: string | null, addressPhone?: string | null, workHours: string, language?: Language | null } }, task?: { __typename?: 'LeasingTask', id: number, isArchived: boolean, isBotDisabled: boolean, launchDate?: string | null, offboardDate?: string | null, displayName: string, firm: { __typename?: 'Firm', id: number, firmName: string } } | null, author?: { __typename?: 'User', id: number, name: string } | null };

export type TaskFirmDispFragment = { __typename?: 'LeasingTask', id: number, isArchived: boolean, isBotDisabled: boolean, launchDate?: string | null, offboardDate?: string | null, displayName: string, firm: { __typename?: 'Firm', id: number, firmName: string } };

export type FetchStatusBoardQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchStatusBoardQuery = { __typename?: 'Query', statusBoard: Array<{ __typename?: 'FirmServiceStatus', warnLevel: WarnLevel, statusMonitorType: StatusMonitorType, lastUpdated?: string | null, firm: { __typename?: 'Firm', id: number, firmName: string } }> };

export type FetchOnboardingTasksQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchOnboardingTasksQuery = { __typename?: 'Query', onboardingTasks: Array<{ __typename?: 'LeasingTask', id: number, displayName: string, addressPhone?: string | null, addressEmail?: string | null, isArchived: boolean, taskType: TaskType, isBotDisabled: boolean, launchDate?: string | null, hasLaunched: boolean, offboardDate?: string | null, hasOffboarded: boolean, showingHours?: string | null, firmTaskId?: number | null, numUnits?: number | null, streetViewAddress?: string | null, primaryPmKeyJson?: string | null, tourTypes: Array<TourType>, onboardingInfo: { __typename?: 'OnboardingInfo', propertyDetailsStatus: OnboardingStatus, bookedTrainingStatus: OnboardingStatus, confirmedSourcesStatus: OnboardingStatus, confirmedMarketLaunchDateStatus: OnboardingStatus, provisionedEmailStatus: OnboardingStatus, enabledPmStatus: OnboardingStatus, addedLisaDynastyStatus: OnboardingStatus }, pmItemKeys: Array<{ __typename?: 'PmItemKey', pmType: string }>, address?: { __typename?: 'Address', id: number, addressParts: { __typename?: 'AddressParts', street: string, city: string, state: string, zipcode: string }, geolocation: { __typename?: 'Geolocation', latitude: number, longitude: number, tzName: string } } | null, firm: { __typename?: 'Firm', id: number, firmName: string, firmType: FirmType, pmTypes: Array<string>, pmKeyJsons: Array<string>, maxAcceptedPerShowing?: number | null, showingDurationMins?: number | null, acceptSection8?: boolean | null, tourTypes: Array<TourType>, showingPolicy?: ShowingPolicy | null, section8Text?: string | null, qualificationText?: string | null, petPolicyText?: string | null, moveInCostText?: string | null, discountsText?: string | null, applicationDocsText?: string | null, leaseTermsText?: string | null, cosignerPolicyText?: string | null, realtorText?: string | null, officePhone?: string | null, propertyListingsUrl?: string | null, englishConversationOnly?: boolean | null, headsUpText?: string | null }, taskAgents: Array<{ __typename?: 'TaskAgent', id: string, precedence?: number | null, numTasks: number, firmTaskThreadType: ConversationType, workHours?: string | null, agent: { __typename?: 'Contact', id: number, firstName?: string | null, lastName?: string | null, addressEmail?: string | null, addressPhone?: string | null, workHours: string, language?: Language | null } }>, leasingInfo?: { __typename?: 'LeasingInfo', buildingName?: string | null, meetingDirections?: string | null, selfGuidedMeetingDirections?: string | null, areAgentsOnsite?: boolean | null, officePhone?: string | null, acceptSection8?: boolean | null, tourTypes?: Array<TourType> | null, showingPolicy?: ShowingPolicy | null, section8Text?: string | null, applicationUrl?: string | null, propertyWebsite?: string | null, floorPlansUrl?: string | null, qualificationText?: string | null, petPolicyText?: string | null, moveInCostText?: string | null, discountsText?: string | null, applicationDocsText?: string | null, leaseTermsText?: string | null, cosignerPolicyText?: string | null, realtorText?: string | null, amenitiesText?: string | null, laundryText?: string | null, utilitiesText?: string | null, parkingText?: string | null, leasingSpecialsText?: string | null, handicappedUnitsText?: string | null, yardiPropertyCode?: string | null, propertyType?: LeasePropertyType | null, maxAcceptedPerShowing?: number | null, showingDurationMins?: number | null, isFurnished?: boolean | null, maxSimultaneousShowings?: number | null, leasingSpecials: Array<{ __typename?: 'LeasingSpecial', text: string, endDate?: string | null }> } | null }> };

export type FetchAdminQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchAdminQuery = { __typename?: 'Query', allFirms: Array<{ __typename?: 'Firm', numUnits: number, timeCreated: string, id: number, firmName: string, firmType: FirmType, pmTypes: Array<string>, pmKeyJsons: Array<string>, maxAcceptedPerShowing?: number | null, showingDurationMins?: number | null, acceptSection8?: boolean | null, tourTypes: Array<TourType>, showingPolicy?: ShowingPolicy | null, section8Text?: string | null, qualificationText?: string | null, petPolicyText?: string | null, moveInCostText?: string | null, discountsText?: string | null, applicationDocsText?: string | null, leaseTermsText?: string | null, cosignerPolicyText?: string | null, realtorText?: string | null, officePhone?: string | null, propertyListingsUrl?: string | null, englishConversationOnly?: boolean | null, headsUpText?: string | null }> };

export type FetchUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchUsersQuery = { __typename?: 'Query', allUsers: Array<{ __typename?: 'User', id: number, phone?: string | null, email: string, name: string, userType: UserType, adpUserId?: string | null, adpFirstName?: string | null, adpLastName?: string | null, slackUserId?: string | null, githubUsername?: string | null, pagerDutyId?: string | null, teamName?: string | null, permissions: { __typename?: 'Permissions', canViewAdminPage: boolean, canModifyLeasingSpecials: boolean, canModifyNotes: boolean, canViewSuperDashboard: boolean, canViewSuperTaskDetails: boolean, canViewCoreTaskInfo: boolean, canViewCalEventUrls: boolean, canCreateTask: boolean, canViewBotAction: boolean, canEditAgents: boolean, canRunBasicJobs: boolean, canViewOccupancy: boolean, canEditTaskDetails: boolean, canViewUnitsAndMarketing: boolean, canResendTcpaViolations: boolean, canResendMassCancellationViolations?: boolean | null, canResendAllowedActionViolations?: boolean | null, canResendInvalidBodyViolations?: boolean | null, canModifyOperatorShifts: boolean, canModifySeniorOperatorShifts: boolean } }> };

export type CreateUserMutationVariables = Exact<{
  user: UserInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'User', id: number } };

export type CreateFirmMutationVariables = Exact<{
  pmType: PmType;
  firmName: Scalars['String'];
  pmFirm?: InputMaybe<Scalars['String']>;
  addressId: Scalars['Int'];
  salesforceVPlusObjectId?: InputMaybe<Scalars['String']>;
}>;


export type CreateFirmMutation = { __typename?: 'Mutation', createFirm: { __typename?: 'Firm', id: number } };

export type FetchFirmExchangeCredsQueryVariables = Exact<{
  firmId: Scalars['Int'];
}>;


export type FetchFirmExchangeCredsQuery = { __typename?: 'Query', exchangeCreds?: { __typename?: 'ExchangeCreds', email: string, ewsUrl: string, userName?: string | null, password?: string | null } | null };

export type FetchFirmMsGraphCredsQueryVariables = Exact<{
  firmId: Scalars['Int'];
}>;


export type FetchFirmMsGraphCredsQuery = { __typename?: 'Query', msGraphCreds?: { __typename?: 'MsGraphCreds', email: string, clientId: string, tokenCache?: string | null, homeAccountId?: string | null, clientSecret?: string | null, password?: string | null } | null };

export type FetchFirmGSuiteCredsQueryVariables = Exact<{
  firmId: Scalars['Int'];
}>;


export type FetchFirmGSuiteCredsQuery = { __typename?: 'Query', gSuiteCreds?: { __typename?: 'GSuiteCreds', email: string, clientId?: string | null, refreshToken?: string | null, password?: string | null } | null };

export type UpdateFirmExchangeCredsMutationVariables = Exact<{
  firmId: Scalars['Int'];
  exchangeCreds: ExchangeCredsInput;
}>;


export type UpdateFirmExchangeCredsMutation = { __typename?: 'Mutation', updateFirmExchangeCreds: boolean };

export type UpdateFirmMsGraphCredsCredsMutationVariables = Exact<{
  firmId: Scalars['Int'];
  msGraphCreds: MsGraphCredsInput;
}>;


export type UpdateFirmMsGraphCredsCredsMutation = { __typename?: 'Mutation', updateFirmMsGraphCreds: boolean };

export type UpdateFirmGSuiteCredsMutationVariables = Exact<{
  firmId: Scalars['Int'];
  gSuiteCreds: GSuiteCredsInput;
}>;


export type UpdateFirmGSuiteCredsMutation = { __typename?: 'Mutation', updateFirmGSuiteCreds: boolean };

export type FetchFirmDetailsQueryVariables = Exact<{
  firmId: Scalars['Int'];
}>;


export type FetchFirmDetailsQuery = { __typename?: 'Query', firm: { __typename?: 'Firm', config?: string | null, id: number, firmName: string, firmType: FirmType, pmTypes: Array<string>, pmKeyJsons: Array<string>, maxAcceptedPerShowing?: number | null, showingDurationMins?: number | null, acceptSection8?: boolean | null, tourTypes: Array<TourType>, showingPolicy?: ShowingPolicy | null, section8Text?: string | null, qualificationText?: string | null, petPolicyText?: string | null, moveInCostText?: string | null, discountsText?: string | null, applicationDocsText?: string | null, leaseTermsText?: string | null, cosignerPolicyText?: string | null, realtorText?: string | null, officePhone?: string | null, propertyListingsUrl?: string | null, englishConversationOnly?: boolean | null, headsUpText?: string | null, firmTask?: { __typename?: 'LeasingTask', id: number } | null, exchangeCredsWithObfuscatedSecrets?: { __typename?: 'ExchangeCreds', email: string, ewsUrl: string, userName?: string | null, password?: string | null } | null, msGraphCredsWithObfuscatedSecrets?: { __typename?: 'MsGraphCreds', email: string, clientId: string, tokenCache?: string | null, homeAccountId?: string | null, clientSecret?: string | null, password?: string | null } | null, gSuiteCredsWithObfuscatedSecrets?: { __typename?: 'GSuiteCreds', email: string, clientId?: string | null, refreshToken?: string | null, password?: string | null } | null, resmanInfoWithObfuscatedSecrets?: { __typename?: 'BasicPmInfo', pmType: string, pmFirm: string } | null, apmInfoWithObfuscatedSecrets?: { __typename?: 'ApmInfo', pmType: string, pmFirm: string, additionalVhosts: Array<string>, showingsNotifyTenant: boolean } | null, entrataInfoWithObfuscatedSecrets?: { __typename?: 'EntrataInfo', pmType: string, pmFirm: string, username: string, password: string } | null, yardiInfoWithObfuscatedSecrets?: { __typename?: 'YardiInfo', pmType: string, pmFirm: string, serviceUrl: string, serverName: string, database: string, databasePlatform: string, apiEntity: string, apiLicenseKey: string, password: string } | null } };

export type FetchFirmEntrataInfoQueryVariables = Exact<{
  firmId: Scalars['Int'];
}>;


export type FetchFirmEntrataInfoQuery = { __typename?: 'Query', entrataInfo?: { __typename?: 'EntrataInfo', pmType: string, pmFirm: string, username: string, password: string } | null };

export type FetchFirmYardiInfoQueryVariables = Exact<{
  firmId: Scalars['Int'];
}>;


export type FetchFirmYardiInfoQuery = { __typename?: 'Query', yardiInfo?: { __typename?: 'YardiInfo', pmType: string, pmFirm: string, serviceUrl: string, serverName: string, database: string, databasePlatform: string, apiEntity: string, apiLicenseKey: string, password: string } | null };

export type UpdateFirmResmanInfoMutationVariables = Exact<{
  firmId: Scalars['Int'];
  resmanInfo: BasicPmInfoInput;
}>;


export type UpdateFirmResmanInfoMutation = { __typename?: 'Mutation', updateFirmResmanInfo: boolean };

export type UpdateFirmApmInfoMutationVariables = Exact<{
  firmId: Scalars['Int'];
  apmInfo: ApmInfoInput;
}>;


export type UpdateFirmApmInfoMutation = { __typename?: 'Mutation', updateFirmApmInfo: boolean };

export type UpdateFirmEntrataInfoMutationVariables = Exact<{
  firmId: Scalars['Int'];
  entrataInfo: EntrataInfoInput;
}>;


export type UpdateFirmEntrataInfoMutation = { __typename?: 'Mutation', updateFirmEntrataInfo: boolean };

export type UpdateFirmYardiInfoMutationVariables = Exact<{
  firmId: Scalars['Int'];
  yardiInfo: YardiInfoInput;
}>;


export type UpdateFirmYardiInfoMutation = { __typename?: 'Mutation', updateFirmYardiInfo: boolean };

export type FetchSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchSettingsQuery = { __typename?: 'Query', settings: Array<{ __typename?: 'Setting', id: number, key: string, value: string, description: string }> };

export type SetSettingMutationVariables = Exact<{
  key: Scalars['String'];
  value: Scalars['String'];
}>;


export type SetSettingMutation = { __typename?: 'Mutation', setSetting: { __typename?: 'Setting', id: number, key: string, value: string, description: string } };

export type FetchUserDetailsQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type FetchUserDetailsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: number, phone?: string | null, email: string, name: string, userType: UserType, adpUserId?: string | null, adpFirstName?: string | null, adpLastName?: string | null, slackUserId?: string | null, githubUsername?: string | null, pagerDutyId?: string | null, teamName?: string | null, permissions: { __typename?: 'Permissions', canViewAdminPage: boolean, canModifyLeasingSpecials: boolean, canModifyNotes: boolean, canViewSuperDashboard: boolean, canViewSuperTaskDetails: boolean, canViewCoreTaskInfo: boolean, canViewCalEventUrls: boolean, canCreateTask: boolean, canViewBotAction: boolean, canEditAgents: boolean, canRunBasicJobs: boolean, canViewOccupancy: boolean, canEditTaskDetails: boolean, canViewUnitsAndMarketing: boolean, canResendTcpaViolations: boolean, canResendMassCancellationViolations?: boolean | null, canResendAllowedActionViolations?: boolean | null, canResendInvalidBodyViolations?: boolean | null, canModifyOperatorShifts: boolean, canModifySeniorOperatorShifts: boolean } } };

export type UpdateUserMutationVariables = Exact<{
  user: UserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: number, phone?: string | null, email: string, name: string, userType: UserType, adpUserId?: string | null, adpFirstName?: string | null, adpLastName?: string | null, slackUserId?: string | null, githubUsername?: string | null, pagerDutyId?: string | null, teamName?: string | null, permissions: { __typename?: 'Permissions', canViewAdminPage: boolean, canModifyLeasingSpecials: boolean, canModifyNotes: boolean, canViewSuperDashboard: boolean, canViewSuperTaskDetails: boolean, canViewCoreTaskInfo: boolean, canViewCalEventUrls: boolean, canCreateTask: boolean, canViewBotAction: boolean, canEditAgents: boolean, canRunBasicJobs: boolean, canViewOccupancy: boolean, canEditTaskDetails: boolean, canViewUnitsAndMarketing: boolean, canResendTcpaViolations: boolean, canResendMassCancellationViolations?: boolean | null, canResendAllowedActionViolations?: boolean | null, canResendInvalidBodyViolations?: boolean | null, canModifyOperatorShifts: boolean, canModifySeniorOperatorShifts: boolean } } };

export type FetchTasksAndAgentsQueryVariables = Exact<{
  firmId: Scalars['Int'];
}>;


export type FetchTasksAndAgentsQuery = { __typename?: 'Query', firm: { __typename?: 'Firm', id: number, emailThreadContacts: Array<{ __typename?: 'Contact', id: number, firstName?: string | null, lastName?: string | null, addressEmail?: string | null, addressPhone?: string | null, workHours: string, language?: Language | null }>, tasks: Array<{ __typename?: 'LeasingTask', id: number, displayName: string, addressPhone?: string | null, addressEmail?: string | null, isArchived: boolean, taskType: TaskType, isBotDisabled: boolean, launchDate?: string | null, hasLaunched: boolean, offboardDate?: string | null, hasOffboarded: boolean, showingHours?: string | null, firmTaskId?: number | null, numUnits?: number | null, streetViewAddress?: string | null, primaryPmKeyJson?: string | null, tourTypes: Array<TourType>, address?: { __typename?: 'Address', id: number, addressParts: { __typename?: 'AddressParts', street: string, city: string, state: string, zipcode: string }, geolocation: { __typename?: 'Geolocation', latitude: number, longitude: number, tzName: string } } | null, firm: { __typename?: 'Firm', id: number, firmName: string, firmType: FirmType, pmTypes: Array<string>, pmKeyJsons: Array<string>, maxAcceptedPerShowing?: number | null, showingDurationMins?: number | null, acceptSection8?: boolean | null, tourTypes: Array<TourType>, showingPolicy?: ShowingPolicy | null, section8Text?: string | null, qualificationText?: string | null, petPolicyText?: string | null, moveInCostText?: string | null, discountsText?: string | null, applicationDocsText?: string | null, leaseTermsText?: string | null, cosignerPolicyText?: string | null, realtorText?: string | null, officePhone?: string | null, propertyListingsUrl?: string | null, englishConversationOnly?: boolean | null, headsUpText?: string | null }, taskAgents: Array<{ __typename?: 'TaskAgent', id: string, precedence?: number | null, numTasks: number, firmTaskThreadType: ConversationType, workHours?: string | null, agent: { __typename?: 'Contact', id: number, firstName?: string | null, lastName?: string | null, addressEmail?: string | null, addressPhone?: string | null, workHours: string, language?: Language | null } }>, leasingInfo?: { __typename?: 'LeasingInfo', buildingName?: string | null, meetingDirections?: string | null, selfGuidedMeetingDirections?: string | null, areAgentsOnsite?: boolean | null, officePhone?: string | null, acceptSection8?: boolean | null, tourTypes?: Array<TourType> | null, showingPolicy?: ShowingPolicy | null, section8Text?: string | null, applicationUrl?: string | null, propertyWebsite?: string | null, floorPlansUrl?: string | null, qualificationText?: string | null, petPolicyText?: string | null, moveInCostText?: string | null, discountsText?: string | null, applicationDocsText?: string | null, leaseTermsText?: string | null, cosignerPolicyText?: string | null, realtorText?: string | null, amenitiesText?: string | null, laundryText?: string | null, utilitiesText?: string | null, parkingText?: string | null, leasingSpecialsText?: string | null, handicappedUnitsText?: string | null, yardiPropertyCode?: string | null, propertyType?: LeasePropertyType | null, maxAcceptedPerShowing?: number | null, showingDurationMins?: number | null, isFurnished?: boolean | null, maxSimultaneousShowings?: number | null, leasingSpecials: Array<{ __typename?: 'LeasingSpecial', text: string, endDate?: string | null }> } | null }> } };

export type FirmPropertiesFragment = { __typename?: 'Firm', id: number, pmPropertiesWithoutTasks: Array<{ __typename?: 'PmProperty', id: string, displayName: string, auditKeyJson: string, jsonUrl: string, pmUrl: string, numUnits: number, numUnitsUnrented: number, cleanAddress?: string | null }> };

export type CreateTasksMutationVariables = Exact<{
  firmId: Scalars['Int'];
  pmItemKeyJsons: Array<Scalars['String']> | Scalars['String'];
  launchDate: Scalars['String'];
}>;


export type CreateTasksMutation = { __typename?: 'Mutation', createTasks: { __typename?: 'Firm', id: number, pmPropertiesWithoutTasks: Array<{ __typename?: 'PmProperty', id: string, displayName: string, auditKeyJson: string, jsonUrl: string, pmUrl: string, numUnits: number, numUnitsUnrented: number, cleanAddress?: string | null }> } };

export type CreateMergedTaskMutationVariables = Exact<{
  firmId: Scalars['Int'];
  pmItemKeyJsons: Array<Scalars['String']> | Scalars['String'];
  launchDate: Scalars['String'];
}>;


export type CreateMergedTaskMutation = { __typename?: 'Mutation', createMergedTask: { __typename?: 'Firm', id: number, pmPropertiesWithoutTasks: Array<{ __typename?: 'PmProperty', id: string, displayName: string, auditKeyJson: string, jsonUrl: string, pmUrl: string, numUnits: number, numUnitsUnrented: number, cleanAddress?: string | null }> } };

export type SavedActionWithTaskFragment = { __typename?: 'SavedAction', id: number, timeCreated: string, actionDisplayName: string, externalUserId?: string | null, description: string, user?: { __typename?: 'User', id: number, name: string } | null, task?: { __typename?: 'LeasingTask', id: number, displayName: string } | null };

export type SavedActionWithContactFragment = { __typename?: 'SavedAction', id: number, timeCreated: string, actionDisplayName: string, externalUserId?: string | null, description: string, user?: { __typename?: 'User', id: number, name: string } | null };

export type FetchLeasingTaskRecentActionsQueryVariables = Exact<{
  taskId: Scalars['Int'];
}>;


export type FetchLeasingTaskRecentActionsQuery = { __typename?: 'Query', task: { __typename?: 'LeasingTask', id: number, recentActions: Array<{ __typename?: 'SavedAction', id: number, timeCreated: string, actionDisplayName: string, externalUserId?: string | null, description: string, user?: { __typename?: 'User', id: number, name: string } | null }> } };

export type FetchAgentRecentActionsQueryVariables = Exact<{
  contactId: Scalars['Int'];
}>;


export type FetchAgentRecentActionsQuery = { __typename?: 'Query', contact: { __typename?: 'Contact', id: number, recentActions: Array<{ __typename?: 'SavedAction', id: number, timeCreated: string, actionDisplayName: string, externalUserId?: string | null, description: string, user?: { __typename?: 'User', id: number, name: string } | null, task?: { __typename?: 'LeasingTask', id: number, displayName: string } | null }> } };

export type AddressAutocompleteQueryVariables = Exact<{
  prefix: Scalars['String'];
}>;


export type AddressAutocompleteQuery = { __typename?: 'Query', addressAutocomplete: Array<string> };

export type FetchJobsQueryVariables = Exact<{
  jobKey: Scalars['String'];
}>;


export type FetchJobsQuery = { __typename?: 'Query', jobs: Array<{ __typename?: 'Job', id: string, jobName: JobName, jobKey: string, jobStatus: JobStatus, timeCreated: string, timeFinished?: string | null }> };

export type FetchNotesQueryVariables = Exact<{
  parentId: Scalars['Int'];
  type: ModelType;
}>;


export type FetchNotesQuery = { __typename?: 'Query', notes: Array<{ __typename?: 'Note', id: number, timeCreated: string, body: string, messageId?: number | null, threadId?: number | null, agentName?: string | null, author: { __typename?: 'User', id: number, name: string } }> };

export type UpdateNoteMutationVariables = Exact<{
  id: Scalars['Int'];
  body?: InputMaybe<Scalars['String']>;
}>;


export type UpdateNoteMutation = { __typename?: 'Mutation', updateNote?: { __typename?: 'Note', id: number, timeCreated: string, body: string, messageId?: number | null, threadId?: number | null, agentName?: string | null, author: { __typename?: 'User', id: number, name: string } } | null };

export type ClockOutUserMutationVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type ClockOutUserMutation = { __typename?: 'Mutation', setClockedIn: { __typename?: 'OperatorClockEvent', id: number, user: { __typename?: 'User', id: number } } };

export type SetAutoStationEnabledForUserMutationVariables = Exact<{
  userId: Scalars['Int'];
  enabled: Scalars['Boolean'];
}>;


export type SetAutoStationEnabledForUserMutation = { __typename?: 'Mutation', setAutoStationEnabledForUser: { __typename?: 'User', id: number, name: string } };

export type UpdateShowingMutationVariables = Exact<{
  showingId: Scalars['Int'];
  showingStatus: ShowingStatus;
}>;


export type UpdateShowingMutation = { __typename?: 'Mutation', updateShowing: { __typename?: 'LeasingTask', id: number } };

export type FetchLatestPmSyncJobQueryVariables = Exact<{
  firmId: Scalars['Int'];
  taskId?: InputMaybe<Scalars['Int']>;
}>;


export type FetchLatestPmSyncJobQuery = { __typename?: 'Query', latestPmSyncJob?: { __typename?: 'Job', id: string, timeCreated: string, pmTypeDisplayName?: string | null } | null };

export type FetchSearchQueryVariables = Exact<{
  prefix: Scalars['String'];
}>;


export type FetchSearchQuery = { __typename?: 'Query', search: Array<{ __typename?: 'SearchResult', type: SearchResultType, path: string, displayName: string, snippet: string, deemphasize: boolean, timeUpdated: string }> };

export type FetchThreadCalViewQueryVariables = Exact<{
  threadId: Scalars['Int'];
}>;


export type FetchThreadCalViewQuery = { __typename?: 'Query', thread: { __typename?: 'Thread', id: number, calView?: { __typename?: 'CalView', tzName: string, blocks: Array<{ __typename?: 'CalViewBlock', id: string, type: CalViewBlockType, dispDate: string, dispTime: string, snippet: string, showingConfStatus?: ConfirmationStatus | null, calRespStatus?: CalResponseStatus | null, calEvent?: { __typename?: 'CalEvent', id: string, timeCreated: string } | null, showing?: { __typename?: 'Showing', id: number, leasingTaskId: number } | null }> } | null } };

export type FetchTaskLinksQueryVariables = Exact<{
  contactId: Scalars['Int'];
}>;


export type FetchTaskLinksQuery = { __typename?: 'Query', contact: { __typename?: 'Contact', id: number, tasks: Array<{ __typename?: 'LeasingTask', id: number, displayName: string, isArchived: boolean, timeCreated: string, taskType: TaskType, leasingInfo?: { __typename?: 'LeasingInfo', propertyType?: LeasePropertyType | null } | null }> } };

export type FetchShowingHistoryQueryVariables = Exact<{
  showingId: Scalars['Int'];
}>;


export type FetchShowingHistoryQuery = { __typename?: 'Query', showing: { __typename?: 'Showing', id: number, history: Array<{ __typename?: 'ShowingContactHistory', timeUpdated: string, contactId: number, confirmationStatus: ConfirmationStatus, user?: { __typename?: 'User', id: number, name: string } | null }> } };

export type FetchArchivedTaskThreadsQueryVariables = Exact<{
  taskId: Scalars['Int'];
}>;


export type FetchArchivedTaskThreadsQuery = { __typename?: 'Query', task: { __typename?: 'LeasingTask', id: number, archivedThreads: Array<{ __typename?: 'Thread', id: number, timeCreated: string, messageType: MessageType, conversationType: ConversationType, isArchived: boolean, archiveUntil?: string | null, botStatus: ThreadBotStatus, addressUs: string, addressThem: string, lastMessageId: number, lastReadMessageId: number, lastInboundMessageId: number, lastMessageInbound: boolean, lastMessageTime?: string | null, sortTime: string, preferredTourType?: TourType | null, contactThem: { __typename?: 'Contact', id: number, firstName?: string | null, lastName?: string | null, addressEmail?: string | null, addressPhone?: string | null, workHours: string, language?: Language | null }, botThread?: { __typename?: 'BotThread', showCountdown: boolean, sendTime?: string | null } | null, recentActions: Array<{ __typename?: 'SavedAction', id: number, timeCreated: string, actionName?: ActionName | null, actionDisplayName: string, summary: string, user?: { __typename?: 'User', id: number, name: string } | null }> }> } };

export type FetchMessageDetailsQueryVariables = Exact<{
  messageId: Scalars['Int'];
}>;


export type FetchMessageDetailsQuery = { __typename?: 'Query', message: { __typename?: 'Message', messageDetails: string, id: number, timeCreated: string, addressFrom: string, addressTo: string, messageType: MessageType, messageStatus: MessageStatus, callStatus?: VoiceCallStatus | null, callStart?: string | null, callDuration?: number | null, isInbound: boolean, censoredShortBody: string, censoredTranslatedShortBody?: string | null, translatedEmailSubject?: string | null, emailSubject?: string | null, mediaUrl?: string | null, calEventId?: string | null, externalUrl?: string | null, errorMessage?: string | null, actionId?: number | null, actionUrl?: string | null, classification?: string | null, tags: Array<MessageTag>, outboundTags: Array<OutboundTag>, leasingAttributionSource?: string | null, messageLLMInfo?: Array<MessageTag> | null, annotations: Array<{ __typename?: 'MessageAnnotation', brainResultJson?: string | null, id: number, timeCreated: string, classification?: string | null, tags?: Array<MessageTag> | null, user?: { __typename?: 'User', id: number, userType: UserType, name: string } | null }>, author?: { __typename?: 'User', id: number, name: string } | null } };

export type AnnotateMessageMutationVariables = Exact<{
  messageId: Scalars['Int'];
  classification: Scalars['String'];
  tags: Array<MessageTag> | MessageTag;
}>;


export type AnnotateMessageMutation = { __typename?: 'Mutation', annotateMessage: { __typename?: 'Message', id: number, classification?: string | null, tags: Array<MessageTag> } };

export type FetchQuickActionsQueryVariables = Exact<{
  threadId: Scalars['Int'];
  prefix: Scalars['String'];
  maxResults: Scalars['Int'];
  resetCache: Scalars['Boolean'];
}>;


export type FetchQuickActionsQuery = { __typename?: 'Query', quickActions: Array<{ __typename?: 'QuickActionResult', displayName: string, snippet: string, body?: string | null, hasError: boolean, composerJson?: string | null, action?: { __typename?: 'Action', actionName: ActionName, preview: string, classification: string, sendQueue: SendQueue, commandJsons: Array<string>, uuid?: string | null, logSummary: string, hasArchiveCommand: boolean, hasSnoozeCommand: boolean, llmAction?: boolean | null, commandTypes: Array<CommandType>, commandPreviews: Array<string> } | null }> };

export type QuickActionResultFragment = { __typename?: 'QuickActionResult', displayName: string, snippet: string, body?: string | null, hasError: boolean, composerJson?: string | null, action?: { __typename?: 'Action', actionName: ActionName, preview: string, classification: string, sendQueue: SendQueue, commandJsons: Array<string>, uuid?: string | null, logSummary: string, hasArchiveCommand: boolean, hasSnoozeCommand: boolean, llmAction?: boolean | null, commandTypes: Array<CommandType>, commandPreviews: Array<string> } | null };

export type FetchActionQueryVariables = Exact<{
  savedActionId: Scalars['Int'];
}>;


export type FetchActionQuery = { __typename?: 'Query', action: { __typename?: 'Action', commandTypes: Array<CommandType>, commandPreviews: Array<string> } };

export type SendMessageMutationVariables = Exact<{
  threadId: Scalars['Int'];
  body: Scalars['String'];
  emailSubject?: InputMaybe<Scalars['String']>;
  mediaUrl?: InputMaybe<Scalars['String']>;
  isInbound?: InputMaybe<Scalars['Boolean']>;
  replyToMessageId?: InputMaybe<Scalars['Int']>;
  operatorResponseTimeMs?: InputMaybe<Scalars['Int']>;
  actionCount?: InputMaybe<Scalars['Int']>;
}>;


export type SendMessageMutation = { __typename?: 'Mutation', sendMessage: { __typename?: 'Thread', id: number, messageType: MessageType, conversationType: ConversationType, addressUs: string, addressThem: string, isArchived: boolean, archiveUntil?: string | null, botStatus: ThreadBotStatus, lastMessageId: number, lastReadMessageId: number, lastMessageInbound: boolean, unitTypesInterested: Array<UnitType>, moveInDate?: string | null, additionalOccupants?: number | null, leasingAttributionSource: LeasingAttributionSource, messagesWithLinks: { __typename?: 'MessagesWithLinks', waitingForShowing: boolean, messages: Array<{ __typename?: 'Message', id: number, timeCreated: string, addressFrom: string, addressTo: string, messageType: MessageType, messageStatus: MessageStatus, callStatus?: VoiceCallStatus | null, callStart?: string | null, callDuration?: number | null, isInbound: boolean, censoredShortBody: string, censoredTranslatedShortBody?: string | null, translatedEmailSubject?: string | null, emailSubject?: string | null, mediaUrl?: string | null, calEventId?: string | null, externalUrl?: string | null, errorMessage?: string | null, actionId?: number | null, actionUrl?: string | null, classification?: string | null, tags: Array<MessageTag>, outboundTags: Array<OutboundTag>, leasingAttributionSource?: string | null, messageLLMInfo?: Array<MessageTag> | null, author?: { __typename?: 'User', id: number, name: string } | null }>, messageLinks: Array<{ __typename?: 'MessageLink', phrase: string, link: { __typename: 'FloorPlanLink', leasingTask: { __typename?: 'LeasingTask', id: number, displayName: string } } | { __typename: 'LeasingTaskLink', leasingTask: { __typename?: 'LeasingTask', id: number, leasingInfo?: { __typename?: 'LeasingInfo', propertyType?: LeasePropertyType | null } | null } } }> }, botThread?: { __typename?: 'BotThread', sendTime?: string | null, showCountdown: boolean, action?: { __typename?: 'Action', actionName: ActionName, preview: string, classification: string, sendQueue: SendQueue, commandJsons: Array<string>, uuid?: string | null, logSummary: string, hasArchiveCommand: boolean, hasSnoozeCommand: boolean, llmAction?: boolean | null, commandTypes: Array<CommandType>, commandPreviews: Array<string> } | null } | null, contactThem: { __typename?: 'Contact', id: number, firstName?: string | null, lastName?: string | null, addressEmail?: string | null, addressPhone?: string | null, workHours: string, language?: Language | null }, calendar?: { __typename?: 'Cal', id: string, timeLastAccess?: string | null } | null } };

export type ReceiveCallMutationVariables = Exact<{
  threadId: Scalars['Int'];
}>;


export type ReceiveCallMutation = { __typename?: 'Mutation', receiveCall: { __typename?: 'Thread', id: number, messageType: MessageType, conversationType: ConversationType, addressUs: string, addressThem: string, isArchived: boolean, archiveUntil?: string | null, botStatus: ThreadBotStatus, lastMessageId: number, lastReadMessageId: number, lastMessageInbound: boolean, unitTypesInterested: Array<UnitType>, moveInDate?: string | null, additionalOccupants?: number | null, leasingAttributionSource: LeasingAttributionSource, messagesWithLinks: { __typename?: 'MessagesWithLinks', waitingForShowing: boolean, messages: Array<{ __typename?: 'Message', id: number, timeCreated: string, addressFrom: string, addressTo: string, messageType: MessageType, messageStatus: MessageStatus, callStatus?: VoiceCallStatus | null, callStart?: string | null, callDuration?: number | null, isInbound: boolean, censoredShortBody: string, censoredTranslatedShortBody?: string | null, translatedEmailSubject?: string | null, emailSubject?: string | null, mediaUrl?: string | null, calEventId?: string | null, externalUrl?: string | null, errorMessage?: string | null, actionId?: number | null, actionUrl?: string | null, classification?: string | null, tags: Array<MessageTag>, outboundTags: Array<OutboundTag>, leasingAttributionSource?: string | null, messageLLMInfo?: Array<MessageTag> | null, author?: { __typename?: 'User', id: number, name: string } | null }>, messageLinks: Array<{ __typename?: 'MessageLink', phrase: string, link: { __typename: 'FloorPlanLink', leasingTask: { __typename?: 'LeasingTask', id: number, displayName: string } } | { __typename: 'LeasingTaskLink', leasingTask: { __typename?: 'LeasingTask', id: number, leasingInfo?: { __typename?: 'LeasingInfo', propertyType?: LeasePropertyType | null } | null } } }> }, botThread?: { __typename?: 'BotThread', sendTime?: string | null, showCountdown: boolean, action?: { __typename?: 'Action', actionName: ActionName, preview: string, classification: string, sendQueue: SendQueue, commandJsons: Array<string>, uuid?: string | null, logSummary: string, hasArchiveCommand: boolean, hasSnoozeCommand: boolean, llmAction?: boolean | null, commandTypes: Array<CommandType>, commandPreviews: Array<string> } | null } | null, contactThem: { __typename?: 'Contact', id: number, firstName?: string | null, lastName?: string | null, addressEmail?: string | null, addressPhone?: string | null, workHours: string, language?: Language | null }, calendar?: { __typename?: 'Cal', id: string, timeLastAccess?: string | null } | null } };

export type SetThreadPreferredTourTypeMutationVariables = Exact<{
  threadId: Scalars['Int'];
  preferredTourType?: InputMaybe<TourType>;
}>;


export type SetThreadPreferredTourTypeMutation = { __typename?: 'Mutation', setThreadPreferredTourType: { __typename?: 'Thread', id: number, unitTypesInterested: Array<UnitType> } };

export type SetThreadUnitTypesMutationVariables = Exact<{
  threadId: Scalars['Int'];
  unitTypes: Array<UnitType> | UnitType;
}>;


export type SetThreadUnitTypesMutation = { __typename?: 'Mutation', setThreadUnitTypes: { __typename?: 'Thread', id: number, unitTypesInterested: Array<UnitType> } };

export type TaskUnitTypesQueryVariables = Exact<{
  taskId: Scalars['Int'];
}>;


export type TaskUnitTypesQuery = { __typename?: 'Query', task: { __typename?: 'LeasingTask', id: number, unitTypes: Array<UnitType>, unitTypesShowableOnAnyDate: Array<UnitType> } };

export type TaskAgentFragment = { __typename?: 'TaskAgent', id: string, firmTaskThreadType: ConversationType, onboardingRoles?: Array<string> | null, precedence?: number | null, workHours?: string | null, numTasks: number, isCurrentlyWorking?: boolean | null, agent: { __typename?: 'Contact', id: number, firstName?: string | null, lastName?: string | null, addressEmail?: string | null, addressPhone?: string | null, workHours: string, language?: Language | null } };

export type FetchTaskAgentsQueryVariables = Exact<{
  taskId: Scalars['Int'];
}>;


export type FetchTaskAgentsQuery = { __typename?: 'Query', task: { __typename?: 'LeasingTask', id: number, firmTaskId?: number | null, hasLaunched: boolean, taskType: TaskType, taskAgents: Array<{ __typename?: 'TaskAgent', id: string, firmTaskThreadType: ConversationType, onboardingRoles?: Array<string> | null, precedence?: number | null, workHours?: string | null, numTasks: number, isCurrentlyWorking?: boolean | null, agent: { __typename?: 'Contact', id: number, firstName?: string | null, lastName?: string | null, addressEmail?: string | null, addressPhone?: string | null, workHours: string, language?: Language | null } }> } };

export type FirmContactsQueryVariables = Exact<{
  firmId: Scalars['Int'];
}>;


export type FirmContactsQuery = { __typename?: 'Query', firm: { __typename?: 'Firm', id: number, emailThreadContacts: Array<{ __typename?: 'Contact', id: number, firstName?: string | null, lastName?: string | null, addressEmail?: string | null, addressPhone?: string | null, workHours: string, language?: Language | null }> } };

export type SaveTaskAgentMutationVariables = Exact<{
  taskId: Scalars['Int'];
  agentId: Scalars['Int'];
  precedence?: InputMaybe<Scalars['Int']>;
  workHours?: InputMaybe<Scalars['String']>;
  onboardingRoles?: InputMaybe<Scalars['String']>;
}>;


export type SaveTaskAgentMutation = { __typename?: 'Mutation', saveTaskAgent: { __typename?: 'LeasingTask', id: number, taskAgents: Array<{ __typename?: 'TaskAgent', id: string, firmTaskThreadType: ConversationType, onboardingRoles?: Array<string> | null, precedence?: number | null, workHours?: string | null, numTasks: number, isCurrentlyWorking?: boolean | null, agent: { __typename?: 'Contact', id: number, firstName?: string | null, lastName?: string | null, addressEmail?: string | null, addressPhone?: string | null, workHours: string, language?: Language | null } }> } };

export type DeleteTaskAgentMutationVariables = Exact<{
  taskId: Scalars['Int'];
  agentId: Scalars['Int'];
}>;


export type DeleteTaskAgentMutation = { __typename?: 'Mutation', deleteTaskAgent: { __typename?: 'LeasingTask', id: number, taskAgents: Array<{ __typename?: 'TaskAgent', id: string, firmTaskThreadType: ConversationType, onboardingRoles?: Array<string> | null, precedence?: number | null, workHours?: string | null, numTasks: number, isCurrentlyWorking?: boolean | null, agent: { __typename?: 'Contact', id: number, firstName?: string | null, lastName?: string | null, addressEmail?: string | null, addressPhone?: string | null, workHours: string, language?: Language | null } }> } };

export type TaskAvailFragment = { __typename?: 'LeasingTask', id: number, taskType: TaskType, isArchived: boolean, firm: { __typename?: 'Firm', id: number, firmName: string }, address?: { __typename?: 'Address', id: number, today: string } | null, floorPlans: Array<{ __typename?: 'FloorPlan', bedrooms?: number | null, bathrooms?: number | null, sqft?: number | null, name?: string | null, description?: string | null, minRentUSD?: number | null, maxRentUSD?: number | null, num: number, numShowable: number, availableOn?: string | null, showableOn?: string | null }>, pmItemKeys: Array<{ __typename?: 'PmItemKey', externalPmUrl?: string | null, pmType: string, firm: string, property: string }> };

export type FetchAvailabilityQueryVariables = Exact<{
  taskId: Scalars['Int'];
}>;


export type FetchAvailabilityQuery = { __typename?: 'Query', task: { __typename?: 'LeasingTask', id: number, taskType: TaskType, isArchived: boolean, firm: { __typename?: 'Firm', id: number, firmName: string }, address?: { __typename?: 'Address', id: number, today: string } | null, floorPlans: Array<{ __typename?: 'FloorPlan', bedrooms?: number | null, bathrooms?: number | null, sqft?: number | null, name?: string | null, description?: string | null, minRentUSD?: number | null, maxRentUSD?: number | null, num: number, numShowable: number, availableOn?: string | null, showableOn?: string | null }>, pmItemKeys: Array<{ __typename?: 'PmItemKey', externalPmUrl?: string | null, pmType: string, firm: string, property: string }> } };

export type UnlinkTaskMutationVariables = Exact<{
  taskId: Scalars['Int'];
}>;


export type UnlinkTaskMutation = { __typename?: 'Mutation', unlinkTask: { __typename?: 'LeasingTask', id: number, taskType: TaskType, isArchived: boolean, firm: { __typename?: 'Firm', id: number, firmName: string }, address?: { __typename?: 'Address', id: number, today: string } | null, floorPlans: Array<{ __typename?: 'FloorPlan', bedrooms?: number | null, bathrooms?: number | null, sqft?: number | null, name?: string | null, description?: string | null, minRentUSD?: number | null, maxRentUSD?: number | null, num: number, numShowable: number, availableOn?: string | null, showableOn?: string | null }>, pmItemKeys: Array<{ __typename?: 'PmItemKey', externalPmUrl?: string | null, pmType: string, firm: string, property: string }> } };

export type FetchEndpointsQueryVariables = Exact<{
  taskId: Scalars['Int'];
  released?: InputMaybe<Scalars['Boolean']>;
}>;


export type FetchEndpointsQuery = { __typename?: 'Query', task: { __typename?: 'LeasingTask', id: number, displayName: string, endpoints: Array<{ __typename?: 'Endpoint', id: number, addr?: string | null, releasedAddr?: string | null, leasingAttributionSource: LeasingAttributionSource, lastInboundTimestamp?: string | null, lastOutboundTimestamp?: string | null }> } };

export type CreateEndpointMutationVariables = Exact<{
  taskId: Scalars['Int'];
  leasingAttributionSource?: InputMaybe<LeasingAttributionSource>;
  addr?: InputMaybe<Scalars['String']>;
}>;


export type CreateEndpointMutation = { __typename?: 'Mutation', createEndpoint: { __typename?: 'LeasingTask', id: number, addressEmail?: string | null, addressPhone?: string | null, isArchived: boolean, endpoints: Array<{ __typename?: 'Endpoint', id: number, addr?: string | null, releasedAddr?: string | null, leasingAttributionSource: LeasingAttributionSource, lastInboundTimestamp?: string | null, lastOutboundTimestamp?: string | null }> } };

export type DeleteEndpointMutationVariables = Exact<{
  id: Scalars['Int'];
  taskId: Scalars['Int'];
}>;


export type DeleteEndpointMutation = { __typename?: 'Mutation', deleteEndpoint: { __typename?: 'LeasingTask', id: number, addressEmail?: string | null, addressPhone?: string | null, isArchived: boolean, endpoints: Array<{ __typename?: 'Endpoint', id: number, addr?: string | null, releasedAddr?: string | null, leasingAttributionSource: LeasingAttributionSource, lastInboundTimestamp?: string | null, lastOutboundTimestamp?: string | null }> } };

export type FetchFeatureFlagsQueryVariables = Exact<{
  firmId: Scalars['Int'];
}>;


export type FetchFeatureFlagsQuery = { __typename?: 'Query', featureFlags: Array<{ __typename?: 'FeatureFlag', featureName: FeatureName, enabled: boolean, description: string }> };

export type EnableFeatureFlagMutationVariables = Exact<{
  featureName: Scalars['String'];
  firmId: Scalars['Int'];
  firmTaskId: Scalars['Int'];
}>;


export type EnableFeatureFlagMutation = { __typename?: 'Mutation', enableFeatureFlag: { __typename?: 'FeatureFlag', featureName: FeatureName, firmId: number, enabled: boolean } };

export type DisableFeatureFlagMutationVariables = Exact<{
  featureName: Scalars['String'];
  firmId: Scalars['Int'];
  firmTaskId: Scalars['Int'];
}>;


export type DisableFeatureFlagMutation = { __typename?: 'Mutation', disableFeatureFlag: { __typename?: 'FeatureFlag', featureName: FeatureName, firmId: number, enabled: boolean } };

export type PmUnitFragment = { __typename?: 'PmPostableUnit', id: string, suggestedPostAction: SuggestedPostAction, latestJobs: Array<{ __typename?: 'Job', id: string, jobName: JobName, jobKey: string, jobStatus: JobStatus, timeCreated: string, timeFinished?: string | null }>, unit: { __typename?: 'PmUnit', displayName: string, auditKeyJson: string, status: UnitStatus, bedrooms?: number | null, bathrooms?: number | null, sqft?: number | null, minRentUSD?: number | null, maxRentUSD?: number | null, isPosted?: boolean | null, marketingTitle?: string | null, marketingDescription?: string | null, photoUrls: Array<string>, pmUrl: string } };

export type PmCampaignInfoFragment = { __typename?: 'PmCampaign', id: string, auditKeyJson: string, bedrooms?: number | null, bathrooms?: number | null, sqft?: number | null, minRentUSD?: number | null, maxRentUSD?: number | null, isPosted?: boolean | null, marketingTitle?: string | null, marketingDescription?: string | null, availableOnDate?: string | null };

export type FetchTaskMarketingQueryVariables = Exact<{
  taskId: Scalars['Int'];
}>;


export type FetchTaskMarketingQuery = { __typename?: 'Query', task: { __typename?: 'LeasingTask', id: number, pmUnits: Array<{ __typename?: 'PmPostableUnit', id: string, suggestedPostAction: SuggestedPostAction, latestJobs: Array<{ __typename?: 'Job', id: string, jobName: JobName, jobKey: string, jobStatus: JobStatus, timeCreated: string, timeFinished?: string | null }>, unit: { __typename?: 'PmUnit', displayName: string, auditKeyJson: string, status: UnitStatus, bedrooms?: number | null, bathrooms?: number | null, sqft?: number | null, minRentUSD?: number | null, maxRentUSD?: number | null, isPosted?: boolean | null, marketingTitle?: string | null, marketingDescription?: string | null, photoUrls: Array<string>, pmUrl: string } }>, pmCampaigns: Array<{ __typename?: 'PmCampaign', id: string, auditKeyJson: string, bedrooms?: number | null, bathrooms?: number | null, sqft?: number | null, minRentUSD?: number | null, maxRentUSD?: number | null, isPosted?: boolean | null, marketingTitle?: string | null, marketingDescription?: string | null, availableOnDate?: string | null }> } };

export type PostUnitMutationVariables = Exact<{
  jobName: PostJobName;
  auditKeyJson: Scalars['String'];
}>;


export type PostUnitMutation = { __typename?: 'Mutation', postUnit: { __typename?: 'LeasingTask', id: number, pmUnits: Array<{ __typename?: 'PmPostableUnit', id: string, suggestedPostAction: SuggestedPostAction, latestJobs: Array<{ __typename?: 'Job', id: string, jobName: JobName, jobKey: string, jobStatus: JobStatus, timeCreated: string, timeFinished?: string | null }>, unit: { __typename?: 'PmUnit', displayName: string, auditKeyJson: string, status: UnitStatus, bedrooms?: number | null, bathrooms?: number | null, sqft?: number | null, minRentUSD?: number | null, maxRentUSD?: number | null, isPosted?: boolean | null, marketingTitle?: string | null, marketingDescription?: string | null, photoUrls: Array<string>, pmUrl: string } }> } };

export type CreateThreadMutationVariables = Exact<{
  addressUs: Scalars['String'];
  addressThem: Scalars['String'];
}>;


export type CreateThreadMutation = { __typename?: 'Mutation', createThread: { __typename?: 'Thread', id: number } };

export type FetchTaskChartsQueryVariables = Exact<{
  tsName: TimeseriesName;
  firmId?: InputMaybe<Scalars['Int']>;
  taskId?: InputMaybe<Scalars['Int']>;
}>;


export type FetchTaskChartsQuery = { __typename?: 'Query', timeseries: Array<{ __typename?: 'SeriesPoint', date: string, value: number }> };

export type FetchTasksQueryVariables = Exact<{
  firmId: Scalars['Int'];
  fetchArchived: Scalars['Boolean'];
}>;


export type FetchTasksQuery = { __typename?: 'Query', firm: { __typename?: 'Firm', id: number, tasks: Array<{ __typename?: 'LeasingTask', id: number, displayName: string, isArchived: boolean, timeCreated: string, launchDate?: string | null, offboardDate?: string | null, taskType: TaskType, leasingInfo?: { __typename?: 'LeasingInfo', propertyType?: LeasePropertyType | null } | null }> } };

export type FetchPropertiesQueryVariables = Exact<{
  firmId: Scalars['Int'];
}>;


export type FetchPropertiesQuery = { __typename?: 'Query', firm: { __typename?: 'Firm', id: number, pmPropertiesWithoutTasks: Array<{ __typename?: 'PmProperty', id: string, displayName: string, auditKeyJson: string, jsonUrl: string, pmUrl: string, numUnits: number, numUnitsUnrented: number, cleanAddress?: string | null }> } };
